!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Popper = e();
}(this, function() {
    "use strict";
    function t(t) {
        return t && "[object Function]" === {}.toString.call(t);
    }
    function e(t, e) {
        if (1 !== t.nodeType) return [];
        var i = window.getComputedStyle(t, null);
        return e ? i[e] : i;
    }
    function i(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }
    function n(t) {
        if (!t || -1 !== [ "HTML", "BODY", "#document" ].indexOf(t.nodeName)) return window.document.body;
        var o = e(t), s = o.overflow, r = o.overflowX, a = o.overflowY;
        return /(auto|scroll)/.test(s + a + r) ? t : n(i(t));
    }
    function o(t) {
        var i = t && t.offsetParent, n = i && i.nodeName;
        return n && "BODY" !== n && "HTML" !== n ? -1 !== [ "TD", "TABLE" ].indexOf(i.nodeName) && "static" === e(i, "position") ? o(i) : i : window.document.documentElement;
    }
    function s(t) {
        return null === t.parentNode ? t : s(t.parentNode);
    }
    function r(t, e) {
        if (!(t && t.nodeType && e && e.nodeType)) return window.document.documentElement;
        var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, n = i ? t : e, a = i ? e : t, l = document.createRange();
        l.setStart(n, 0), l.setEnd(a, 0);
        var c = l.commonAncestorContainer;
        if (t !== c && e !== c || n.contains(a)) return function(t) {
            var e = t.nodeName;
            return "BODY" !== e && ("HTML" === e || o(t.firstElementChild) === t);
        }(c) ? c : o(c);
        var d = s(t);
        return d.host ? r(d.host, e) : r(t, s(e).host);
    }
    function a(t) {
        var e = "top" === (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft", i = t.nodeName;
        if ("BODY" === i || "HTML" === i) {
            var n = window.document.documentElement;
            return (window.document.scrollingElement || n)[e];
        }
        return t[e];
    }
    function l(t, e) {
        var i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], n = a(e, "top"), o = a(e, "left"), s = i ? -1 : 1;
        return t.top += n * s, t.bottom += n * s, t.left += o * s, t.right += o * s, t;
    }
    function c(t, e) {
        var i = "x" === e ? "Left" : "Top", n = "Left" == i ? "Right" : "Bottom";
        return +t["border" + i + "Width"].split("px")[0] + +t["border" + n + "Width"].split("px")[0];
    }
    function d(t, e, i, n) {
        return z(e["offset" + t], e["scroll" + t], i["client" + t], i["offset" + t], i["scroll" + t], q() ? i["offset" + t] + n["margin" + ("Height" === t ? "Top" : "Left")] + n["margin" + ("Height" === t ? "Bottom" : "Right")] : 0);
    }
    function u() {
        var t = window.document.body, e = window.document.documentElement, i = q() && window.getComputedStyle(e);
        return {
            height: d("Height", t, e, i),
            width: d("Width", t, e, i)
        };
    }
    function h(t) {
        return V({}, t, {
            right: t.left + t.width,
            bottom: t.top + t.height
        });
    }
    function p(t) {
        var i = {};
        if (q()) try {
            i = t.getBoundingClientRect();
            var n = a(t, "top"), o = a(t, "left");
            i.top += n, i.left += o, i.bottom += n, i.right += o;
        } catch (t) {} else i = t.getBoundingClientRect();
        var s = {
            left: i.left,
            top: i.top,
            width: i.right - i.left,
            height: i.bottom - i.top
        }, r = "HTML" === t.nodeName ? u() : {}, l = r.width || t.clientWidth || s.right - s.left, d = r.height || t.clientHeight || s.bottom - s.top, p = t.offsetWidth - l, f = t.offsetHeight - d;
        if (p || f) {
            var g = e(t);
            p -= c(g, "x"), f -= c(g, "y"), s.width -= p, s.height -= f;
        }
        return h(s);
    }
    function f(t, i) {
        var o = q(), s = "HTML" === i.nodeName, r = p(t), a = p(i), c = n(t), d = e(i), u = +d.borderTopWidth.split("px")[0], f = +d.borderLeftWidth.split("px")[0], g = h({
            top: r.top - a.top - u,
            left: r.left - a.left - f,
            width: r.width,
            height: r.height
        });
        if (g.marginTop = 0, g.marginLeft = 0, !o && s) {
            var m = +d.marginTop.split("px")[0], v = +d.marginLeft.split("px")[0];
            g.top -= u - m, g.bottom -= u - m, g.left -= f - v, g.right -= f - v, g.marginTop = m, 
            g.marginLeft = v;
        }
        return (o ? i.contains(c) : i === c && "BODY" !== c.nodeName) && (g = l(g, i)), 
        g;
    }
    function g(t) {
        var e = window.document.documentElement, i = f(t, e), n = z(e.clientWidth, window.innerWidth || 0), o = z(e.clientHeight, window.innerHeight || 0), s = a(e), r = a(e, "left");
        return h({
            top: s - i.top + i.marginTop,
            left: r - i.left + i.marginLeft,
            width: n,
            height: o
        });
    }
    function m(t) {
        var n = t.nodeName;
        return "BODY" !== n && "HTML" !== n && ("fixed" === e(t, "position") || m(i(t)));
    }
    function v(t, e, o, s) {
        var a = {
            top: 0,
            left: 0
        }, l = r(t, e);
        if ("viewport" === s) a = g(l); else {
            var c;
            "scrollParent" === s ? "BODY" === (c = n(i(t))).nodeName && (c = window.document.documentElement) : c = "window" === s ? window.document.documentElement : s;
            var d = f(c, l);
            if ("HTML" !== c.nodeName || m(l)) a = d; else {
                var h = u(), p = h.height, v = h.width;
                a.top += d.top - d.marginTop, a.bottom = p + d.top, a.left += d.left - d.marginLeft, 
                a.right = v + d.left;
            }
        }
        return a.left += o, a.top += o, a.right -= o, a.bottom -= o, a;
    }
    function y(t) {
        return t.width * t.height;
    }
    function b(t, e, i, n, o) {
        var s = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === t.indexOf("auto")) return t;
        var r = v(i, n, s, o), a = {
            top: {
                width: r.width,
                height: e.top - r.top
            },
            right: {
                width: r.right - e.right,
                height: r.height
            },
            bottom: {
                width: r.width,
                height: r.bottom - e.bottom
            },
            left: {
                width: e.left - r.left,
                height: r.height
            }
        }, l = Object.keys(a).map(function(t) {
            return V({
                key: t
            }, a[t], {
                area: y(a[t])
            });
        }).sort(function(t, e) {
            return e.area - t.area;
        }), c = l.filter(function(t) {
            var e = t.width, n = t.height;
            return e >= i.clientWidth && n >= i.clientHeight;
        }), d = 0 < c.length ? c[0].key : l[0].key, u = t.split("-")[1];
        return d + (u ? "-" + u : "");
    }
    function S(t, e, i) {
        return f(i, r(e, i));
    }
    function w(t) {
        var e = window.getComputedStyle(t), i = parseFloat(e.marginTop) + parseFloat(e.marginBottom), n = parseFloat(e.marginLeft) + parseFloat(e.marginRight);
        return {
            width: t.offsetWidth + n,
            height: t.offsetHeight + i
        };
    }
    function _(t) {
        var e = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return t.replace(/left|right|bottom|top/g, function(t) {
            return e[t];
        });
    }
    function T(t, e, i) {
        i = i.split("-")[0];
        var n = w(t), o = {
            width: n.width,
            height: n.height
        }, s = -1 !== [ "right", "left" ].indexOf(i), r = s ? "top" : "left", a = s ? "left" : "top", l = s ? "height" : "width", c = s ? "width" : "height";
        return o[r] = e[r] + e[l] / 2 - n[l] / 2, o[a] = i === a ? e[a] - n[c] : e[_(a)], 
        o;
    }
    function C(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }
    function x(e, i, n) {
        return (void 0 === n ? e : e.slice(0, function(t, e, i) {
            if (Array.prototype.findIndex) return t.findIndex(function(t) {
                return t[e] === i;
            });
            var n = C(t, function(t) {
                return t[e] === i;
            });
            return t.indexOf(n);
        }(e, "name", n))).forEach(function(e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = e.function || e.fn;
            e.enabled && t(n) && (i.offsets.popper = h(i.offsets.popper), i.offsets.reference = h(i.offsets.reference), 
            i = n(i, e));
        }), i;
    }
    function E(t, e) {
        return t.some(function(t) {
            var i = t.name;
            return t.enabled && i === e;
        });
    }
    function k(t) {
        for (var e = [ !1, "ms", "Webkit", "Moz", "O" ], i = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < e.length - 1; n++) {
            var o = e[n], s = o ? "" + o + i : t;
            if (void 0 !== window.document.body.style[s]) return s;
        }
        return null;
    }
    function I(t, e, i, o) {
        i.updateBound = o, window.addEventListener("resize", i.updateBound, {
            passive: !0
        });
        var s = n(t);
        return function t(e, i, o, s) {
            var r = "BODY" === e.nodeName, a = r ? window : e;
            a.addEventListener(i, o, {
                passive: !0
            }), r || t(n(a.parentNode), i, o, s), s.push(a);
        }(s, "scroll", i.updateBound, i.scrollParents), i.scrollElement = s, i.eventsEnabled = !0, 
        i;
    }
    function A() {
        var t;
        this.state.eventsEnabled && (window.cancelAnimationFrame(this.scheduleUpdate), this.state = (this.reference, 
        t = this.state, window.removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(e) {
            e.removeEventListener("scroll", t.updateBound);
        }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, 
        t));
    }
    function $(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }
    function O(t, e) {
        Object.keys(e).forEach(function(i) {
            var n = "";
            -1 !== [ "width", "height", "top", "right", "bottom", "left" ].indexOf(i) && $(e[i]) && (n = "px"), 
            t.style[i] = e[i] + n;
        });
    }
    function P(t, e, i) {
        var n = C(t, function(t) {
            return t.name === e;
        }), o = !!n && t.some(function(t) {
            return t.name === i && t.enabled && t.order < n.order;
        });
        if (!o) {
            var s = "`" + e + "`";
            console.warn("`" + i + "` modifier is required by " + s + " modifier in order to work, be sure to include it before " + s + "!");
        }
        return o;
    }
    function D(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1], i = G.indexOf(t), n = G.slice(i + 1).concat(G.slice(0, i));
        return e ? n.reverse() : n;
    }
    function L(t, e, i, n) {
        var o = [ 0, 0 ], s = -1 !== [ "right", "left" ].indexOf(n), r = t.split(/(\+|\-)/).map(function(t) {
            return t.trim();
        }), a = r.indexOf(C(r, function(t) {
            return -1 !== t.search(/,|\s/);
        }));
        r[a] && -1 === r[a].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/, c = -1 === a ? [ r ] : [ r.slice(0, a).concat([ r[a].split(l)[0] ]), [ r[a].split(l)[1] ].concat(r.slice(a + 1)) ];
        return (c = c.map(function(t, n) {
            var o = (1 === n ? !s : s) ? "height" : "width", r = !1;
            return t.reduce(function(t, e) {
                return "" === t[t.length - 1] && -1 !== [ "+", "-" ].indexOf(e) ? (t[t.length - 1] = e, 
                r = !0, t) : r ? (t[t.length - 1] += e, r = !1, t) : t.concat(e);
            }, []).map(function(t) {
                return function(t, e, i, n) {
                    var o = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), s = +o[1], r = o[2];
                    if (!s) return t;
                    if (0 === r.indexOf("%")) {
                        var a;
                        switch (r) {
                          case "%p":
                            a = i;
                            break;

                          case "%":
                          case "%r":
                          default:
                            a = n;
                        }
                        return h(a)[e] / 100 * s;
                    }
                    return "vh" === r || "vw" === r ? ("vh" === r ? z(document.documentElement.clientHeight, window.innerHeight || 0) : z(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * s : s;
                }(t, o, e, i);
            });
        })).forEach(function(t, e) {
            t.forEach(function(i, n) {
                $(i) && (o[e] += i * ("-" === t[n - 1] ? -1 : 1));
            });
        }), o;
    }
    for (var H = Math.min, N = Math.floor, z = Math.max, M = [ "native code", "[object MutationObserverConstructor]" ], j = "undefined" != typeof window, R = [ "Edge", "Trident", "Firefox" ], W = 0, F = 0; F < R.length; F += 1) if (j && 0 <= navigator.userAgent.indexOf(R[F])) {
        W = 1;
        break;
    }
    var B, U = j && function(t) {
        return M.some(function(e) {
            return -1 < (t || "").toString().indexOf(e);
        });
    }(window.MutationObserver) ? function(t) {
        var e = !1, i = 0, n = document.createElement("span");
        return new MutationObserver(function() {
            t(), e = !1;
        }).observe(n, {
            attributes: !0
        }), function() {
            e || (e = !0, n.setAttribute("x-index", i), ++i);
        };
    } : function(t) {
        var e = !1;
        return function() {
            e || (e = !0, setTimeout(function() {
                e = !1, t();
            }, W));
        };
    }, q = function() {
        return null == B && (B = -1 !== navigator.appVersion.indexOf("MSIE 10")), B;
    }, Y = function(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }, Q = function() {
        function t(t, e) {
            for (var i, n = 0; n < e.length; n++) (i = e[n]).enumerable = i.enumerable || !1, 
            i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
        return function(e, i, n) {
            return i && t(e.prototype, i), n && t(e, n), e;
        };
    }(), X = function(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i, t;
    }, V = Object.assign || function(t) {
        for (var e, i = 1; i < arguments.length; i++) for (var n in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t;
    }, K = [ "auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start" ], G = K.slice(3), Z = "flip", J = "clockwise", tt = "counterclockwise", et = function() {
        function e(i, n) {
            var o = this, s = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            Y(this, e), this.scheduleUpdate = function() {
                return requestAnimationFrame(o.update);
            }, this.update = U(this.update.bind(this)), this.options = V({}, e.Defaults, s), 
            this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            }, this.reference = i.jquery ? i[0] : i, this.popper = n.jquery ? n[0] : n, this.options.modifiers = {}, 
            Object.keys(V({}, e.Defaults.modifiers, s.modifiers)).forEach(function(t) {
                o.options.modifiers[t] = V({}, e.Defaults.modifiers[t] || {}, s.modifiers ? s.modifiers[t] : {});
            }), this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                return V({
                    name: t
                }, o.options.modifiers[t]);
            }).sort(function(t, e) {
                return t.order - e.order;
            }), this.modifiers.forEach(function(e) {
                e.enabled && t(e.onLoad) && e.onLoad(o.reference, o.popper, o.options, e, o.state);
            }), this.update();
            var r = this.options.eventsEnabled;
            r && this.enableEventListeners(), this.state.eventsEnabled = r;
        }
        return Q(e, [ {
            key: "update",
            value: function() {
                return function() {
                    if (!this.state.isDestroyed) {
                        var t = {
                            instance: this,
                            styles: {},
                            arrowStyles: {},
                            attributes: {},
                            flipped: !1,
                            offsets: {}
                        };
                        t.offsets.reference = S(this.state, this.popper, this.reference), t.placement = b(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), 
                        t.originalPlacement = t.placement, t.offsets.popper = T(this.popper, t.offsets.reference, t.placement), 
                        t.offsets.popper.position = "absolute", t = x(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, 
                        this.options.onCreate(t));
                    }
                }.call(this);
            }
        }, {
            key: "destroy",
            value: function() {
                return function() {
                    return this.state.isDestroyed = !0, E(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), 
                    this.popper.style.left = "", this.popper.style.position = "", this.popper.style.top = "", 
                    this.popper.style[k("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), 
                    this;
                }.call(this);
            }
        }, {
            key: "enableEventListeners",
            value: function() {
                return function() {
                    this.state.eventsEnabled || (this.state = I(this.reference, this.options, this.state, this.scheduleUpdate));
                }.call(this);
            }
        }, {
            key: "disableEventListeners",
            value: function() {
                return A.call(this);
            }
        } ]), e;
    }();
    return et.Utils = ("undefined" == typeof window ? global : window).PopperUtils, 
    et.placements = K, et.Defaults = {
        placement: "bottom",
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(t) {
                    var e = t.placement, i = e.split("-")[0], n = e.split("-")[1];
                    if (n) {
                        var o = t.offsets, s = o.reference, r = o.popper, a = -1 !== [ "bottom", "top" ].indexOf(i), l = a ? "left" : "top", c = a ? "width" : "height", d = {
                            start: X({}, l, s[l]),
                            end: X({}, l, s[l] + s[c] - r[c])
                        };
                        t.offsets.popper = V({}, r, d[n]);
                    }
                    return t;
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: function(t, e) {
                    var i, n = e.offset, o = t.placement, s = t.offsets, r = s.popper, a = s.reference, l = o.split("-")[0];
                    return i = $(+n) ? [ +n, 0 ] : L(n, r, a, l), "left" === l ? (r.top += i[0], r.left -= i[1]) : "right" === l ? (r.top += i[0], 
                    r.left += i[1]) : "top" === l ? (r.left += i[0], r.top -= i[1]) : "bottom" === l && (r.left += i[0], 
                    r.top += i[1]), t.popper = r, t;
                },
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(t, e) {
                    var i = e.boundariesElement || o(t.instance.popper);
                    t.instance.reference === i && (i = o(i));
                    var n = v(t.instance.popper, t.instance.reference, e.padding, i);
                    e.boundaries = n;
                    var s = e.priority, r = t.offsets.popper, a = {
                        primary: function(t) {
                            var i = r[t];
                            return r[t] < n[t] && !e.escapeWithReference && (i = z(r[t], n[t])), X({}, t, i);
                        },
                        secondary: function(t) {
                            var i = "right" === t ? "left" : "top", o = r[i];
                            return r[t] > n[t] && !e.escapeWithReference && (o = H(r[i], n[t] - ("right" === t ? r.width : r.height))), 
                            X({}, i, o);
                        }
                    };
                    return s.forEach(function(t) {
                        var e = -1 === [ "left", "top" ].indexOf(t) ? "secondary" : "primary";
                        r = V({}, r, a[e](t));
                    }), t.offsets.popper = r, t;
                },
                priority: [ "left", "right", "top", "bottom" ],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(t) {
                    var e = t.offsets, i = e.popper, n = e.reference, o = t.placement.split("-")[0], s = N, r = -1 !== [ "top", "bottom" ].indexOf(o), a = r ? "right" : "bottom", l = r ? "left" : "top", c = r ? "width" : "height";
                    return i[a] < s(n[l]) && (t.offsets.popper[l] = s(n[l]) - i[c]), i[l] > s(n[a]) && (t.offsets.popper[l] = s(n[a])), 
                    t;
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(t, i) {
                    if (!P(t.instance.modifiers, "arrow", "keepTogether")) return t;
                    var n = i.element;
                    if ("string" == typeof n) {
                        if (!(n = t.instance.popper.querySelector(n))) return t;
                    } else if (!t.instance.popper.contains(n)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), 
                    t;
                    var o = t.placement.split("-")[0], s = t.offsets, r = s.popper, a = s.reference, l = -1 !== [ "left", "right" ].indexOf(o), c = l ? "height" : "width", d = l ? "Top" : "Left", u = d.toLowerCase(), p = l ? "left" : "top", f = l ? "bottom" : "right", g = w(n)[c];
                    a[f] - g < r[u] && (t.offsets.popper[u] -= r[u] - (a[f] - g)), a[u] + g > r[f] && (t.offsets.popper[u] += a[u] + g - r[f]);
                    var m = a[u] + a[c] / 2 - g / 2, v = e(t.instance.popper, "margin" + d).replace("px", ""), y = m - h(t.offsets.popper)[u] - v;
                    return y = z(H(r[c] - g, y), 0), t.arrowElement = n, t.offsets.arrow = {}, t.offsets.arrow[u] = Math.round(y), 
                    t.offsets.arrow[p] = "", t;
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(t, e) {
                    if (E(t.instance.modifiers, "inner")) return t;
                    if (t.flipped && t.placement === t.originalPlacement) return t;
                    var i = v(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement), n = t.placement.split("-")[0], o = _(n), s = t.placement.split("-")[1] || "", r = [];
                    switch (e.behavior) {
                      case Z:
                        r = [ n, o ];
                        break;

                      case J:
                        r = D(n);
                        break;

                      case tt:
                        r = D(n, !0);
                        break;

                      default:
                        r = e.behavior;
                    }
                    return r.forEach(function(a, l) {
                        if (n !== a || r.length === l + 1) return t;
                        n = t.placement.split("-")[0], o = _(n);
                        var c = t.offsets.popper, d = t.offsets.reference, u = N, h = "left" === n && u(c.right) > u(d.left) || "right" === n && u(c.left) < u(d.right) || "top" === n && u(c.bottom) > u(d.top) || "bottom" === n && u(c.top) < u(d.bottom), p = u(c.left) < u(i.left), f = u(c.right) > u(i.right), g = u(c.top) < u(i.top), m = u(c.bottom) > u(i.bottom), v = "left" === n && p || "right" === n && f || "top" === n && g || "bottom" === n && m, y = -1 !== [ "top", "bottom" ].indexOf(n), b = !!e.flipVariations && (y && "start" === s && p || y && "end" === s && f || !y && "start" === s && g || !y && "end" === s && m);
                        (h || v || b) && (t.flipped = !0, (h || v) && (n = r[l + 1]), b && (s = function(t) {
                            return "end" === t ? "start" : "start" === t ? "end" : t;
                        }(s)), t.placement = n + (s ? "-" + s : ""), t.offsets.popper = V({}, t.offsets.popper, T(t.instance.popper, t.offsets.reference, t.placement)), 
                        t = x(t.instance.modifiers, t, "flip"));
                    }), t;
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport"
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(t) {
                    var e = t.placement, i = e.split("-")[0], n = t.offsets, o = n.popper, s = n.reference, r = -1 !== [ "left", "right" ].indexOf(i), a = -1 === [ "top", "left" ].indexOf(i);
                    return o[r ? "left" : "top"] = s[i] - (a ? o[r ? "width" : "height"] : 0), t.placement = _(e), 
                    t.offsets.popper = h(o), t;
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(t) {
                    if (!P(t.instance.modifiers, "hide", "preventOverflow")) return t;
                    var e = t.offsets.reference, i = C(t.instance.modifiers, function(t) {
                        return "preventOverflow" === t.name;
                    }).boundaries;
                    if (e.bottom < i.top || e.left > i.right || e.top > i.bottom || e.right < i.left) {
                        if (!0 === t.hide) return t;
                        t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
                    } else {
                        if (!1 === t.hide) return t;
                        t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
                    }
                    return t;
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(t, e) {
                    var i = e.x, n = e.y, s = t.offsets.popper, r = C(t.instance.modifiers, function(t) {
                        return "applyStyle" === t.name;
                    }).gpuAcceleration;
                    void 0 !== r && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var a, l, c = void 0 === r ? e.gpuAcceleration : r, d = p(o(t.instance.popper)), u = {
                        position: s.position
                    }, h = {
                        left: N(s.left),
                        top: N(s.top),
                        bottom: N(s.bottom),
                        right: N(s.right)
                    }, f = "bottom" === i ? "top" : "bottom", g = "right" === n ? "left" : "right", m = k("transform");
                    if (l = "bottom" == f ? -d.height + h.bottom : h.top, a = "right" == g ? -d.width + h.right : h.left, 
                    c && m) u[m] = "translate3d(" + a + "px, " + l + "px, 0)", u[f] = 0, u[g] = 0, u.willChange = "transform"; else {
                        var v = "bottom" == f ? -1 : 1, y = "right" == g ? -1 : 1;
                        u[f] = l * v, u[g] = a * y, u.willChange = f + ", " + g;
                    }
                    var b = {
                        "x-placement": t.placement
                    };
                    return t.attributes = V({}, b, t.attributes), t.styles = V({}, u, t.styles), t.arrowStyles = V({}, t.offsets.arrow, t.arrowStyles), 
                    t;
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(t) {
                    return O(t.instance.popper, t.styles), function(t, e) {
                        Object.keys(e).forEach(function(i) {
                            !1 === e[i] ? t.removeAttribute(i) : t.setAttribute(i, e[i]);
                        });
                    }(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && O(t.arrowElement, t.arrowStyles), 
                    t;
                },
                onLoad: function(t, e, i, n, o) {
                    var s = S(0, e, t), r = b(i.placement, s, e, t, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
                    return e.setAttribute("x-placement", r), O(e, {
                        position: "absolute"
                    }), i;
                },
                gpuAcceleration: void 0
            }
        }
    }, et;
}), function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e(exports, require("jquery"), require("popper.js")) : "function" == typeof define && define.amd ? define([ "exports", "jquery", "popper.js" ], e) : e(t.bootstrap = {}, t.jQuery, t.Popper);
}(this, function(t, e, i) {
    "use strict";
    function n(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
            Object.defineProperty(t, n.key, n);
        }
    }
    function o(t, e, i) {
        return e && n(t.prototype, e), i && n(t, i), t;
    }
    function s() {
        return (s = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
            }
            return t;
        }).apply(this, arguments);
    }
    e = e && e.hasOwnProperty("default") ? e.default : e, i = i && i.hasOwnProperty("default") ? i.default : i;
    var r, a, l, c, d, u, h, p, f, g, m, v, y, b, S, w, _, T, C = function(t) {
        var e = !1;
        var i = {
            TRANSITION_END: "bsTransitionEnd",
            getUID: function(t) {
                do {
                    t += ~~(1e6 * Math.random());
                } while (document.getElementById(t));
                return t;
            },
            getSelectorFromElement: function(e) {
                var i, n = e.getAttribute("data-target");
                n && "#" !== n || (n = e.getAttribute("href") || ""), "#" === n.charAt(0) && (i = n, 
                n = i = "function" == typeof t.escapeSelector ? t.escapeSelector(i).substr(1) : i.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1"));
                try {
                    return t(document).find(n).length > 0 ? n : null;
                } catch (t) {
                    return null;
                }
            },
            reflow: function(t) {
                return t.offsetHeight;
            },
            triggerTransitionEnd: function(i) {
                t(i).trigger(e.end);
            },
            supportsTransitionEnd: function() {
                return Boolean(e);
            },
            isElement: function(t) {
                return (t[0] || t).nodeType;
            },
            typeCheckConfig: function(t, e, n) {
                for (var o in n) if (Object.prototype.hasOwnProperty.call(n, o)) {
                    var s = n[o], r = e[o], a = r && i.isElement(r) ? "element" : (l = r, {}.toString.call(l).match(/\s([a-zA-Z]+)/)[1].toLowerCase());
                    if (!new RegExp(s).test(a)) throw new Error(t.toUpperCase() + ': Option "' + o + '" provided type "' + a + '" but expected type "' + s + '".');
                }
                var l;
            }
        };
        return e = ("undefined" == typeof window || !window.QUnit) && {
            end: "transitionend"
        }, t.fn.emulateTransitionEnd = function(e) {
            var n = this, o = !1;
            return t(this).one(i.TRANSITION_END, function() {
                o = !0;
            }), setTimeout(function() {
                o || i.triggerTransitionEnd(n);
            }, e), this;
        }, i.supportsTransitionEnd() && (t.event.special[i.TRANSITION_END] = {
            bindType: e.end,
            delegateType: e.end,
            handle: function(e) {
                if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
            }
        }), i;
    }(e), x = (a = "alert", c = "." + (l = "bs.alert"), d = (r = e).fn[a], u = {
        CLOSE: "close" + c,
        CLOSED: "closed" + c,
        CLICK_DATA_API: "click" + c + ".data-api"
    }, "alert", "fade", "show", h = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.close = function(t) {
            t = t || this._element;
            var e = this._getRootElement(t);
            this._triggerCloseEvent(e).isDefaultPrevented() || this._removeElement(e);
        }, e.dispose = function() {
            r.removeData(this._element, l), this._element = null;
        }, e._getRootElement = function(t) {
            var e = C.getSelectorFromElement(t), i = !1;
            return e && (i = r(e)[0]), i || (i = r(t).closest(".alert")[0]), i;
        }, e._triggerCloseEvent = function(t) {
            var e = r.Event(u.CLOSE);
            return r(t).trigger(e), e;
        }, e._removeElement = function(t) {
            var e = this;
            r(t).removeClass("show"), C.supportsTransitionEnd() && r(t).hasClass("fade") ? r(t).one(C.TRANSITION_END, function(i) {
                return e._destroyElement(t, i);
            }).emulateTransitionEnd(150) : this._destroyElement(t);
        }, e._destroyElement = function(t) {
            r(t).detach().trigger(u.CLOSED).remove();
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var i = r(this), n = i.data(l);
                n || (n = new t(this), i.data(l, n)), "close" === e && n[e](this);
            });
        }, t._handleDismiss = function(t) {
            return function(e) {
                e && e.preventDefault(), t.close(this);
            };
        }, o(t, null, [ {
            key: "VERSION",
            get: function() {
                return "4.0.0";
            }
        } ]), t;
    }(), r(document).on(u.CLICK_DATA_API, '[data-dismiss="alert"]', h._handleDismiss(new h())), 
    r.fn[a] = h._jQueryInterface, r.fn[a].Constructor = h, r.fn[a].noConflict = function() {
        return r.fn[a] = d, h._jQueryInterface;
    }, h), E = (f = "button", m = "." + (g = "bs.button"), v = ".data-api", y = (p = e).fn[f], 
    b = "active", "btn", "focus", S = '[data-toggle^="button"]', '[data-toggle="buttons"]', 
    "input", ".active", w = ".btn", _ = {
        CLICK_DATA_API: "click" + m + v,
        FOCUS_BLUR_DATA_API: "focus" + m + v + " blur" + m + v
    }, T = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.toggle = function() {
            var t = !0, e = !0, i = p(this._element).closest('[data-toggle="buttons"]')[0];
            if (i) {
                var n = p(this._element).find("input")[0];
                if (n) {
                    if ("radio" === n.type) if (n.checked && p(this._element).hasClass(b)) t = !1; else {
                        var o = p(i).find(".active")[0];
                        o && p(o).removeClass(b);
                    }
                    if (t) {
                        if (n.hasAttribute("disabled") || i.hasAttribute("disabled") || n.classList.contains("disabled") || i.classList.contains("disabled")) return;
                        n.checked = !p(this._element).hasClass(b), p(n).trigger("change");
                    }
                    n.focus(), e = !1;
                }
            }
            e && this._element.setAttribute("aria-pressed", !p(this._element).hasClass(b)), 
            t && p(this._element).toggleClass(b);
        }, e.dispose = function() {
            p.removeData(this._element, g), this._element = null;
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var i = p(this).data(g);
                i || (i = new t(this), p(this).data(g, i)), "toggle" === e && i[e]();
            });
        }, o(t, null, [ {
            key: "VERSION",
            get: function() {
                return "4.0.0";
            }
        } ]), t;
    }(), p(document).on(_.CLICK_DATA_API, S, function(t) {
        t.preventDefault();
        var e = t.target;
        p(e).hasClass("btn") || (e = p(e).closest(w)), T._jQueryInterface.call(p(e), "toggle");
    }).on(_.FOCUS_BLUR_DATA_API, S, function(t) {
        var e = p(t.target).closest(w)[0];
        p(e).toggleClass("focus", /^focus(in)?$/.test(t.type));
    }), p.fn[f] = T._jQueryInterface, p.fn[f].Constructor = T, p.fn[f].noConflict = function() {
        return p.fn[f] = y, T._jQueryInterface;
    }, T), k = function(t) {
        var e = "carousel", i = "bs.carousel", n = "." + i, r = t.fn[e], a = {
            interval: 5e3,
            keyboard: !0,
            slide: !1,
            pause: "hover",
            wrap: !0
        }, l = {
            interval: "(number|boolean)",
            keyboard: "boolean",
            slide: "(boolean|string)",
            pause: "(string|boolean)",
            wrap: "boolean"
        }, c = "next", d = "prev", u = {
            SLIDE: "slide" + n,
            SLID: "slid" + n,
            KEYDOWN: "keydown" + n,
            MOUSEENTER: "mouseenter" + n,
            MOUSELEAVE: "mouseleave" + n,
            TOUCHEND: "touchend" + n,
            LOAD_DATA_API: "load" + n + ".data-api",
            CLICK_DATA_API: "click" + n + ".data-api"
        }, h = "active", p = {
            ACTIVE: ".active",
            ACTIVE_ITEM: ".active.carousel-item",
            ITEM: ".carousel-item",
            NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
            INDICATORS: ".carousel-indicators",
            DATA_SLIDE: "[data-slide], [data-slide-to]",
            DATA_RIDE: '[data-ride="carousel"]'
        }, f = function() {
            function r(e, i) {
                this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, 
                this._isSliding = !1, this.touchTimeout = null, this._config = this._getConfig(i), 
                this._element = t(e)[0], this._indicatorsElement = t(this._element).find(p.INDICATORS)[0], 
                this._addEventListeners();
            }
            var f = r.prototype;
            return f.next = function() {
                this._isSliding || this._slide(c);
            }, f.nextWhenVisible = function() {
                !document.hidden && t(this._element).is(":visible") && "hidden" !== t(this._element).css("visibility") && this.next();
            }, f.prev = function() {
                this._isSliding || this._slide(d);
            }, f.pause = function(e) {
                e || (this._isPaused = !0), t(this._element).find(p.NEXT_PREV)[0] && C.supportsTransitionEnd() && (C.triggerTransitionEnd(this._element), 
                this.cycle(!0)), clearInterval(this._interval), this._interval = null;
            }, f.cycle = function(t) {
                t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), 
                this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval));
            }, f.to = function(e) {
                var i = this;
                this._activeElement = t(this._element).find(p.ACTIVE_ITEM)[0];
                var n = this._getItemIndex(this._activeElement);
                if (!(e > this._items.length - 1 || e < 0)) if (this._isSliding) t(this._element).one(u.SLID, function() {
                    return i.to(e);
                }); else {
                    if (n === e) return this.pause(), void this.cycle();
                    var o = e > n ? c : d;
                    this._slide(o, this._items[e]);
                }
            }, f.dispose = function() {
                t(this._element).off(n), t.removeData(this._element, i), this._items = null, this._config = null, 
                this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, 
                this._activeElement = null, this._indicatorsElement = null;
            }, f._getConfig = function(t) {
                return t = s({}, a, t), C.typeCheckConfig(e, t, l), t;
            }, f._addEventListeners = function() {
                var e = this;
                this._config.keyboard && t(this._element).on(u.KEYDOWN, function(t) {
                    return e._keydown(t);
                }), "hover" === this._config.pause && (t(this._element).on(u.MOUSEENTER, function(t) {
                    return e.pause(t);
                }).on(u.MOUSELEAVE, function(t) {
                    return e.cycle(t);
                }), "ontouchstart" in document.documentElement && t(this._element).on(u.TOUCHEND, function() {
                    e.pause(), e.touchTimeout && clearTimeout(e.touchTimeout), e.touchTimeout = setTimeout(function(t) {
                        return e.cycle(t);
                    }, 500 + e._config.interval);
                }));
            }, f._keydown = function(t) {
                if (!/input|textarea/i.test(t.target.tagName)) switch (t.which) {
                  case 37:
                    t.preventDefault(), this.prev();
                    break;

                  case 39:
                    t.preventDefault(), this.next();
                }
            }, f._getItemIndex = function(e) {
                return this._items = t.makeArray(t(e).parent().find(p.ITEM)), this._items.indexOf(e);
            }, f._getItemByDirection = function(t, e) {
                var i = t === c, n = t === d, o = this._getItemIndex(e), s = this._items.length - 1;
                if ((n && 0 === o || i && o === s) && !this._config.wrap) return e;
                var r = (o + (t === d ? -1 : 1)) % this._items.length;
                return -1 === r ? this._items[this._items.length - 1] : this._items[r];
            }, f._triggerSlideEvent = function(e, i) {
                var n = this._getItemIndex(e), o = this._getItemIndex(t(this._element).find(p.ACTIVE_ITEM)[0]), s = t.Event(u.SLIDE, {
                    relatedTarget: e,
                    direction: i,
                    from: o,
                    to: n
                });
                return t(this._element).trigger(s), s;
            }, f._setActiveIndicatorElement = function(e) {
                if (this._indicatorsElement) {
                    t(this._indicatorsElement).find(p.ACTIVE).removeClass(h);
                    var i = this._indicatorsElement.children[this._getItemIndex(e)];
                    i && t(i).addClass(h);
                }
            }, f._slide = function(e, i) {
                var n, o, s, r = this, a = t(this._element).find(p.ACTIVE_ITEM)[0], l = this._getItemIndex(a), d = i || a && this._getItemByDirection(e, a), f = this._getItemIndex(d), g = Boolean(this._interval);
                if (e === c ? (n = "carousel-item-left", o = "carousel-item-next", s = "left") : (n = "carousel-item-right", 
                o = "carousel-item-prev", s = "right"), d && t(d).hasClass(h)) this._isSliding = !1; else if (!this._triggerSlideEvent(d, s).isDefaultPrevented() && a && d) {
                    this._isSliding = !0, g && this.pause(), this._setActiveIndicatorElement(d);
                    var m = t.Event(u.SLID, {
                        relatedTarget: d,
                        direction: s,
                        from: l,
                        to: f
                    });
                    C.supportsTransitionEnd() && t(this._element).hasClass("slide") ? (t(d).addClass(o), 
                    C.reflow(d), t(a).addClass(n), t(d).addClass(n), t(a).one(C.TRANSITION_END, function() {
                        t(d).removeClass(n + " " + o).addClass(h), t(a).removeClass(h + " " + o + " " + n), 
                        r._isSliding = !1, setTimeout(function() {
                            return t(r._element).trigger(m);
                        }, 0);
                    }).emulateTransitionEnd(600)) : (t(a).removeClass(h), t(d).addClass(h), this._isSliding = !1, 
                    t(this._element).trigger(m)), g && this.cycle();
                }
            }, r._jQueryInterface = function(e) {
                return this.each(function() {
                    var n = t(this).data(i), o = s({}, a, t(this).data());
                    "object" == typeof e && (o = s({}, o, e));
                    var l = "string" == typeof e ? e : o.slide;
                    if (n || (n = new r(this, o), t(this).data(i, n)), "number" == typeof e) n.to(e); else if ("string" == typeof l) {
                        if (void 0 === n[l]) throw new TypeError('No method named "' + l + '"');
                        n[l]();
                    } else o.interval && (n.pause(), n.cycle());
                });
            }, r._dataApiClickHandler = function(e) {
                var n = C.getSelectorFromElement(this);
                if (n) {
                    var o = t(n)[0];
                    if (o && t(o).hasClass("carousel")) {
                        var a = s({}, t(o).data(), t(this).data()), l = this.getAttribute("data-slide-to");
                        l && (a.interval = !1), r._jQueryInterface.call(t(o), a), l && t(o).data(i).to(l), 
                        e.preventDefault();
                    }
                }
            }, o(r, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return a;
                }
            } ]), r;
        }();
        return t(document).on(u.CLICK_DATA_API, p.DATA_SLIDE, f._dataApiClickHandler), t(window).on(u.LOAD_DATA_API, function() {
            t(p.DATA_RIDE).each(function() {
                var e = t(this);
                f._jQueryInterface.call(e, e.data());
            });
        }), t.fn[e] = f._jQueryInterface, t.fn[e].Constructor = f, t.fn[e].noConflict = function() {
            return t.fn[e] = r, f._jQueryInterface;
        }, f;
    }(e), I = function(t) {
        var e = "collapse", i = "bs.collapse", n = "." + i, r = t.fn[e], a = {
            toggle: !0,
            parent: ""
        }, l = {
            toggle: "boolean",
            parent: "(string|element)"
        }, c = {
            SHOW: "show" + n,
            SHOWN: "shown" + n,
            HIDE: "hide" + n,
            HIDDEN: "hidden" + n,
            CLICK_DATA_API: "click" + n + ".data-api"
        }, d = "show", u = "collapse", h = "collapsing", p = "collapsed", f = "width", g = {
            ACTIVES: ".show, .collapsing",
            DATA_TOGGLE: '[data-toggle="collapse"]'
        }, m = function() {
            function n(e, i) {
                this._isTransitioning = !1, this._element = e, this._config = this._getConfig(i), 
                this._triggerArray = t.makeArray(t('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'));
                for (var n = t(g.DATA_TOGGLE), o = 0; o < n.length; o++) {
                    var s = n[o], r = C.getSelectorFromElement(s);
                    null !== r && t(r).filter(e).length > 0 && (this._selector = r, this._triggerArray.push(s));
                }
                this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), 
                this._config.toggle && this.toggle();
            }
            var r = n.prototype;
            return r.toggle = function() {
                t(this._element).hasClass(d) ? this.hide() : this.show();
            }, r.show = function() {
                var e, o, s = this;
                if (!(this._isTransitioning || t(this._element).hasClass(d) || (this._parent && 0 === (e = t.makeArray(t(this._parent).find(g.ACTIVES).filter('[data-parent="' + this._config.parent + '"]'))).length && (e = null), 
                e && (o = t(e).not(this._selector).data(i)) && o._isTransitioning))) {
                    var r = t.Event(c.SHOW);
                    if (t(this._element).trigger(r), !r.isDefaultPrevented()) {
                        e && (n._jQueryInterface.call(t(e).not(this._selector), "hide"), o || t(e).data(i, null));
                        var a = this._getDimension();
                        t(this._element).removeClass(u).addClass(h), this._element.style[a] = 0, this._triggerArray.length > 0 && t(this._triggerArray).removeClass(p).attr("aria-expanded", !0), 
                        this.setTransitioning(!0);
                        var l = function() {
                            t(s._element).removeClass(h).addClass(u).addClass(d), s._element.style[a] = "", 
                            s.setTransitioning(!1), t(s._element).trigger(c.SHOWN);
                        };
                        if (C.supportsTransitionEnd()) {
                            var f = "scroll" + (a[0].toUpperCase() + a.slice(1));
                            t(this._element).one(C.TRANSITION_END, l).emulateTransitionEnd(600), this._element.style[a] = this._element[f] + "px";
                        } else l();
                    }
                }
            }, r.hide = function() {
                var e = this;
                if (!this._isTransitioning && t(this._element).hasClass(d)) {
                    var i = t.Event(c.HIDE);
                    if (t(this._element).trigger(i), !i.isDefaultPrevented()) {
                        var n = this._getDimension();
                        if (this._element.style[n] = this._element.getBoundingClientRect()[n] + "px", C.reflow(this._element), 
                        t(this._element).addClass(h).removeClass(u).removeClass(d), this._triggerArray.length > 0) for (var o = 0; o < this._triggerArray.length; o++) {
                            var s = this._triggerArray[o], r = C.getSelectorFromElement(s);
                            null !== r && (t(r).hasClass(d) || t(s).addClass(p).attr("aria-expanded", !1));
                        }
                        this.setTransitioning(!0);
                        var a = function() {
                            e.setTransitioning(!1), t(e._element).removeClass(h).addClass(u).trigger(c.HIDDEN);
                        };
                        this._element.style[n] = "", C.supportsTransitionEnd() ? t(this._element).one(C.TRANSITION_END, a).emulateTransitionEnd(600) : a();
                    }
                }
            }, r.setTransitioning = function(t) {
                this._isTransitioning = t;
            }, r.dispose = function() {
                t.removeData(this._element, i), this._config = null, this._parent = null, this._element = null, 
                this._triggerArray = null, this._isTransitioning = null;
            }, r._getConfig = function(t) {
                return (t = s({}, a, t)).toggle = Boolean(t.toggle), C.typeCheckConfig(e, t, l), 
                t;
            }, r._getDimension = function() {
                return t(this._element).hasClass(f) ? f : "height";
            }, r._getParent = function() {
                var e = this, i = null;
                C.isElement(this._config.parent) ? (i = this._config.parent, void 0 !== this._config.parent.jquery && (i = this._config.parent[0])) : i = t(this._config.parent)[0];
                var o = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
                return t(i).find(o).each(function(t, i) {
                    e._addAriaAndCollapsedClass(n._getTargetFromElement(i), [ i ]);
                }), i;
            }, r._addAriaAndCollapsedClass = function(e, i) {
                if (e) {
                    var n = t(e).hasClass(d);
                    i.length > 0 && t(i).toggleClass(p, !n).attr("aria-expanded", n);
                }
            }, n._getTargetFromElement = function(e) {
                var i = C.getSelectorFromElement(e);
                return i ? t(i)[0] : null;
            }, n._jQueryInterface = function(e) {
                return this.each(function() {
                    var o = t(this), r = o.data(i), l = s({}, a, o.data(), "object" == typeof e && e);
                    if (!r && l.toggle && /show|hide/.test(e) && (l.toggle = !1), r || (r = new n(this, l), 
                    o.data(i, r)), "string" == typeof e) {
                        if (void 0 === r[e]) throw new TypeError('No method named "' + e + '"');
                        r[e]();
                    }
                });
            }, o(n, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return a;
                }
            } ]), n;
        }();
        return t(document).on(c.CLICK_DATA_API, g.DATA_TOGGLE, function(e) {
            "A" === e.currentTarget.tagName && e.preventDefault();
            var n = t(this), o = C.getSelectorFromElement(this);
            t(o).each(function() {
                var e = t(this), o = e.data(i) ? "toggle" : n.data();
                m._jQueryInterface.call(e, o);
            });
        }), t.fn[e] = m._jQueryInterface, t.fn[e].Constructor = m, t.fn[e].noConflict = function() {
            return t.fn[e] = r, m._jQueryInterface;
        }, m;
    }(e), A = function(t) {
        var e = "dropdown", n = "bs.dropdown", r = "." + n, a = ".data-api", l = t.fn[e], c = new RegExp("38|40|27"), d = {
            HIDE: "hide" + r,
            HIDDEN: "hidden" + r,
            SHOW: "show" + r,
            SHOWN: "shown" + r,
            CLICK: "click" + r,
            CLICK_DATA_API: "click" + r + a,
            KEYDOWN_DATA_API: "keydown" + r + a,
            KEYUP_DATA_API: "keyup" + r + a
        }, u = "disabled", h = "show", p = "dropup", f = "dropdown-menu-right", g = '[data-toggle="dropdown"]', m = ".dropdown-menu", v = {
            offset: 0,
            flip: !0,
            boundary: "scrollParent"
        }, y = {
            offset: "(number|string|function)",
            flip: "boolean",
            boundary: "(string|element)"
        }, b = function() {
            function a(t, e) {
                this._element = t, this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), 
                this._inNavbar = this._detectNavbar(), this._addEventListeners();
            }
            var l = a.prototype;
            return l.toggle = function() {
                if (!this._element.disabled && !t(this._element).hasClass(u)) {
                    var e = a._getParentFromElement(this._element), n = t(this._menu).hasClass(h);
                    if (a._clearMenus(), !n) {
                        var o = {
                            relatedTarget: this._element
                        }, s = t.Event(d.SHOW, o);
                        if (t(e).trigger(s), !s.isDefaultPrevented()) {
                            if (!this._inNavbar) {
                                if (void 0 === i) throw new TypeError("Bootstrap dropdown require Popper.js (https://popper.js.org)");
                                var r = this._element;
                                t(e).hasClass(p) && (t(this._menu).hasClass("dropdown-menu-left") || t(this._menu).hasClass(f)) && (r = e), 
                                "scrollParent" !== this._config.boundary && t(e).addClass("position-static"), this._popper = new i(r, this._menu, this._getPopperConfig());
                            }
                            "ontouchstart" in document.documentElement && 0 === t(e).closest(".navbar-nav").length && t("body").children().on("mouseover", null, t.noop), 
                            this._element.focus(), this._element.setAttribute("aria-expanded", !0), t(this._menu).toggleClass(h), 
                            t(e).toggleClass(h).trigger(t.Event(d.SHOWN, o));
                        }
                    }
                }
            }, l.dispose = function() {
                t.removeData(this._element, n), t(this._element).off(r), this._element = null, this._menu = null, 
                null !== this._popper && (this._popper.destroy(), this._popper = null);
            }, l.update = function() {
                this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate();
            }, l._addEventListeners = function() {
                var e = this;
                t(this._element).on(d.CLICK, function(t) {
                    t.preventDefault(), t.stopPropagation(), e.toggle();
                });
            }, l._getConfig = function(i) {
                return i = s({}, this.constructor.Default, t(this._element).data(), i), C.typeCheckConfig(e, i, this.constructor.DefaultType), 
                i;
            }, l._getMenuElement = function() {
                if (!this._menu) {
                    var e = a._getParentFromElement(this._element);
                    this._menu = t(e).find(m)[0];
                }
                return this._menu;
            }, l._getPlacement = function() {
                var e = t(this._element).parent(), i = "bottom-start";
                return e.hasClass(p) ? (i = "top-start", t(this._menu).hasClass(f) && (i = "top-end")) : e.hasClass("dropright") ? i = "right-start" : e.hasClass("dropleft") ? i = "left-start" : t(this._menu).hasClass(f) && (i = "bottom-end"), 
                i;
            }, l._detectNavbar = function() {
                return t(this._element).closest(".navbar").length > 0;
            }, l._getPopperConfig = function() {
                var t = this, e = {};
                return "function" == typeof this._config.offset ? e.fn = function(e) {
                    return e.offsets = s({}, e.offsets, t._config.offset(e.offsets) || {}), e;
                } : e.offset = this._config.offset, {
                    placement: this._getPlacement(),
                    modifiers: {
                        offset: e,
                        flip: {
                            enabled: this._config.flip
                        },
                        preventOverflow: {
                            boundariesElement: this._config.boundary
                        }
                    }
                };
            }, a._jQueryInterface = function(e) {
                return this.each(function() {
                    var i = t(this).data(n);
                    if (i || (i = new a(this, "object" == typeof e ? e : null), t(this).data(n, i)), 
                    "string" == typeof e) {
                        if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
                        i[e]();
                    }
                });
            }, a._clearMenus = function(e) {
                if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which)) for (var i = t.makeArray(t(g)), o = 0; o < i.length; o++) {
                    var s = a._getParentFromElement(i[o]), r = t(i[o]).data(n), l = {
                        relatedTarget: i[o]
                    };
                    if (r) {
                        var c = r._menu;
                        if (t(s).hasClass(h) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && t.contains(s, e.target))) {
                            var u = t.Event(d.HIDE, l);
                            t(s).trigger(u), u.isDefaultPrevented() || ("ontouchstart" in document.documentElement && t("body").children().off("mouseover", null, t.noop), 
                            i[o].setAttribute("aria-expanded", "false"), t(c).removeClass(h), t(s).removeClass(h).trigger(t.Event(d.HIDDEN, l)));
                        }
                    }
                }
            }, a._getParentFromElement = function(e) {
                var i, n = C.getSelectorFromElement(e);
                return n && (i = t(n)[0]), i || e.parentNode;
            }, a._dataApiKeydownHandler = function(e) {
                if ((/input|textarea/i.test(e.target.tagName) ? !(32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || t(e.target).closest(m).length)) : c.test(e.which)) && (e.preventDefault(), 
                e.stopPropagation(), !this.disabled && !t(this).hasClass(u))) {
                    var i = a._getParentFromElement(this), n = t(i).hasClass(h);
                    if ((n || 27 === e.which && 32 === e.which) && (!n || 27 !== e.which && 32 !== e.which)) {
                        var o = t(i).find(".dropdown-menu .dropdown-item:not(.disabled)").get();
                        if (0 !== o.length) {
                            var s = o.indexOf(e.target);
                            38 === e.which && s > 0 && s--, 40 === e.which && s < o.length - 1 && s++, s < 0 && (s = 0), 
                            o[s].focus();
                        }
                    } else {
                        if (27 === e.which) {
                            var r = t(i).find(g)[0];
                            t(r).trigger("focus");
                        }
                        t(this).trigger("click");
                    }
                }
            }, o(a, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return v;
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return y;
                }
            } ]), a;
        }();
        return t(document).on(d.KEYDOWN_DATA_API, g, b._dataApiKeydownHandler).on(d.KEYDOWN_DATA_API, m, b._dataApiKeydownHandler).on(d.CLICK_DATA_API + " " + d.KEYUP_DATA_API, b._clearMenus).on(d.CLICK_DATA_API, g, function(e) {
            e.preventDefault(), e.stopPropagation(), b._jQueryInterface.call(t(this), "toggle");
        }).on(d.CLICK_DATA_API, ".dropdown form", function(t) {
            t.stopPropagation();
        }), t.fn[e] = b._jQueryInterface, t.fn[e].Constructor = b, t.fn[e].noConflict = function() {
            return t.fn[e] = l, b._jQueryInterface;
        }, b;
    }(e), $ = function(t) {
        var e = "bs.modal", i = "." + e, n = t.fn.modal, r = {
            backdrop: !0,
            keyboard: !0,
            focus: !0,
            show: !0
        }, a = {
            backdrop: "(boolean|string)",
            keyboard: "boolean",
            focus: "boolean",
            show: "boolean"
        }, l = {
            HIDE: "hide" + i,
            HIDDEN: "hidden" + i,
            SHOW: "show" + i,
            SHOWN: "shown" + i,
            FOCUSIN: "focusin" + i,
            RESIZE: "resize" + i,
            CLICK_DISMISS: "click.dismiss" + i,
            KEYDOWN_DISMISS: "keydown.dismiss" + i,
            MOUSEUP_DISMISS: "mouseup.dismiss" + i,
            MOUSEDOWN_DISMISS: "mousedown.dismiss" + i,
            CLICK_DATA_API: "click" + i + ".data-api"
        }, c = "modal-open", d = "fade", u = "show", h = {
            DIALOG: ".modal-dialog",
            DATA_TOGGLE: '[data-toggle="modal"]',
            DATA_DISMISS: '[data-dismiss="modal"]',
            FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
            STICKY_CONTENT: ".sticky-top",
            NAVBAR_TOGGLER: ".navbar-toggler"
        }, p = function() {
            function n(e, i) {
                this._config = this._getConfig(i), this._element = e, this._dialog = t(e).find(h.DIALOG)[0], 
                this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, 
                this._originalBodyPadding = 0, this._scrollbarWidth = 0;
            }
            var p = n.prototype;
            return p.toggle = function(t) {
                return this._isShown ? this.hide() : this.show(t);
            }, p.show = function(e) {
                var i = this;
                if (!this._isTransitioning && !this._isShown) {
                    C.supportsTransitionEnd() && t(this._element).hasClass(d) && (this._isTransitioning = !0);
                    var n = t.Event(l.SHOW, {
                        relatedTarget: e
                    });
                    t(this._element).trigger(n), this._isShown || n.isDefaultPrevented() || (this._isShown = !0, 
                    this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), t(document.body).addClass(c), 
                    this._setEscapeEvent(), this._setResizeEvent(), t(this._element).on(l.CLICK_DISMISS, h.DATA_DISMISS, function(t) {
                        return i.hide(t);
                    }), t(this._dialog).on(l.MOUSEDOWN_DISMISS, function() {
                        t(i._element).one(l.MOUSEUP_DISMISS, function(e) {
                            t(e.target).is(i._element) && (i._ignoreBackdropClick = !0);
                        });
                    }), this._showBackdrop(function() {
                        return i._showElement(e);
                    }));
                }
            }, p.hide = function(e) {
                var i = this;
                if (e && e.preventDefault(), !this._isTransitioning && this._isShown) {
                    var n = t.Event(l.HIDE);
                    if (t(this._element).trigger(n), this._isShown && !n.isDefaultPrevented()) {
                        this._isShown = !1;
                        var o = C.supportsTransitionEnd() && t(this._element).hasClass(d);
                        o && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), 
                        t(document).off(l.FOCUSIN), t(this._element).removeClass(u), t(this._element).off(l.CLICK_DISMISS), 
                        t(this._dialog).off(l.MOUSEDOWN_DISMISS), o ? t(this._element).one(C.TRANSITION_END, function(t) {
                            return i._hideModal(t);
                        }).emulateTransitionEnd(300) : this._hideModal();
                    }
                }
            }, p.dispose = function() {
                t.removeData(this._element, e), t(window, document, this._element, this._backdrop).off(i), 
                this._config = null, this._element = null, this._dialog = null, this._backdrop = null, 
                this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, 
                this._scrollbarWidth = null;
            }, p.handleUpdate = function() {
                this._adjustDialog();
            }, p._getConfig = function(t) {
                return t = s({}, r, t), C.typeCheckConfig("modal", t, a), t;
            }, p._showElement = function(e) {
                var i = this, n = C.supportsTransitionEnd() && t(this._element).hasClass(d);
                this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), 
                this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), 
                this._element.scrollTop = 0, n && C.reflow(this._element), t(this._element).addClass(u), 
                this._config.focus && this._enforceFocus();
                var o = t.Event(l.SHOWN, {
                    relatedTarget: e
                }), s = function() {
                    i._config.focus && i._element.focus(), i._isTransitioning = !1, t(i._element).trigger(o);
                };
                n ? t(this._dialog).one(C.TRANSITION_END, s).emulateTransitionEnd(300) : s();
            }, p._enforceFocus = function() {
                var e = this;
                t(document).off(l.FOCUSIN).on(l.FOCUSIN, function(i) {
                    document !== i.target && e._element !== i.target && 0 === t(e._element).has(i.target).length && e._element.focus();
                });
            }, p._setEscapeEvent = function() {
                var e = this;
                this._isShown && this._config.keyboard ? t(this._element).on(l.KEYDOWN_DISMISS, function(t) {
                    27 === t.which && (t.preventDefault(), e.hide());
                }) : this._isShown || t(this._element).off(l.KEYDOWN_DISMISS);
            }, p._setResizeEvent = function() {
                var e = this;
                this._isShown ? t(window).on(l.RESIZE, function(t) {
                    return e.handleUpdate(t);
                }) : t(window).off(l.RESIZE);
            }, p._hideModal = function() {
                var e = this;
                this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), 
                this._isTransitioning = !1, this._showBackdrop(function() {
                    t(document.body).removeClass(c), e._resetAdjustments(), e._resetScrollbar(), t(e._element).trigger(l.HIDDEN);
                });
            }, p._removeBackdrop = function() {
                this._backdrop && (t(this._backdrop).remove(), this._backdrop = null);
            }, p._showBackdrop = function(e) {
                var i = this, n = t(this._element).hasClass(d) ? d : "";
                if (this._isShown && this._config.backdrop) {
                    var o = C.supportsTransitionEnd() && n;
                    if (this._backdrop = document.createElement("div"), this._backdrop.className = "modal-backdrop", 
                    n && t(this._backdrop).addClass(n), t(this._backdrop).appendTo(document.body), t(this._element).on(l.CLICK_DISMISS, function(t) {
                        i._ignoreBackdropClick ? i._ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" === i._config.backdrop ? i._element.focus() : i.hide());
                    }), o && C.reflow(this._backdrop), t(this._backdrop).addClass(u), !e) return;
                    if (!o) return void e();
                    t(this._backdrop).one(C.TRANSITION_END, e).emulateTransitionEnd(150);
                } else if (!this._isShown && this._backdrop) {
                    t(this._backdrop).removeClass(u);
                    var s = function() {
                        i._removeBackdrop(), e && e();
                    };
                    C.supportsTransitionEnd() && t(this._element).hasClass(d) ? t(this._backdrop).one(C.TRANSITION_END, s).emulateTransitionEnd(150) : s();
                } else e && e();
            }, p._adjustDialog = function() {
                var t = this._element.scrollHeight > document.documentElement.clientHeight;
                !this._isBodyOverflowing && t && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), 
                this._isBodyOverflowing && !t && (this._element.style.paddingRight = this._scrollbarWidth + "px");
            }, p._resetAdjustments = function() {
                this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
            }, p._checkScrollbar = function() {
                var t = document.body.getBoundingClientRect();
                this._isBodyOverflowing = t.left + t.right < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth();
            }, p._setScrollbar = function() {
                var e = this;
                if (this._isBodyOverflowing) {
                    t(h.FIXED_CONTENT).each(function(i, n) {
                        var o = t(n)[0].style.paddingRight, s = t(n).css("padding-right");
                        t(n).data("padding-right", o).css("padding-right", parseFloat(s) + e._scrollbarWidth + "px");
                    }), t(h.STICKY_CONTENT).each(function(i, n) {
                        var o = t(n)[0].style.marginRight, s = t(n).css("margin-right");
                        t(n).data("margin-right", o).css("margin-right", parseFloat(s) - e._scrollbarWidth + "px");
                    }), t(h.NAVBAR_TOGGLER).each(function(i, n) {
                        var o = t(n)[0].style.marginRight, s = t(n).css("margin-right");
                        t(n).data("margin-right", o).css("margin-right", parseFloat(s) + e._scrollbarWidth + "px");
                    });
                    var i = document.body.style.paddingRight, n = t("body").css("padding-right");
                    t("body").data("padding-right", i).css("padding-right", parseFloat(n) + this._scrollbarWidth + "px");
                }
            }, p._resetScrollbar = function() {
                t(h.FIXED_CONTENT).each(function(e, i) {
                    var n = t(i).data("padding-right");
                    void 0 !== n && t(i).css("padding-right", n).removeData("padding-right");
                }), t(h.STICKY_CONTENT + ", " + h.NAVBAR_TOGGLER).each(function(e, i) {
                    var n = t(i).data("margin-right");
                    void 0 !== n && t(i).css("margin-right", n).removeData("margin-right");
                });
                var e = t("body").data("padding-right");
                void 0 !== e && t("body").css("padding-right", e).removeData("padding-right");
            }, p._getScrollbarWidth = function() {
                var t = document.createElement("div");
                t.className = "modal-scrollbar-measure", document.body.appendChild(t);
                var e = t.getBoundingClientRect().width - t.clientWidth;
                return document.body.removeChild(t), e;
            }, n._jQueryInterface = function(i, o) {
                return this.each(function() {
                    var r = t(this).data(e), a = s({}, n.Default, t(this).data(), "object" == typeof i && i);
                    if (r || (r = new n(this, a), t(this).data(e, r)), "string" == typeof i) {
                        if (void 0 === r[i]) throw new TypeError('No method named "' + i + '"');
                        r[i](o);
                    } else a.show && r.show(o);
                });
            }, o(n, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return r;
                }
            } ]), n;
        }();
        return t(document).on(l.CLICK_DATA_API, h.DATA_TOGGLE, function(i) {
            var n, o = this, r = C.getSelectorFromElement(this);
            r && (n = t(r)[0]);
            var a = t(n).data(e) ? "toggle" : s({}, t(n).data(), t(this).data());
            "A" !== this.tagName && "AREA" !== this.tagName || i.preventDefault();
            var c = t(n).one(l.SHOW, function(e) {
                e.isDefaultPrevented() || c.one(l.HIDDEN, function() {
                    t(o).is(":visible") && o.focus();
                });
            });
            p._jQueryInterface.call(t(n), a, this);
        }), t.fn.modal = p._jQueryInterface, t.fn.modal.Constructor = p, t.fn.modal.noConflict = function() {
            return t.fn.modal = n, p._jQueryInterface;
        }, p;
    }(e), O = function(t) {
        var e = "tooltip", n = "bs.tooltip", r = "." + n, a = t.fn[e], l = new RegExp("(^|\\s)bs-tooltip\\S+", "g"), c = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "(number|string)",
            container: "(string|element|boolean)",
            fallbackPlacement: "(string|array)",
            boundary: "(string|element)"
        }, d = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left"
        }, u = {
            animation: !0,
            template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: !1,
            selector: !1,
            placement: "top",
            offset: 0,
            container: !1,
            fallbackPlacement: "flip",
            boundary: "scrollParent"
        }, h = "show", p = "out", f = {
            HIDE: "hide" + r,
            HIDDEN: "hidden" + r,
            SHOW: "show" + r,
            SHOWN: "shown" + r,
            INSERTED: "inserted" + r,
            CLICK: "click" + r,
            FOCUSIN: "focusin" + r,
            FOCUSOUT: "focusout" + r,
            MOUSEENTER: "mouseenter" + r,
            MOUSELEAVE: "mouseleave" + r
        }, g = "fade", m = "show", v = "hover", y = "focus", b = function() {
            function a(t, e) {
                if (void 0 === i) throw new TypeError("Bootstrap tooltips require Popper.js (https://popper.js.org)");
                this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, 
                this._popper = null, this.element = t, this.config = this._getConfig(e), this.tip = null, 
                this._setListeners();
            }
            var b = a.prototype;
            return b.enable = function() {
                this._isEnabled = !0;
            }, b.disable = function() {
                this._isEnabled = !1;
            }, b.toggleEnabled = function() {
                this._isEnabled = !this._isEnabled;
            }, b.toggle = function(e) {
                if (this._isEnabled) if (e) {
                    var i = this.constructor.DATA_KEY, n = t(e.currentTarget).data(i);
                    n || (n = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(i, n)), 
                    n._activeTrigger.click = !n._activeTrigger.click, n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n);
                } else {
                    if (t(this.getTipElement()).hasClass(m)) return void this._leave(null, this);
                    this._enter(null, this);
                }
            }, b.dispose = function() {
                clearTimeout(this._timeout), t.removeData(this.element, this.constructor.DATA_KEY), 
                t(this.element).off(this.constructor.EVENT_KEY), t(this.element).closest(".modal").off("hide.bs.modal"), 
                this.tip && t(this.tip).remove(), this._isEnabled = null, this._timeout = null, 
                this._hoverState = null, this._activeTrigger = null, null !== this._popper && this._popper.destroy(), 
                this._popper = null, this.element = null, this.config = null, this.tip = null;
            }, b.show = function() {
                var e = this;
                if ("none" === t(this.element).css("display")) throw new Error("Please use show on visible elements");
                var n = t.Event(this.constructor.Event.SHOW);
                if (this.isWithContent() && this._isEnabled) {
                    t(this.element).trigger(n);
                    var o = t.contains(this.element.ownerDocument.documentElement, this.element);
                    if (n.isDefaultPrevented() || !o) return;
                    var s = this.getTipElement(), r = C.getUID(this.constructor.NAME);
                    s.setAttribute("id", r), this.element.setAttribute("aria-describedby", r), this.setContent(), 
                    this.config.animation && t(s).addClass(g);
                    var l = "function" == typeof this.config.placement ? this.config.placement.call(this, s, this.element) : this.config.placement, c = this._getAttachment(l);
                    this.addAttachmentClass(c);
                    var d = !1 === this.config.container ? document.body : t(this.config.container);
                    t(s).data(this.constructor.DATA_KEY, this), t.contains(this.element.ownerDocument.documentElement, this.tip) || t(s).appendTo(d), 
                    t(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new i(this.element, s, {
                        placement: c,
                        modifiers: {
                            offset: {
                                offset: this.config.offset
                            },
                            flip: {
                                behavior: this.config.fallbackPlacement
                            },
                            arrow: {
                                element: ".arrow"
                            },
                            preventOverflow: {
                                boundariesElement: this.config.boundary
                            }
                        },
                        onCreate: function(t) {
                            t.originalPlacement !== t.placement && e._handlePopperPlacementChange(t);
                        },
                        onUpdate: function(t) {
                            e._handlePopperPlacementChange(t);
                        }
                    }), t(s).addClass(m), "ontouchstart" in document.documentElement && t("body").children().on("mouseover", null, t.noop);
                    var u = function() {
                        e.config.animation && e._fixTransition();
                        var i = e._hoverState;
                        e._hoverState = null, t(e.element).trigger(e.constructor.Event.SHOWN), i === p && e._leave(null, e);
                    };
                    C.supportsTransitionEnd() && t(this.tip).hasClass(g) ? t(this.tip).one(C.TRANSITION_END, u).emulateTransitionEnd(a._TRANSITION_DURATION) : u();
                }
            }, b.hide = function(e) {
                var i = this, n = this.getTipElement(), o = t.Event(this.constructor.Event.HIDE), s = function() {
                    i._hoverState !== h && n.parentNode && n.parentNode.removeChild(n), i._cleanTipClass(), 
                    i.element.removeAttribute("aria-describedby"), t(i.element).trigger(i.constructor.Event.HIDDEN), 
                    null !== i._popper && i._popper.destroy(), e && e();
                };
                t(this.element).trigger(o), o.isDefaultPrevented() || (t(n).removeClass(m), "ontouchstart" in document.documentElement && t("body").children().off("mouseover", null, t.noop), 
                this._activeTrigger.click = !1, this._activeTrigger[y] = !1, this._activeTrigger[v] = !1, 
                C.supportsTransitionEnd() && t(this.tip).hasClass(g) ? t(n).one(C.TRANSITION_END, s).emulateTransitionEnd(150) : s(), 
                this._hoverState = "");
            }, b.update = function() {
                null !== this._popper && this._popper.scheduleUpdate();
            }, b.isWithContent = function() {
                return Boolean(this.getTitle());
            }, b.addAttachmentClass = function(e) {
                t(this.getTipElement()).addClass("bs-tooltip-" + e);
            }, b.getTipElement = function() {
                return this.tip = this.tip || t(this.config.template)[0], this.tip;
            }, b.setContent = function() {
                var e = t(this.getTipElement());
                this.setElementContent(e.find(".tooltip-inner"), this.getTitle()), e.removeClass(g + " " + m);
            }, b.setElementContent = function(e, i) {
                var n = this.config.html;
                "object" == typeof i && (i.nodeType || i.jquery) ? n ? t(i).parent().is(e) || e.empty().append(i) : e.text(t(i).text()) : e[n ? "html" : "text"](i);
            }, b.getTitle = function() {
                var t = this.element.getAttribute("data-original-title");
                return t || (t = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), 
                t;
            }, b._getAttachment = function(t) {
                return d[t.toUpperCase()];
            }, b._setListeners = function() {
                var e = this;
                this.config.trigger.split(" ").forEach(function(i) {
                    if ("click" === i) t(e.element).on(e.constructor.Event.CLICK, e.config.selector, function(t) {
                        return e.toggle(t);
                    }); else if ("manual" !== i) {
                        var n = i === v ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN, o = i === v ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                        t(e.element).on(n, e.config.selector, function(t) {
                            return e._enter(t);
                        }).on(o, e.config.selector, function(t) {
                            return e._leave(t);
                        });
                    }
                    t(e.element).closest(".modal").on("hide.bs.modal", function() {
                        return e.hide();
                    });
                }), this.config.selector ? this.config = s({}, this.config, {
                    trigger: "manual",
                    selector: ""
                }) : this._fixTitle();
            }, b._fixTitle = function() {
                var t = typeof this.element.getAttribute("data-original-title");
                (this.element.getAttribute("title") || "string" !== t) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), 
                this.element.setAttribute("title", ""));
            }, b._enter = function(e, i) {
                var n = this.constructor.DATA_KEY;
                (i = i || t(e.currentTarget).data(n)) || (i = new this.constructor(e.currentTarget, this._getDelegateConfig()), 
                t(e.currentTarget).data(n, i)), e && (i._activeTrigger["focusin" === e.type ? y : v] = !0), 
                t(i.getTipElement()).hasClass(m) || i._hoverState === h ? i._hoverState = h : (clearTimeout(i._timeout), 
                i._hoverState = h, i.config.delay && i.config.delay.show ? i._timeout = setTimeout(function() {
                    i._hoverState === h && i.show();
                }, i.config.delay.show) : i.show());
            }, b._leave = function(e, i) {
                var n = this.constructor.DATA_KEY;
                (i = i || t(e.currentTarget).data(n)) || (i = new this.constructor(e.currentTarget, this._getDelegateConfig()), 
                t(e.currentTarget).data(n, i)), e && (i._activeTrigger["focusout" === e.type ? y : v] = !1), 
                i._isWithActiveTrigger() || (clearTimeout(i._timeout), i._hoverState = p, i.config.delay && i.config.delay.hide ? i._timeout = setTimeout(function() {
                    i._hoverState === p && i.hide();
                }, i.config.delay.hide) : i.hide());
            }, b._isWithActiveTrigger = function() {
                for (var t in this._activeTrigger) if (this._activeTrigger[t]) return !0;
                return !1;
            }, b._getConfig = function(i) {
                return "number" == typeof (i = s({}, this.constructor.Default, t(this.element).data(), i)).delay && (i.delay = {
                    show: i.delay,
                    hide: i.delay
                }), "number" == typeof i.title && (i.title = i.title.toString()), "number" == typeof i.content && (i.content = i.content.toString()), 
                C.typeCheckConfig(e, i, this.constructor.DefaultType), i;
            }, b._getDelegateConfig = function() {
                var t = {};
                if (this.config) for (var e in this.config) this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
                return t;
            }, b._cleanTipClass = function() {
                var e = t(this.getTipElement()), i = e.attr("class").match(l);
                null !== i && i.length > 0 && e.removeClass(i.join(""));
            }, b._handlePopperPlacementChange = function(t) {
                this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement));
            }, b._fixTransition = function() {
                var e = this.getTipElement(), i = this.config.animation;
                null === e.getAttribute("x-placement") && (t(e).removeClass(g), this.config.animation = !1, 
                this.hide(), this.show(), this.config.animation = i);
            }, a._jQueryInterface = function(e) {
                return this.each(function() {
                    var i = t(this).data(n), o = "object" == typeof e && e;
                    if ((i || !/dispose|hide/.test(e)) && (i || (i = new a(this, o), t(this).data(n, i)), 
                    "string" == typeof e)) {
                        if (void 0 === i[e]) throw new TypeError('No method named "' + e + '"');
                        i[e]();
                    }
                });
            }, o(a, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return u;
                }
            }, {
                key: "NAME",
                get: function() {
                    return e;
                }
            }, {
                key: "DATA_KEY",
                get: function() {
                    return n;
                }
            }, {
                key: "Event",
                get: function() {
                    return f;
                }
            }, {
                key: "EVENT_KEY",
                get: function() {
                    return r;
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return c;
                }
            } ]), a;
        }();
        return t.fn[e] = b._jQueryInterface, t.fn[e].Constructor = b, t.fn[e].noConflict = function() {
            return t.fn[e] = a, b._jQueryInterface;
        }, b;
    }(e), P = function(t) {
        var e = "popover", i = "bs.popover", n = "." + i, r = t.fn[e], a = new RegExp("(^|\\s)bs-popover\\S+", "g"), l = s({}, O.Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        }), c = s({}, O.DefaultType, {
            content: "(string|element|function)"
        }), d = {
            HIDE: "hide" + n,
            HIDDEN: "hidden" + n,
            SHOW: "show" + n,
            SHOWN: "shown" + n,
            INSERTED: "inserted" + n,
            CLICK: "click" + n,
            FOCUSIN: "focusin" + n,
            FOCUSOUT: "focusout" + n,
            MOUSEENTER: "mouseenter" + n,
            MOUSELEAVE: "mouseleave" + n
        }, u = function(s) {
            var r, u;
            function h() {
                return s.apply(this, arguments) || this;
            }
            u = s, (r = h).prototype = Object.create(u.prototype), r.prototype.constructor = r, 
            r.__proto__ = u;
            var p = h.prototype;
            return p.isWithContent = function() {
                return this.getTitle() || this._getContent();
            }, p.addAttachmentClass = function(e) {
                t(this.getTipElement()).addClass("bs-popover-" + e);
            }, p.getTipElement = function() {
                return this.tip = this.tip || t(this.config.template)[0], this.tip;
            }, p.setContent = function() {
                var e = t(this.getTipElement());
                this.setElementContent(e.find(".popover-header"), this.getTitle());
                var i = this._getContent();
                "function" == typeof i && (i = i.call(this.element)), this.setElementContent(e.find(".popover-body"), i), 
                e.removeClass("fade show");
            }, p._getContent = function() {
                return this.element.getAttribute("data-content") || this.config.content;
            }, p._cleanTipClass = function() {
                var e = t(this.getTipElement()), i = e.attr("class").match(a);
                null !== i && i.length > 0 && e.removeClass(i.join(""));
            }, h._jQueryInterface = function(e) {
                return this.each(function() {
                    var n = t(this).data(i), o = "object" == typeof e ? e : null;
                    if ((n || !/destroy|hide/.test(e)) && (n || (n = new h(this, o), t(this).data(i, n)), 
                    "string" == typeof e)) {
                        if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
                        n[e]();
                    }
                });
            }, o(h, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return l;
                }
            }, {
                key: "NAME",
                get: function() {
                    return e;
                }
            }, {
                key: "DATA_KEY",
                get: function() {
                    return i;
                }
            }, {
                key: "Event",
                get: function() {
                    return d;
                }
            }, {
                key: "EVENT_KEY",
                get: function() {
                    return n;
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return c;
                }
            } ]), h;
        }(O);
        return t.fn[e] = u._jQueryInterface, t.fn[e].Constructor = u, t.fn[e].noConflict = function() {
            return t.fn[e] = r, u._jQueryInterface;
        }, u;
    }(e), D = function(t) {
        var e = "scrollspy", i = "bs.scrollspy", n = "." + i, r = t.fn[e], a = {
            offset: 10,
            method: "auto",
            target: ""
        }, l = {
            offset: "number",
            method: "string",
            target: "(string|element)"
        }, c = {
            ACTIVATE: "activate" + n,
            SCROLL: "scroll" + n,
            LOAD_DATA_API: "load" + n + ".data-api"
        }, d = "active", u = {
            DATA_SPY: '[data-spy="scroll"]',
            ACTIVE: ".active",
            NAV_LIST_GROUP: ".nav, .list-group",
            NAV_LINKS: ".nav-link",
            NAV_ITEMS: ".nav-item",
            LIST_ITEMS: ".list-group-item",
            DROPDOWN: ".dropdown",
            DROPDOWN_ITEMS: ".dropdown-item",
            DROPDOWN_TOGGLE: ".dropdown-toggle"
        }, h = "position", p = function() {
            function r(e, i) {
                var n = this;
                this._element = e, this._scrollElement = "BODY" === e.tagName ? window : e, this._config = this._getConfig(i), 
                this._selector = this._config.target + " " + u.NAV_LINKS + "," + this._config.target + " " + u.LIST_ITEMS + "," + this._config.target + " " + u.DROPDOWN_ITEMS, 
                this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, 
                t(this._scrollElement).on(c.SCROLL, function(t) {
                    return n._process(t);
                }), this.refresh(), this._process();
            }
            var p = r.prototype;
            return p.refresh = function() {
                var e = this, i = this._scrollElement === this._scrollElement.window ? "offset" : h, n = "auto" === this._config.method ? i : this._config.method, o = n === h ? this._getScrollTop() : 0;
                this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight(), 
                t.makeArray(t(this._selector)).map(function(e) {
                    var i, s = C.getSelectorFromElement(e);
                    if (s && (i = t(s)[0]), i) {
                        var r = i.getBoundingClientRect();
                        if (r.width || r.height) return [ t(i)[n]().top + o, s ];
                    }
                    return null;
                }).filter(function(t) {
                    return t;
                }).sort(function(t, e) {
                    return t[0] - e[0];
                }).forEach(function(t) {
                    e._offsets.push(t[0]), e._targets.push(t[1]);
                });
            }, p.dispose = function() {
                t.removeData(this._element, i), t(this._scrollElement).off(n), this._element = null, 
                this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, 
                this._targets = null, this._activeTarget = null, this._scrollHeight = null;
            }, p._getConfig = function(i) {
                if ("string" != typeof (i = s({}, a, i)).target) {
                    var n = t(i.target).attr("id");
                    n || (n = C.getUID(e), t(i.target).attr("id", n)), i.target = "#" + n;
                }
                return C.typeCheckConfig(e, i, l), i;
            }, p._getScrollTop = function() {
                return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
            }, p._getScrollHeight = function() {
                return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            }, p._getOffsetHeight = function() {
                return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
            }, p._process = function() {
                var t = this._getScrollTop() + this._config.offset, e = this._getScrollHeight(), i = this._config.offset + e - this._getOffsetHeight();
                if (this._scrollHeight !== e && this.refresh(), t >= i) {
                    var n = this._targets[this._targets.length - 1];
                    this._activeTarget !== n && this._activate(n);
                } else {
                    if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, 
                    void this._clear();
                    for (var o = this._offsets.length; o--; ) this._activeTarget !== this._targets[o] && t >= this._offsets[o] && (void 0 === this._offsets[o + 1] || t < this._offsets[o + 1]) && this._activate(this._targets[o]);
                }
            }, p._activate = function(e) {
                this._activeTarget = e, this._clear();
                var i = this._selector.split(",");
                i = i.map(function(t) {
                    return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]';
                });
                var n = t(i.join(","));
                n.hasClass("dropdown-item") ? (n.closest(u.DROPDOWN).find(u.DROPDOWN_TOGGLE).addClass(d), 
                n.addClass(d)) : (n.addClass(d), n.parents(u.NAV_LIST_GROUP).prev(u.NAV_LINKS + ", " + u.LIST_ITEMS).addClass(d), 
                n.parents(u.NAV_LIST_GROUP).prev(u.NAV_ITEMS).children(u.NAV_LINKS).addClass(d)), 
                t(this._scrollElement).trigger(c.ACTIVATE, {
                    relatedTarget: e
                });
            }, p._clear = function() {
                t(this._selector).filter(u.ACTIVE).removeClass(d);
            }, r._jQueryInterface = function(e) {
                return this.each(function() {
                    var n = t(this).data(i);
                    if (n || (n = new r(this, "object" == typeof e && e), t(this).data(i, n)), "string" == typeof e) {
                        if (void 0 === n[e]) throw new TypeError('No method named "' + e + '"');
                        n[e]();
                    }
                });
            }, o(r, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            }, {
                key: "Default",
                get: function() {
                    return a;
                }
            } ]), r;
        }();
        return t(window).on(c.LOAD_DATA_API, function() {
            for (var e = t.makeArray(t(u.DATA_SPY)), i = e.length; i--; ) {
                var n = t(e[i]);
                p._jQueryInterface.call(n, n.data());
            }
        }), t.fn[e] = p._jQueryInterface, t.fn[e].Constructor = p, t.fn[e].noConflict = function() {
            return t.fn[e] = r, p._jQueryInterface;
        }, p;
    }(e), L = function(t) {
        var e = "bs.tab", i = "." + e, n = t.fn.tab, s = {
            HIDE: "hide" + i,
            HIDDEN: "hidden" + i,
            SHOW: "show" + i,
            SHOWN: "shown" + i,
            CLICK_DATA_API: "click.bs.tab.data-api"
        }, r = "active", a = "show", l = ".active", c = "> li > .active", d = function() {
            function i(t) {
                this._element = t;
            }
            var n = i.prototype;
            return n.show = function() {
                var e = this;
                if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && t(this._element).hasClass(r) || t(this._element).hasClass("disabled"))) {
                    var i, n, o = t(this._element).closest(".nav, .list-group")[0], a = C.getSelectorFromElement(this._element);
                    if (o) {
                        var d = "UL" === o.nodeName ? c : l;
                        n = (n = t.makeArray(t(o).find(d)))[n.length - 1];
                    }
                    var u = t.Event(s.HIDE, {
                        relatedTarget: this._element
                    }), h = t.Event(s.SHOW, {
                        relatedTarget: n
                    });
                    if (n && t(n).trigger(u), t(this._element).trigger(h), !h.isDefaultPrevented() && !u.isDefaultPrevented()) {
                        a && (i = t(a)[0]), this._activate(this._element, o);
                        var p = function() {
                            var i = t.Event(s.HIDDEN, {
                                relatedTarget: e._element
                            }), o = t.Event(s.SHOWN, {
                                relatedTarget: n
                            });
                            t(n).trigger(i), t(e._element).trigger(o);
                        };
                        i ? this._activate(i, i.parentNode, p) : p();
                    }
                }
            }, n.dispose = function() {
                t.removeData(this._element, e), this._element = null;
            }, n._activate = function(e, i, n) {
                var o = this, s = ("UL" === i.nodeName ? t(i).find(c) : t(i).children(l))[0], r = n && C.supportsTransitionEnd() && s && t(s).hasClass("fade"), a = function() {
                    return o._transitionComplete(e, s, n);
                };
                s && r ? t(s).one(C.TRANSITION_END, a).emulateTransitionEnd(150) : a();
            }, n._transitionComplete = function(e, i, n) {
                if (i) {
                    t(i).removeClass(a + " " + r);
                    var o = t(i.parentNode).find("> .dropdown-menu .active")[0];
                    o && t(o).removeClass(r), "tab" === i.getAttribute("role") && i.setAttribute("aria-selected", !1);
                }
                if (t(e).addClass(r), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0), 
                C.reflow(e), t(e).addClass(a), e.parentNode && t(e.parentNode).hasClass("dropdown-menu")) {
                    var s = t(e).closest(".dropdown")[0];
                    s && t(s).find(".dropdown-toggle").addClass(r), e.setAttribute("aria-expanded", !0);
                }
                n && n();
            }, i._jQueryInterface = function(n) {
                return this.each(function() {
                    var o = t(this), s = o.data(e);
                    if (s || (s = new i(this), o.data(e, s)), "string" == typeof n) {
                        if (void 0 === s[n]) throw new TypeError('No method named "' + n + '"');
                        s[n]();
                    }
                });
            }, o(i, null, [ {
                key: "VERSION",
                get: function() {
                    return "4.0.0";
                }
            } ]), i;
        }();
        return t(document).on(s.CLICK_DATA_API, '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', function(e) {
            e.preventDefault(), d._jQueryInterface.call(t(this), "show");
        }), t.fn.tab = d._jQueryInterface, t.fn.tab.Constructor = d, t.fn.tab.noConflict = function() {
            return t.fn.tab = n, d._jQueryInterface;
        }, d;
    }(e);
    !function(t) {
        if (void 0 === t) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
        var e = t.fn.jquery.split(" ")[0].split(".");
        if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || e[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
    }(e), t.Util = C, t.Alert = x, t.Button = E, t.Carousel = k, t.Collapse = I, t.Dropdown = A, 
    t.Modal = $, t.Popover = P, t.Scrollspy = D, t.Tab = L, t.Tooltip = O, Object.defineProperty(t, "__esModule", {
        value: !0
    });
}), function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define([ "jquery" ], t) : t(jQuery);
}(function(t) {
    "use strict";
    function e(t) {
        var e = t.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(e);
    }
    function i(t) {
        return function(i) {
            var o = i.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (o) for (var s = 0, a = o.length; a > s; ++s) {
                var l = o[s].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), c = e(l[0]), d = l[1] || "", u = l[3] || "", h = null;
                l = l[2], r.hasOwnProperty(l) && (h = r[l], h = Number(t[h])), null !== h && ("!" === d && (h = n(u, h)), 
                "" === d && 10 > h && (h = "0" + h.toString()), i = i.replace(c, h.toString()));
            }
            return i.replace(/%%/, "%");
        };
    }
    function n(t, e) {
        var i = "s", n = "";
        return t && (1 === (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? i = t[0] : (n = t[0], 
        i = t[1])), 1 === Math.abs(e) ? n : i;
    }
    var o = [], s = [];
    s.push(/^[0-9]*$/.source), s.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), 
    s.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), s = new RegExp(s.join("|"));
    var r = {
        Y: "years",
        m: "months",
        w: "weeks",
        d: "days",
        D: "totalDays",
        H: "hours",
        M: "minutes",
        S: "seconds"
    }, a = function(e, i, n) {
        this.el = e, this.$el = t(e), this.interval = null, this.offset = {}, this.instanceNumber = o.length, 
        o.push(this), this.$el.data("countdown-instance", this.instanceNumber), n && (this.$el.on("update.countdown", n), 
        this.$el.on("stoped.countdown", n), this.$el.on("finish.countdown", n)), this.setFinalDate(i), 
        this.start();
    };
    t.extend(a.prototype, {
        start: function() {
            null !== this.interval && clearInterval(this.interval);
            var t = this;
            this.update(), this.interval = setInterval(function() {
                t.update.call(t);
            }, 100);
        },
        stop: function() {
            clearInterval(this.interval), this.interval = null, this.dispatchEvent("stoped");
        },
        toggle: function() {
            this.interval ? this.stop() : this.start();
        },
        pause: function() {
            this.stop();
        },
        resume: function() {
            this.start();
        },
        remove: function() {
            this.stop.call(this), o[this.instanceNumber] = null, delete this.$el.data().countdownInstance;
        },
        setFinalDate: function(t) {
            this.finalDate = function(t) {
                if (t instanceof Date) return t;
                if (String(t).match(s)) return String(t).match(/^[0-9]*$/) && (t = Number(t)), String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")), 
                new Date(t);
                throw new Error("Couldn't cast `" + t + "` to a date object.");
            }(t);
        },
        update: function() {
            return 0 === this.$el.closest("html").length ? void this.remove() : (this.totalSecsLeft = this.finalDate.getTime() - new Date().getTime(), 
            this.totalSecsLeft = Math.ceil(this.totalSecsLeft / 1e3), this.totalSecsLeft = this.totalSecsLeft < 0 ? 0 : this.totalSecsLeft, 
            this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30),
                years: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 365)
            }, void (0 === this.totalSecsLeft ? (this.stop(), this.dispatchEvent("finish")) : this.dispatchEvent("update")));
        },
        dispatchEvent: function(e) {
            var n = t.Event(e + ".countdown");
            n.finalDate = this.finalDate, n.offset = t.extend({}, this.offset), n.strftime = i(this.offset), 
            this.$el.trigger(n);
        }
    }), t.fn.countdown = function() {
        var e = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var i = t(this).data("countdown-instance");
            if (void 0 !== i) {
                var n = o[i], s = e[0];
                a.prototype.hasOwnProperty(s) ? n[s].apply(n, e.slice(1)) : null === String(s).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (n.setFinalDate.call(n, s), 
                n.start()) : t.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, s));
            } else new a(this, e[0], e[1]);
        });
    };
}), "object" != typeof JSON && (JSON = {}), function() {
    "use strict";
    function f(t) {
        return t < 10 ? "0" + t : t;
    }
    function quote(t) {
        return escapable.lastIndex = 0, escapable.test(t) ? '"' + t.replace(escapable, function(t) {
            var e = meta[t];
            return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + t + '"';
    }
    function str(t, e) {
        var i, n, o, s, r, a = gap, l = e[t];
        switch (l && "object" == typeof l && "function" == typeof l.toJSON && (l = l.toJSON(t)), 
        "function" == typeof rep && (l = rep.call(e, t, l)), typeof l) {
          case "string":
            return quote(l);

          case "number":
            return isFinite(l) ? String(l) : "null";

          case "boolean":
          case "null":
            return String(l);

          case "object":
            if (!l) return "null";
            if (gap += indent, r = [], "[object Array]" === Object.prototype.toString.apply(l)) {
                for (s = l.length, i = 0; i < s; i += 1) r[i] = str(i, l) || "null";
                return o = 0 === r.length ? "[]" : gap ? "[\n" + gap + r.join(",\n" + gap) + "\n" + a + "]" : "[" + r.join(",") + "]", 
                gap = a, o;
            }
            if (rep && "object" == typeof rep) for (s = rep.length, i = 0; i < s; i += 1) "string" == typeof rep[i] && ((o = str(n = rep[i], l)) && r.push(quote(n) + (gap ? ": " : ":") + o)); else for (n in l) Object.prototype.hasOwnProperty.call(l, n) && ((o = str(n, l)) && r.push(quote(n) + (gap ? ": " : ":") + o));
            return o = 0 === r.length ? "{}" : gap ? "{\n" + gap + r.join(",\n" + gap) + "\n" + a + "}" : "{" + r.join(",") + "}", 
            gap = a, o;
        }
    }
    "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function(t) {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
    }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function(t) {
        return this.valueOf();
    });
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta = {
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    }, rep;
    "function" != typeof JSON.stringify && (JSON.stringify = function(t, e, i) {
        var n;
        if (gap = "", indent = "", "number" == typeof i) for (n = 0; n < i; n += 1) indent += " "; else "string" == typeof i && (indent = i);
        if (rep = e, !e || "function" == typeof e || "object" == typeof e && "number" == typeof e.length) return str("", {
            "": t
        });
        throw new Error("JSON.stringify");
    }), "function" != typeof JSON.parse && (JSON.parse = function(text, reviver) {
        function walk(t, e) {
            var i, n, o = t[e];
            if (o && "object" == typeof o) for (i in o) Object.prototype.hasOwnProperty.call(o, i) && (void 0 !== (n = walk(o, i)) ? o[i] = n : delete o[i]);
            return reviver.call(t, e, o);
        }
        var j;
        if (text = String(text), cx.lastIndex = 0, cx.test(text) && (text = text.replace(cx, function(t) {
            return "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
        })), /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return j = eval("(" + text + ")"), 
        "function" == typeof reviver ? walk({
            "": j
        }, "") : j;
        throw new SyntaxError("JSON.parse");
    });
}(), function(t, e) {
    "use strict";
    var i = t.History = t.History || {}, n = t.jQuery;
    if (void 0 !== i.Adapter) throw new Error("History.js Adapter has already been loaded...");
    i.Adapter = {
        bind: function(t, e, i) {
            n(t).bind(e, i);
        },
        trigger: function(t, e, i) {
            n(t).trigger(e, i);
        },
        extractEventData: function(t, e, i) {
            return e && e.originalEvent && e.originalEvent[t] || i && i[t] || void 0;
        },
        onDomLoad: function(t) {
            n(t);
        }
    }, void 0 !== i.init && i.init();
}(window), function(t, e) {
    "use strict";
    var i = t.document, n = t.setTimeout || n, o = t.clearTimeout || o, s = t.setInterval || s, r = t.History = t.History || {};
    if (void 0 !== r.initHtml4) throw new Error("History.js HTML4 Support has already been loaded...");
    r.initHtml4 = function() {
        if (void 0 !== r.initHtml4.initialized) return !1;
        r.initHtml4.initialized = !0, r.enabled = !0, r.savedHashes = [], r.isLastHash = function(t) {
            return t === r.getHashByIndex();
        }, r.isHashEqual = function(t, e) {
            return (t = encodeURIComponent(t).replace(/%25/g, "%")) === (e = encodeURIComponent(e).replace(/%25/g, "%"));
        }, r.saveHash = function(t) {
            return !r.isLastHash(t) && (r.savedHashes.push(t), !0);
        }, r.getHashByIndex = function(t) {
            return void 0 === t ? r.savedHashes[r.savedHashes.length - 1] : t < 0 ? r.savedHashes[r.savedHashes.length + t] : r.savedHashes[t];
        }, r.discardedHashes = {}, r.discardedStates = {}, r.discardState = function(t, e, i) {
            var n, o = r.getHashByState(t);
            return n = {
                discardedState: t,
                backState: i,
                forwardState: e
            }, r.discardedStates[o] = n, !0;
        }, r.discardHash = function(t, e, i) {
            var n = {
                discardedHash: t,
                backState: i,
                forwardState: e
            };
            return r.discardedHashes[t] = n, !0;
        }, r.discardedState = function(t) {
            var e = r.getHashByState(t);
            return r.discardedStates[e] || !1;
        }, r.discardedHash = function(t) {
            return r.discardedHashes[t] || !1;
        }, r.recycleState = function(t) {
            var e = r.getHashByState(t);
            return r.discardedState(t) && delete r.discardedStates[e], !0;
        }, r.emulated.hashChange && (r.hashChangeInit = function() {
            r.checkerFunction = null;
            var e, n, o, a = "", l = Boolean(r.getHash());
            return r.isInternetExplorer() ? ("historyjs-iframe", (e = i.createElement("iframe")).setAttribute("id", "historyjs-iframe"), 
            e.setAttribute("src", "#"), e.style.display = "none", i.body.appendChild(e), e.contentWindow.document.open(), 
            e.contentWindow.document.close(), n = "", o = !1, r.checkerFunction = function() {
                if (o) return !1;
                o = !0;
                var i = r.getHash(), s = r.getHash(e.contentWindow.document);
                return i !== a ? (a = i, s !== i && (n = s = i, e.contentWindow.document.open(), 
                e.contentWindow.document.close(), e.contentWindow.document.location.hash = r.escapeHash(i)), 
                r.Adapter.trigger(t, "hashchange")) : s !== n && (n = s, l && "" === s ? r.back() : r.setHash(s, !1)), 
                o = !1, !0;
            }) : r.checkerFunction = function() {
                var e = r.getHash() || "";
                return e !== a && (a = e, r.Adapter.trigger(t, "hashchange")), !0;
            }, r.intervalList.push(s(r.checkerFunction, r.options.hashChangeInterval)), !0;
        }, r.Adapter.onDomLoad(r.hashChangeInit)), r.emulated.pushState && (r.onHashChange = function(e) {
            var i, n = e && e.newURL || r.getLocationHref(), o = r.getHashByUrl(n), s = null;
            return r.isLastHash(o) ? (r.busy(!1), !1) : (r.doubleCheckComplete(), r.saveHash(o), 
            o && r.isTraditionalAnchor(o) ? (r.Adapter.trigger(t, "anchorchange"), r.busy(!1), 
            !1) : (s = r.extractState(r.getFullUrl(o || r.getLocationHref()), !0), r.isLastSavedState(s) ? (r.busy(!1), 
            !1) : (r.getHashByState(s), (i = r.discardedState(s)) ? (r.getHashByIndex(-2) === r.getHashByState(i.forwardState) ? r.back(!1) : r.forward(!1), 
            !1) : (r.pushState(s.data, s.title, encodeURI(s.url), !1), !0))));
        }, r.Adapter.bind(t, "hashchange", r.onHashChange), r.pushState = function(e, i, n, o) {
            if (n = encodeURI(n).replace(/%25/g, "%"), r.getHashByUrl(n)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
            if (!1 !== o && r.busy()) return r.pushQueue({
                scope: r,
                callback: r.pushState,
                args: arguments,
                queue: o
            }), !1;
            r.busy(!0);
            var s = r.createStateObject(e, i, n), a = r.getHashByState(s), l = r.getState(!1), c = r.getHashByState(l), d = r.getHash(), u = r.expectedStateId == s.id;
            return r.storeState(s), r.expectedStateId = s.id, r.recycleState(s), r.setTitle(s), 
            a === c ? (r.busy(!1), !1) : (r.saveState(s), u || r.Adapter.trigger(t, "statechange"), 
            !r.isHashEqual(a, d) && !r.isHashEqual(a, r.getShortUrl(r.getLocationHref())) && r.setHash(a, !1), 
            r.busy(!1), !0);
        }, r.replaceState = function(e, i, n, o) {
            if (n = encodeURI(n).replace(/%25/g, "%"), r.getHashByUrl(n)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
            if (!1 !== o && r.busy()) return r.pushQueue({
                scope: r,
                callback: r.replaceState,
                args: arguments,
                queue: o
            }), !1;
            r.busy(!0);
            var s = r.createStateObject(e, i, n), a = r.getHashByState(s), l = r.getState(!1), c = r.getHashByState(l), d = r.getStateByIndex(-2);
            return r.discardState(l, s, d), a === c ? (r.storeState(s), r.expectedStateId = s.id, 
            r.recycleState(s), r.setTitle(s), r.saveState(s), r.Adapter.trigger(t, "statechange"), 
            r.busy(!1)) : r.pushState(s.data, s.title, s.url, !1), !0;
        }), r.emulated.pushState && r.getHash() && !r.emulated.hashChange && r.Adapter.onDomLoad(function() {
            r.Adapter.trigger(t, "hashchange");
        });
    }, void 0 !== r.init && r.init();
}(window), function(t, e) {
    "use strict";
    var i = t.console || e, n = t.document, o = t.navigator, s = !1, r = t.setTimeout, a = t.clearTimeout, l = t.setInterval, c = t.clearInterval, d = t.JSON, u = t.alert, h = t.History = t.History || {}, p = t.history;
    try {
        (s = t.sessionStorage).setItem("TEST", "1"), s.removeItem("TEST");
    } catch (t) {
        s = !1;
    }
    if (d.stringify = d.stringify || d.encode, d.parse = d.parse || d.decode, void 0 !== h.init) throw new Error("History.js Core has already been loaded...");
    h.init = function(t) {
        return void 0 !== h.Adapter && (void 0 !== h.initCore && h.initCore(), void 0 !== h.initHtml4 && h.initHtml4(), 
        !0);
    }, h.initCore = function(f) {
        if (void 0 !== h.initCore.initialized) return !1;
        if (h.initCore.initialized = !0, h.options = h.options || {}, h.options.hashChangeInterval = h.options.hashChangeInterval || 100, 
        h.options.safariPollInterval = h.options.safariPollInterval || 500, h.options.doubleCheckInterval = h.options.doubleCheckInterval || 500, 
        h.options.disableSuid = h.options.disableSuid || !1, h.options.storeInterval = h.options.storeInterval || 1e3, 
        h.options.busyDelay = h.options.busyDelay || 250, h.options.debug = h.options.debug || !1, 
        h.options.initialTitle = h.options.initialTitle || n.title, h.options.html4Mode = h.options.html4Mode || !1, 
        h.options.delayInit = h.options.delayInit || !1, h.intervalList = [], h.clearAllIntervals = function() {
            var t, e = h.intervalList;
            if (null != e) {
                for (t = 0; t < e.length; t++) c(e[t]);
                h.intervalList = null;
            }
        }, h.debug = function() {
            h.options.debug && h.log.apply(h, arguments);
        }, h.log = function() {
            var t, e, o, s, r, a = void 0 !== i && void 0 !== i.log && void 0 !== i.log.apply, l = n.getElementById("log");
            for (a ? (t = (s = Array.prototype.slice.call(arguments)).shift(), void 0 !== i.debug ? i.debug.apply(i, [ t, s ]) : i.log.apply(i, [ t, s ])) : t = "\n" + arguments[0] + "\n", 
            e = 1, o = arguments.length; e < o; ++e) {
                if ("object" == typeof (r = arguments[e]) && void 0 !== d) try {
                    r = d.stringify(r);
                } catch (t) {}
                t += "\n" + r + "\n";
            }
            return l ? (l.value += t + "\n-----\n", l.scrollTop = l.scrollHeight - l.clientHeight) : a || u(t), 
            !0;
        }, h.getInternetExplorerMajorVersion = function() {
            return h.getInternetExplorerMajorVersion.cached = void 0 !== h.getInternetExplorerMajorVersion.cached ? h.getInternetExplorerMajorVersion.cached : function() {
                for (var t = 3, e = n.createElement("div"), i = e.getElementsByTagName("i"); (e.innerHTML = "\x3c!--[if gt IE " + ++t + "]><i></i><![endif]--\x3e") && i[0]; ) ;
                return t > 4 && t;
            }();
        }, h.isInternetExplorer = function() {
            return h.isInternetExplorer.cached = void 0 !== h.isInternetExplorer.cached ? h.isInternetExplorer.cached : Boolean(h.getInternetExplorerMajorVersion());
        }, h.options.html4Mode ? h.emulated = {
            pushState: !0,
            hashChange: !0
        } : h.emulated = {
            pushState: !Boolean(t.history && t.history.pushState && t.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(o.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(o.userAgent)),
            hashChange: Boolean(!("onhashchange" in t || "onhashchange" in n) || h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8)
        }, h.enabled = !h.emulated.pushState, h.bugs = {
            setHash: Boolean(!h.emulated.pushState && "Apple Computer, Inc." === o.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(o.userAgent)),
            safariPoll: Boolean(!h.emulated.pushState && "Apple Computer, Inc." === o.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(o.userAgent)),
            ieDoubleCheck: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8),
            hashEscape: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 7)
        }, h.isEmptyObject = function(t) {
            for (var e in t) if (t.hasOwnProperty(e)) return !1;
            return !0;
        }, h.cloneObject = function(t) {
            var e, i;
            return t ? (e = d.stringify(t), i = d.parse(e)) : i = {}, i;
        }, h.getRootUrl = function() {
            var t = n.location.protocol + "//" + (n.location.hostname || n.location.host);
            return n.location.port && (t += ":" + n.location.port), t += "/";
        }, h.getBaseHref = function() {
            var t = n.getElementsByTagName("base"), e = "";
            return 1 === t.length && (e = t[0].href.replace(/[^\/]+$/, "")), (e = e.replace(/\/+$/, "")) && (e += "/"), 
            e;
        }, h.getBaseUrl = function() {
            return h.getBaseHref() || h.getBasePageUrl() || h.getRootUrl();
        }, h.getPageUrl = function() {
            return ((h.getState(!1, !1) || {}).url || h.getLocationHref()).replace(/\/+$/, "").replace(/[^\/]+$/, function(t, e, i) {
                return /\./.test(t) ? t : t + "/";
            });
        }, h.getBasePageUrl = function() {
            return h.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(t, e, i) {
                return /[^\/]$/.test(t) ? "" : t;
            }).replace(/\/+$/, "") + "/";
        }, h.getFullUrl = function(t, e) {
            var i = t, n = t.substring(0, 1);
            return e = void 0 === e || e, /[a-z]+\:\/\//.test(t) || (i = "/" === n ? h.getRootUrl() + t.replace(/^\/+/, "") : "#" === n ? h.getPageUrl().replace(/#.*/, "") + t : "?" === n ? h.getPageUrl().replace(/[\?#].*/, "") + t : e ? h.getBaseUrl() + t.replace(/^(\.\/)+/, "") : h.getBasePageUrl() + t.replace(/^(\.\/)+/, "")), 
            i.replace(/\#$/, "");
        }, h.getShortUrl = function(t) {
            var e = t, i = h.getBaseUrl(), n = h.getRootUrl();
            return h.emulated.pushState && (e = e.replace(i, "")), e = e.replace(n, "/"), h.isTraditionalAnchor(e) && (e = "./" + e), 
            e = e.replace(/^(\.\/)+/g, "./").replace(/\#$/, "");
        }, h.getLocationHref = function(t) {
            return (t = t || n).URL === t.location.href ? t.location.href : t.location.href === decodeURIComponent(t.URL) ? t.URL : t.location.hash && decodeURIComponent(t.location.href.replace(/^[^#]+/, "")) === t.location.hash ? t.location.href : -1 == t.URL.indexOf("#") && -1 != t.location.href.indexOf("#") ? t.location.href : t.URL || t.location.href;
        }, h.store = {}, h.idToState = h.idToState || {}, h.stateToId = h.stateToId || {}, 
        h.urlToId = h.urlToId || {}, h.storedStates = h.storedStates || [], h.savedStates = h.savedStates || [], 
        h.normalizeStore = function() {
            h.store.idToState = h.store.idToState || {}, h.store.urlToId = h.store.urlToId || {}, 
            h.store.stateToId = h.store.stateToId || {};
        }, h.getState = function(t, e) {
            void 0 === t && (t = !0), void 0 === e && (e = !0);
            var i = h.getLastSavedState();
            return !i && e && (i = h.createStateObject()), t && ((i = h.cloneObject(i)).url = i.cleanUrl || i.url), 
            i;
        }, h.getIdByState = function(t) {
            var e, i = h.extractId(t.url);
            if (!i) if (e = h.getStateString(t), void 0 !== h.stateToId[e]) i = h.stateToId[e]; else if (void 0 !== h.store.stateToId[e]) i = h.store.stateToId[e]; else {
                for (;i = new Date().getTime() + String(Math.random()).replace(/\D/g, ""), void 0 !== h.idToState[i] || void 0 !== h.store.idToState[i]; ) ;
                h.stateToId[e] = i, h.idToState[i] = t;
            }
            return i;
        }, h.normalizeState = function(t) {
            var e, i;
            return t && "object" == typeof t || (t = {}), void 0 !== t.normalized ? t : (t.data && "object" == typeof t.data || (t.data = {}), 
            (e = {}).normalized = !0, e.title = t.title || "", e.url = h.getFullUrl(t.url ? t.url : h.getLocationHref()), 
            e.hash = h.getShortUrl(e.url), e.data = h.cloneObject(t.data), e.id = h.getIdByState(e), 
            e.cleanUrl = e.url.replace(/\??\&_suid.*/, ""), e.url = e.cleanUrl, i = !h.isEmptyObject(e.data), 
            (e.title || i) && !0 !== h.options.disableSuid && (e.hash = h.getShortUrl(e.url).replace(/\??\&_suid.*/, ""), 
            /\?/.test(e.hash) || (e.hash += "?"), e.hash += "&_suid=" + e.id), e.hashedUrl = h.getFullUrl(e.hash), 
            (h.emulated.pushState || h.bugs.safariPoll) && h.hasUrlDuplicate(e) && (e.url = e.hashedUrl), 
            e);
        }, h.createStateObject = function(t, e, i) {
            var n = {
                data: t,
                title: e,
                url: i
            };
            return n = h.normalizeState(n);
        }, h.getStateById = function(t) {
            return t = String(t), h.idToState[t] || h.store.idToState[t] || e;
        }, h.getStateString = function(t) {
            var e;
            return e = {
                data: h.normalizeState(t).data,
                title: t.title,
                url: t.url
            }, d.stringify(e);
        }, h.getStateId = function(t) {
            return h.normalizeState(t).id;
        }, h.getHashByState = function(t) {
            return h.normalizeState(t).hash;
        }, h.extractId = function(t) {
            var e, i;
            return i = -1 != t.indexOf("#") ? t.split("#")[0] : t, (e = /(.*)\&_suid=([0-9]+)$/.exec(i)) && e[1] || t, 
            (e ? String(e[2] || "") : "") || !1;
        }, h.isTraditionalAnchor = function(t) {
            return !/[\/\?\.]/.test(t);
        }, h.extractState = function(t, e) {
            var i, n, o = null;
            return e = e || !1, (i = h.extractId(t)) && (o = h.getStateById(i)), o || (n = h.getFullUrl(t), 
            (i = h.getIdByUrl(n) || !1) && (o = h.getStateById(i)), !o && e && !h.isTraditionalAnchor(t) && (o = h.createStateObject(null, null, n))), 
            o;
        }, h.getIdByUrl = function(t) {
            return h.urlToId[t] || h.store.urlToId[t] || e;
        }, h.getLastSavedState = function() {
            return h.savedStates[h.savedStates.length - 1] || e;
        }, h.getLastStoredState = function() {
            return h.storedStates[h.storedStates.length - 1] || e;
        }, h.hasUrlDuplicate = function(t) {
            var e;
            return (e = h.extractState(t.url)) && e.id !== t.id;
        }, h.storeState = function(t) {
            return h.urlToId[t.url] = t.id, h.storedStates.push(h.cloneObject(t)), t;
        }, h.isLastSavedState = function(t) {
            var e = !1;
            return h.savedStates.length && (e = t.id === h.getLastSavedState().id), e;
        }, h.saveState = function(t) {
            return !h.isLastSavedState(t) && (h.savedStates.push(h.cloneObject(t)), !0);
        }, h.getStateByIndex = function(t) {
            return void 0 === t ? h.savedStates[h.savedStates.length - 1] : t < 0 ? h.savedStates[h.savedStates.length + t] : h.savedStates[t];
        }, h.getCurrentIndex = function() {
            return h.savedStates.length < 1 ? 0 : h.savedStates.length - 1;
        }, h.getHash = function(t) {
            var e = h.getLocationHref(t);
            return h.getHashByUrl(e);
        }, h.unescapeHash = function(t) {
            var e = h.normalizeHash(t);
            return e = decodeURIComponent(e);
        }, h.normalizeHash = function(t) {
            return t.replace(/[^#]*#/, "").replace(/#.*/, "");
        }, h.setHash = function(t, e) {
            var i, o;
            return !1 !== e && h.busy() ? (h.pushQueue({
                scope: h,
                callback: h.setHash,
                args: arguments,
                queue: e
            }), !1) : (h.busy(!0), (i = h.extractState(t, !0)) && !h.emulated.pushState ? h.pushState(i.data, i.title, i.url, !1) : h.getHash() !== t && (h.bugs.setHash ? (o = h.getPageUrl(), 
            h.pushState(null, null, o + "#" + t, !1)) : n.location.hash = t), h);
        }, h.escapeHash = function(e) {
            var i = h.normalizeHash(e);
            return i = t.encodeURIComponent(i), h.bugs.hashEscape || (i = i.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")), 
            i;
        }, h.getHashByUrl = function(t) {
            var e = String(t).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            return e = h.unescapeHash(e);
        }, h.setTitle = function(t) {
            var e, i = t.title;
            i || (e = h.getStateByIndex(0)) && e.url === t.url && (i = e.title || h.options.initialTitle);
            try {
                n.getElementsByTagName("title")[0].innerHTML = i.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ");
            } catch (t) {}
            return n.title = i, h;
        }, h.queues = [], h.busy = function(t) {
            if (void 0 !== t ? h.busy.flag = t : void 0 === h.busy.flag && (h.busy.flag = !1), 
            !h.busy.flag) {
                a(h.busy.timeout);
                var e = function() {
                    var t, i, n;
                    if (!h.busy.flag) for (t = h.queues.length - 1; t >= 0; --t) 0 !== (i = h.queues[t]).length && (n = i.shift(), 
                    h.fireQueueItem(n), h.busy.timeout = r(e, h.options.busyDelay));
                };
                h.busy.timeout = r(e, h.options.busyDelay);
            }
            return h.busy.flag;
        }, h.busy.flag = !1, h.fireQueueItem = function(t) {
            return t.callback.apply(t.scope || h, t.args || []);
        }, h.pushQueue = function(t) {
            return h.queues[t.queue || 0] = h.queues[t.queue || 0] || [], h.queues[t.queue || 0].push(t), 
            h;
        }, h.queue = function(t, e) {
            return "function" == typeof t && (t = {
                callback: t
            }), void 0 !== e && (t.queue = e), h.busy() ? h.pushQueue(t) : h.fireQueueItem(t), 
            h;
        }, h.clearQueue = function() {
            return h.busy.flag = !1, h.queues = [], h;
        }, h.stateChanged = !1, h.doubleChecker = !1, h.doubleCheckComplete = function() {
            return h.stateChanged = !0, h.doubleCheckClear(), h;
        }, h.doubleCheckClear = function() {
            return h.doubleChecker && (a(h.doubleChecker), h.doubleChecker = !1), h;
        }, h.doubleCheck = function(t) {
            return h.stateChanged = !1, h.doubleCheckClear(), h.bugs.ieDoubleCheck && (h.doubleChecker = r(function() {
                return h.doubleCheckClear(), h.stateChanged || t(), !0;
            }, h.options.doubleCheckInterval)), h;
        }, h.safariStatePoll = function() {
            var e = h.extractState(h.getLocationHref());
            if (!h.isLastSavedState(e)) return e || h.createStateObject(), h.Adapter.trigger(t, "popstate"), 
            h;
        }, h.back = function(t) {
            return !1 !== t && h.busy() ? (h.pushQueue({
                scope: h,
                callback: h.back,
                args: arguments,
                queue: t
            }), !1) : (h.busy(!0), h.doubleCheck(function() {
                h.back(!1);
            }), p.go(-1), !0);
        }, h.forward = function(t) {
            return !1 !== t && h.busy() ? (h.pushQueue({
                scope: h,
                callback: h.forward,
                args: arguments,
                queue: t
            }), !1) : (h.busy(!0), h.doubleCheck(function() {
                h.forward(!1);
            }), p.go(1), !0);
        }, h.go = function(t, e) {
            var i;
            if (t > 0) for (i = 1; i <= t; ++i) h.forward(e); else {
                if (!(t < 0)) throw new Error("History.go: History.go requires a positive or negative integer passed.");
                for (i = -1; i >= t; --i) h.back(e);
            }
            return h;
        }, h.emulated.pushState) {
            var g = function() {};
            h.pushState = h.pushState || g, h.replaceState = h.replaceState || g;
        } else h.onPopState = function(e, i) {
            var n, o, s = !1, r = !1;
            return h.doubleCheckComplete(), (n = h.getHash()) ? ((o = h.extractState(n || h.getLocationHref(), !0)) ? h.replaceState(o.data, o.title, o.url, !1) : (h.Adapter.trigger(t, "anchorchange"), 
            h.busy(!1)), h.expectedStateId = !1, !1) : ((r = (s = h.Adapter.extractEventData("state", e, i) || !1) ? h.getStateById(s) : h.expectedStateId ? h.getStateById(h.expectedStateId) : h.extractState(h.getLocationHref())) || (r = h.createStateObject(null, null, h.getLocationHref())), 
            h.expectedStateId = !1, h.isLastSavedState(r) ? (h.busy(!1), !1) : (h.storeState(r), 
            h.saveState(r), h.setTitle(r), h.Adapter.trigger(t, "statechange"), h.busy(!1), 
            !0));
        }, h.Adapter.bind(t, "popstate", h.onPopState), h.pushState = function(e, i, n, o) {
            if (h.getHashByUrl(n) && h.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
            if (!1 !== o && h.busy()) return h.pushQueue({
                scope: h,
                callback: h.pushState,
                args: arguments,
                queue: o
            }), !1;
            h.busy(!0);
            var s = h.createStateObject(e, i, n);
            return h.isLastSavedState(s) ? h.busy(!1) : (h.storeState(s), h.expectedStateId = s.id, 
            p.pushState(s.id, s.title, s.url), h.Adapter.trigger(t, "popstate")), !0;
        }, h.replaceState = function(e, i, n, o) {
            if (h.getHashByUrl(n) && h.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
            if (!1 !== o && h.busy()) return h.pushQueue({
                scope: h,
                callback: h.replaceState,
                args: arguments,
                queue: o
            }), !1;
            h.busy(!0);
            var s = h.createStateObject(e, i, n);
            return h.isLastSavedState(s) ? h.busy(!1) : (h.storeState(s), h.expectedStateId = s.id, 
            p.replaceState(s.id, s.title, s.url), h.Adapter.trigger(t, "popstate")), !0;
        };
        if (s) {
            try {
                h.store = d.parse(s.getItem("History.store")) || {};
            } catch (t) {
                h.store = {};
            }
            h.normalizeStore();
        } else h.store = {}, h.normalizeStore();
        h.Adapter.bind(t, "unload", h.clearAllIntervals), h.saveState(h.storeState(h.extractState(h.getLocationHref(), !0))), 
        s && (h.onUnload = function() {
            var t, e, i;
            try {
                t = d.parse(s.getItem("History.store")) || {};
            } catch (e) {
                t = {};
            }
            for (e in t.idToState = t.idToState || {}, t.urlToId = t.urlToId || {}, t.stateToId = t.stateToId || {}, 
            h.idToState) h.idToState.hasOwnProperty(e) && (t.idToState[e] = h.idToState[e]);
            for (e in h.urlToId) h.urlToId.hasOwnProperty(e) && (t.urlToId[e] = h.urlToId[e]);
            for (e in h.stateToId) h.stateToId.hasOwnProperty(e) && (t.stateToId[e] = h.stateToId[e]);
            h.store = t, h.normalizeStore(), i = d.stringify(t);
            try {
                s.setItem("History.store", i);
            } catch (t) {
                if (t.code !== DOMException.QUOTA_EXCEEDED_ERR) throw t;
                s.length && (s.removeItem("History.store"), s.setItem("History.store", i));
            }
        }, h.intervalList.push(l(h.onUnload, h.options.storeInterval)), h.Adapter.bind(t, "beforeunload", h.onUnload), 
        h.Adapter.bind(t, "unload", h.onUnload)), h.emulated.pushState || (h.bugs.safariPoll && h.intervalList.push(l(h.safariStatePoll, h.options.safariPollInterval)), 
        "Apple Computer, Inc." !== o.vendor && "Mozilla" !== (o.appCodeName || "") || (h.Adapter.bind(t, "hashchange", function() {
            h.Adapter.trigger(t, "popstate");
        }), h.getHash() && h.Adapter.onDomLoad(function() {
            h.Adapter.trigger(t, "hashchange");
        })));
    }, (!h.options || !h.options.delayInit) && h.init();
}(window), function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", [ "jquery" ], function(i) {
        return e(t, i);
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery);
}(window, function(t, e) {
    "use strict";
    function i(i, s, a) {
        (a = a || e || t.jQuery) && (s.prototype.option || (s.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
        }), a.fn[i] = function(t) {
            return "string" == typeof t ? function(t, e, n) {
                var o, s = "$()." + i + '("' + e + '")';
                return t.each(function(t, l) {
                    var c = a.data(l, i);
                    if (c) {
                        var d = c[e];
                        if (d && "_" != e.charAt(0)) {
                            var u = d.apply(c, n);
                            o = void 0 === o ? u : o;
                        } else r(s + " is not a valid method");
                    } else r(i + " not initialized. Cannot call methods, i.e. " + s);
                }), void 0 !== o ? o : t;
            }(this, t, o.call(arguments, 1)) : (function(t, e) {
                t.each(function(t, n) {
                    var o = a.data(n, i);
                    o ? (o.option(e), o._init()) : (o = new s(n, e), a.data(n, i, o));
                });
            }(this, t), this);
        }, n(a));
    }
    function n(t) {
        !t || t && t.bridget || (t.bridget = i);
    }
    var o = Array.prototype.slice, s = t.console, r = void 0 === s ? function() {} : function(t) {
        s.error(t);
    };
    return n(e || t.jQuery), i;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e();
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}, n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this;
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0, this;
        }
    }, e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this;
        }
    }, e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0), e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var s = i[o];
                n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e);
            }
            return this;
        }
    }, e.allOff = function() {
        delete this._events, delete this._onceEvents;
    }, t;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e();
}(window, function() {
    "use strict";
    function t(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    function e(t) {
        var e = getComputedStyle(t);
        return e || s("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), 
        e;
    }
    function i() {
        if (!l) {
            l = !0;
            var i = document.createElement("div");
            i.style.width = "200px", i.style.padding = "1px 2px 3px 4px", i.style.borderStyle = "solid", 
            i.style.borderWidth = "1px 2px 3px 4px", i.style.boxSizing = "border-box";
            var s = document.body || document.documentElement;
            s.appendChild(i);
            var r = e(i);
            o = 200 == Math.round(t(r.width)), n.isBoxSizeOuter = o, s.removeChild(i);
        }
    }
    function n(n) {
        if (i(), "string" == typeof n && (n = document.querySelector(n)), n && "object" == typeof n && n.nodeType) {
            var s = e(n);
            if ("none" == s.display) return function() {
                for (var t = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, e = 0; e < a; e++) t[r[e]] = 0;
                return t;
            }();
            var l = {};
            l.width = n.offsetWidth, l.height = n.offsetHeight;
            for (var c = l.isBorderBox = "border-box" == s.boxSizing, d = 0; d < a; d++) {
                var u = r[d], h = s[u], p = parseFloat(h);
                l[u] = isNaN(p) ? 0 : p;
            }
            var f = l.paddingLeft + l.paddingRight, g = l.paddingTop + l.paddingBottom, m = l.marginLeft + l.marginRight, v = l.marginTop + l.marginBottom, y = l.borderLeftWidth + l.borderRightWidth, b = l.borderTopWidth + l.borderBottomWidth, S = c && o, w = t(s.width);
            !1 !== w && (l.width = w + (S ? 0 : f + y));
            var _ = t(s.height);
            return !1 !== _ && (l.height = _ + (S ? 0 : g + b)), l.innerWidth = l.width - (f + y), 
            l.innerHeight = l.height - (g + b), l.outerWidth = l.width + m, l.outerHeight = l.height + v, 
            l;
        }
    }
    var o, s = "undefined" == typeof console ? function() {} : function(t) {
        console.error(t);
    }, r = [ "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth" ], a = r.length, l = !1;
    return n;
}), function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e();
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = [ "webkit", "moz", "ms", "o" ], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n]) return n;
        }
    }();
    return function(e, i) {
        return e[t](i);
    };
}), function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", [ "desandro-matches-selector/matches-selector" ], function(i) {
        return e(t, i);
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector);
}(window, function(t, e) {
    var i = {
        extend: function(t, e) {
            for (var i in e) t[i] = e[i];
            return t;
        },
        modulo: function(t, e) {
            return (t % e + e) % e;
        }
    }, n = Array.prototype.slice;
    i.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [ t ];
    }, i.removeFrom = function(t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
    }, i.getParent = function(t, i) {
        for (;t.parentNode && t != document.body; ) if (t = t.parentNode, e(t, i)) return t;
    }, i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t;
    }, i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
    }, i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++) o.push(i[s]);
            }
        }), o;
    }, i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e], o = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[o];
            clearTimeout(t);
            var e = arguments, s = this;
            this[o] = setTimeout(function() {
                n.apply(s, e), delete s[o];
            }, i);
        };
    }, i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
    }, i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i;
        }).toLowerCase();
    };
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady(function() {
            var s = i.toDashed(n), r = "data-" + s, a = document.querySelectorAll("[" + r + "]"), l = document.querySelectorAll(".js-" + s), c = i.makeArray(a).concat(i.makeArray(l)), d = r + "-options", u = t.jQuery;
            c.forEach(function(t) {
                var i, s = t.getAttribute(r) || t.getAttribute(d);
                try {
                    i = s && JSON.parse(s);
                } catch (e) {
                    return void (o && o.error("Error parsing " + r + " on " + t.className + ": " + e));
                }
                var a = new e(t, i);
                u && u.data(t, n, a);
            });
        });
    }, i;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", [ "ev-emitter/ev-emitter", "get-size/get-size" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, 
    t.Outlayer.Item = e(t.EvEmitter, t.getSize));
}(window, function(t, e) {
    "use strict";
    function i(t, e) {
        t && (this.element = t, this.layout = e, this.position = {
            x: 0,
            y: 0
        }, this._create());
    }
    var n = document.documentElement.style, o = "string" == typeof n.transition ? "transition" : "WebkitTransition", s = "string" == typeof n.transform ? "transform" : "WebkitTransform", r = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
    }[o], a = {
        transform: s,
        transition: o,
        transitionDuration: o + "Duration",
        transitionProperty: o + "Property",
        transitionDelay: o + "Delay"
    }, l = i.prototype = Object.create(t.prototype);
    l.constructor = i, l._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        }, this.css({
            position: "absolute"
        });
    }, l.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
    }, l.getSize = function() {
        this.size = e(this.element);
    }, l.css = function(t) {
        var e = this.element.style;
        for (var i in t) {
            e[a[i] || i] = t[i];
        }
    }, l.getPosition = function() {
        var t = getComputedStyle(this.element), e = this.layout._getOption("originLeft"), i = this.layout._getOption("originTop"), n = t[e ? "left" : "right"], o = t[i ? "top" : "bottom"], s = parseFloat(n), r = parseFloat(o), a = this.layout.size;
        -1 != n.indexOf("%") && (s = s / 100 * a.width), -1 != o.indexOf("%") && (r = r / 100 * a.height), 
        s = isNaN(s) ? 0 : s, r = isNaN(r) ? 0 : r, s -= e ? a.paddingLeft : a.paddingRight, 
        r -= i ? a.paddingTop : a.paddingBottom, this.position.x = s, this.position.y = r;
    }, l.layoutPosition = function() {
        var t = this.layout.size, e = {}, i = this.layout._getOption("originLeft"), n = this.layout._getOption("originTop"), o = i ? "paddingLeft" : "paddingRight", s = i ? "left" : "right", r = i ? "right" : "left", a = this.position.x + t[o];
        e[s] = this.getXValue(a), e[r] = "";
        var l = n ? "paddingTop" : "paddingBottom", c = n ? "top" : "bottom", d = n ? "bottom" : "top", u = this.position.y + t[l];
        e[c] = this.getYValue(u), e[d] = "", this.css(e), this.emitEvent("layout", [ this ]);
    }, l.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px";
    }, l.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px";
    }, l._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x, n = this.position.y, o = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e), !o || this.isTransitioning) {
            var s = t - i, r = e - n, a = {};
            a.transform = this.getTranslate(s, r), this.transition({
                to: a,
                onTransitionEnd: {
                    transform: this.layoutPosition
                },
                isCleaning: !0
            });
        } else this.layoutPosition();
    }, l.getTranslate = function(t, e) {
        return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)";
    }, l.goTo = function(t, e) {
        this.setPosition(t, e), this.layoutPosition();
    }, l.moveTo = l._transitionTo, l.setPosition = function(t, e) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(e);
    }, l._nonTransition = function(t) {
        for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this);
    }, l.transition = function(t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
            var e = this._transn;
            for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
            for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
            if (t.from) {
                this.css(t.from);
                this.element.offsetHeight;
                null;
            }
            this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0;
        } else this._nonTransition(t);
    };
    var c = "opacity," + function(t) {
        return t.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase();
        });
    }(s);
    l.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t, this.css({
                transitionProperty: c,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(r, this, !1);
        }
    }, l.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t);
    }, l.onotransitionend = function(t) {
        this.ontransitionend(t);
    };
    var d = {
        "-webkit-transform": "transform"
    };
    l.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn, i = d[t.propertyName] || t.propertyName;
            if (delete e.ingProperties[i], function(t) {
                for (var e in t) return !1;
                return !0;
            }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", 
            delete e.clean[i]), i in e.onEnd) e.onEnd[i].call(this), delete e.onEnd[i];
            this.emitEvent("transitionEnd", [ this ]);
        }
    }, l.disableTransition = function() {
        this.removeTransitionStyles(), this.element.removeEventListener(r, this, !1), this.isTransitioning = !1;
    }, l._removeStyles = function(t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e);
    };
    var u = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return l.removeTransitionStyles = function() {
        this.css(u);
    }, l.stagger = function(t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms";
    }, l.removeElem = function() {
        this.element.parentNode.removeChild(this.element), this.css({
            display: ""
        }), this.emitEvent("remove", [ this ]);
    }, l.remove = function() {
        return o && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem();
        }), void this.hide()) : void this.removeElem();
    }, l.reveal = function() {
        delete this.isHidden, this.css({
            display: ""
        });
        var t = this.layout.options, e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, 
        this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        });
    }, l.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal");
    }, l.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i;
    }, l.hide = function() {
        this.isHidden = !0, this.css({
            display: ""
        });
        var t = this.layout.options, e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, 
        this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        });
    }, l.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }), this.emitEvent("hide"));
    }, l.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        });
    }, i;
}), function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", [ "ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item" ], function(i, n, o, s) {
        return e(t, i, n, o, s);
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
}(window, function(t, e, i, n, o) {
    "use strict";
    function s(t, e) {
        var i = n.getQueryElement(t);
        if (i) {
            this.element = i, l && (this.$element = l(this.element)), this.options = n.extend({}, this.constructor.defaults), 
            this.option(e);
            var o = ++d;
            this.element.outlayerGUID = o, u[o] = this, this._create(), this._getOption("initLayout") && this.layout();
        } else a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t));
    }
    function r(t) {
        function e() {
            t.apply(this, arguments);
        }
        return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e;
    }
    var a = t.console, l = t.jQuery, c = function() {}, d = 0, u = {};
    s.namespace = "outlayer", s.Item = o, s.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var h = s.prototype;
    n.extend(h, e.prototype), h.option = function(t) {
        n.extend(this.options, t);
    }, h._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
    }, s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, h._create = function() {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), 
        this._getOption("resize") && this.bindResize();
    }, h.reloadItems = function() {
        this.items = this._itemize(this.element.children);
    }, h._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var s = new i(e[o], this);
            n.push(s);
        }
        return n;
    }, h._filterFindItemElements = function(t) {
        return n.filterFindElements(t, this.options.itemSelector);
    }, h.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element;
        });
    }, h.layout = function() {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"), e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), this._isLayoutInited = !0;
    }, h._init = h.layout, h._resetLayout = function() {
        this.getSize();
    }, h.getSize = function() {
        this.size = i(this.element);
    }, h._getMeasurement = function(t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), 
        this[t] = n ? i(n)[e] : o) : this[t] = 0;
    }, h.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout();
    }, h._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored;
        });
    }, h._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t), t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n);
            }, this), this._processLayoutQueue(i);
        }
    }, h._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        };
    }, h._processLayoutQueue = function(t) {
        this.updateStagger(), t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
        }, this);
    }, h.updateStagger = function() {
        var t = this.options.stagger;
        return null == t ? void (this.stagger = 0) : (this.stagger = function(t) {
            if ("number" == typeof t) return t;
            var e = t.match(/(^\d*\.?\d*)(\w*)/), i = e && e[1], n = e && e[2];
            return i.length ? (i = parseFloat(i)) * (p[n] || 1) : 0;
        }(t), this.stagger);
    }, h._positionItem = function(t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
    }, h._postLayout = function() {
        this.resizeContainer();
    }, h.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var t = this._getContainerSize();
            t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1));
        }
    }, h._getContainerSize = c, h._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), 
            t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px";
        }
    }, h._emitCompleteOnItems = function(t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [ e ]);
        }
        function n() {
            ++r == s && i();
        }
        var o = this, s = e.length;
        if (e && s) {
            var r = 0;
            e.forEach(function(e) {
                e.once(t, n);
            });
        } else i();
    }, h.dispatchEvent = function(t, e, i) {
        var n = e ? [ e ].concat(i) : i;
        if (this.emitEvent(t, n), l) if (this.$element = this.$element || l(this.element), 
        e) {
            var o = l.Event(e);
            o.type = t, this.$element.trigger(o, i);
        } else this.$element.trigger(t, i);
    }, h.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
    }, h.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
    }, h.stamp = function(t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this));
    }, h.unstamp = function(t) {
        (t = this._find(t)) && t.forEach(function(t) {
            n.removeFrom(this.stamps, t), this.unignore(t);
        }, this);
    }, h._find = function(t) {
        if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), n.makeArray(t);
    }, h._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
    }, h._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect(), e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        };
    }, h._manageStamp = c, h._getElementOffset = function(t) {
        var e = t.getBoundingClientRect(), n = this._boundingRect, o = i(t);
        return {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        };
    }, h.handleEvent = n.handleEvent, h.bindResize = function() {
        t.addEventListener("resize", this), this.isResizeBound = !0;
    }, h.unbindResize = function() {
        t.removeEventListener("resize", this), this.isResizeBound = !1;
    }, h.onresize = function() {
        this.resize();
    }, n.debounceMethod(s, "onresize", 100), h.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
    }, h.needsResizeLayout = function() {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth;
    }, h.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e;
    }, h.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
    }, h.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), 
            this.reveal(e), this.layoutItems(i);
        }
    }, h.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.reveal();
            });
        }
    }, h.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.hide();
            });
        }
    }, h.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e);
    }, h.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e);
    }, h.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i;
        }
    }, h.getItems = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i);
        }, this), e;
    }, h.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
            t.remove(), n.removeFrom(this.items, t);
        }, this);
    }, h.destroy = function() {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
            t.destroy();
        }), this.unbindResize();
        var e = this.element.outlayerGUID;
        delete u[e], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace);
    }, s.data = function(t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && u[e];
    }, s.create = function(t, e) {
        var i = r(s);
        return i.defaults = n.extend({}, s.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, s.compatOptions), 
        i.namespace = t, i.data = s.data, i.Item = r(o), n.htmlInit(i, t), l && l.bridget && l.bridget(t, i), 
        i;
    };
    var p = {
        ms: 1,
        s: 1e3
    };
    return s.Item = o, s;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/item", [ "outlayer/outlayer" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer")) : (t.Isotope = t.Isotope || {}, 
    t.Isotope.Item = e(t.Outlayer));
}(window, function(t) {
    "use strict";
    function e() {
        t.Item.apply(this, arguments);
    }
    var i = e.prototype = Object.create(t.Item.prototype), n = i._create;
    i._create = function() {
        this.id = this.layout.itemGUID++, n.call(this), this.sortData = {};
    }, i.updateSortData = function() {
        if (!this.isIgnored) {
            this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
            var t = this.layout.options.getSortData, e = this.layout._sorters;
            for (var i in t) {
                var n = e[i];
                this.sortData[i] = n(this.element, this);
            }
        }
    };
    var o = i.destroy;
    return i.destroy = function() {
        o.apply(this, arguments), this.css({
            display: ""
        });
    }, e;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-mode", [ "get-size/get-size", "outlayer/outlayer" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("get-size"), require("outlayer")) : (t.Isotope = t.Isotope || {}, 
    t.Isotope.LayoutMode = e(t.getSize, t.Outlayer));
}(window, function(t, e) {
    "use strict";
    function i(t) {
        this.isotope = t, t && (this.options = t.options[this.namespace], this.element = t.element, 
        this.items = t.filteredItems, this.size = t.size);
    }
    var n = i.prototype;
    return [ "_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption" ].forEach(function(t) {
        n[t] = function() {
            return e.prototype[t].apply(this.isotope, arguments);
        };
    }), n.needsVerticalResizeLayout = function() {
        var e = t(this.isotope.element);
        return this.isotope.size && e && e.innerHeight != this.isotope.size.innerHeight;
    }, n._getMeasurement = function() {
        this.isotope._getMeasurement.apply(this, arguments);
    }, n.getColumnWidth = function() {
        this.getSegmentSize("column", "Width");
    }, n.getRowHeight = function() {
        this.getSegmentSize("row", "Height");
    }, n.getSegmentSize = function(t, e) {
        var i = t + e, n = "outer" + e;
        if (this._getMeasurement(i, n), !this[i]) {
            var o = this.getFirstItemSize();
            this[i] = o && o[n] || this.isotope.size["inner" + e];
        }
    }, n.getFirstItemSize = function() {
        var e = this.isotope.filteredItems[0];
        return e && e.element && t(e.element);
    }, n.layout = function() {
        this.isotope.layout.apply(this.isotope, arguments);
    }, n.getSize = function() {
        this.isotope.getSize(), this.size = this.isotope.size;
    }, i.modes = {}, i.create = function(t, e) {
        function o() {
            i.apply(this, arguments);
        }
        return o.prototype = Object.create(n), o.prototype.constructor = o, e && (o.options = e), 
        o.prototype.namespace = t, i.modes[t] = o, o;
    }, i;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("masonry-layout/masonry", [ "outlayer/outlayer", "get-size/get-size" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize);
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return n._resetLayout = function() {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), 
        this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0;
    }, n.measureColumns = function() {
        if (this.getContainerWidth(), !this.columnWidth) {
            var t = this.items[0], i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth;
        }
        var n = this.columnWidth += this.gutter, o = this.containerWidth + this.gutter, s = o / n, r = n - o % n;
        s = Math[r && r < 1 ? "round" : "floor"](s), this.cols = Math.max(s, 1);
    }, n.getContainerWidth = function() {
        var t = this._getOption("fitWidth") ? this.element.parentNode : this.element, i = e(t);
        this.containerWidth = i && i.innerWidth;
    }, n._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth, i = Math[e && e < 1 ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
        i = Math.min(i, this.cols);
        for (var n = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](i, t), o = {
            x: this.columnWidth * n.col,
            y: n.y
        }, s = n.y + t.size.outerHeight, r = i + n.col, a = n.col; a < r; a++) this.colYs[a] = s;
        return o;
    }, n._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t), i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        };
    }, n._getTopColGroup = function(t) {
        if (t < 2) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++) e[n] = this._getColGroupY(n, t);
        return e;
    }, n._getColGroupY = function(t, e) {
        if (e < 2) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i);
    }, n._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
            col: i,
            y: this._getColGroupY(i, t)
        };
    }, n._manageStamp = function(t) {
        var i = e(t), n = this._getElementOffset(t), o = this._getOption("originLeft") ? n.left : n.right, s = o + i.outerWidth, r = Math.floor(o / this.columnWidth);
        r = Math.max(0, r);
        var a = Math.floor(s / this.columnWidth);
        a -= s % this.columnWidth ? 0 : 1, a = Math.min(this.cols - 1, a);
        for (var l = (this._getOption("originTop") ? n.top : n.bottom) + i.outerHeight, c = r; c <= a; c++) this.colYs[c] = Math.max(l, this.colYs[c]);
    }, n._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), 
        t;
    }, n._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
    }, n.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth;
    }, i;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/masonry", [ "../layout-mode", "masonry-layout/masonry" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode"), require("masonry-layout")) : e(t.Isotope.LayoutMode, t.Masonry);
}(window, function(t, e) {
    "use strict";
    var i = t.create("masonry"), n = i.prototype, o = {
        _getElementOffset: !0,
        layout: !0,
        _getMeasurement: !0
    };
    for (var s in e.prototype) o[s] || (n[s] = e.prototype[s]);
    var r = n.measureColumns;
    n.measureColumns = function() {
        this.items = this.isotope.filteredItems, r.call(this);
    };
    var a = n._getOption;
    return n._getOption = function(t) {
        return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : a.apply(this.isotope, arguments);
    }, i;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/fit-rows", [ "../layout-mode" ], e) : "object" == typeof exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode);
}(window, function(t) {
    "use strict";
    var e = t.create("fitRows"), i = e.prototype;
    return i._resetLayout = function() {
        this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth");
    }, i._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth + this.gutter, i = this.isotope.size.innerWidth + this.gutter;
        0 !== this.x && e + this.x > i && (this.x = 0, this.y = this.maxY);
        var n = {
            x: this.x,
            y: this.y
        };
        return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight), this.x += e, 
        n;
    }, i._getContainerSize = function() {
        return {
            height: this.maxY
        };
    }, e;
}), function(t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/vertical", [ "../layout-mode" ], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode);
}(window, function(t) {
    "use strict";
    var e = t.create("vertical", {
        horizontalAlignment: 0
    }), i = e.prototype;
    return i._resetLayout = function() {
        this.y = 0;
    }, i._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment, i = this.y;
        return this.y += t.size.outerHeight, {
            x: e,
            y: i
        };
    }, i._getContainerSize = function() {
        return {
            height: this.y
        };
    }, e;
}), function(t, e) {
    "function" == typeof define && define.amd ? define([ "outlayer/outlayer", "get-size/get-size", "desandro-matches-selector/matches-selector", "fizzy-ui-utils/utils", "isotope-layout/js/item", "isotope-layout/js/layout-mode", "isotope-layout/js/layout-modes/masonry", "isotope-layout/js/layout-modes/fit-rows", "isotope-layout/js/layout-modes/vertical" ], function(i, n, o, s, r, a) {
        return e(t, i, n, o, s, r, a);
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("outlayer"), require("get-size"), require("desandro-matches-selector"), require("fizzy-ui-utils"), require("isotope-layout/js/item"), require("isotope-layout/js/layout-mode"), require("isotope-layout/js/layout-modes/masonry"), require("isotope-layout/js/layout-modes/fit-rows"), require("isotope-layout/js/layout-modes/vertical")) : t.Isotope = e(t, t.Outlayer, t.getSize, t.matchesSelector, t.fizzyUIUtils, t.Isotope.Item, t.Isotope.LayoutMode);
}(window, function(t, e, i, n, o, s, r) {
    var a = t.jQuery, l = String.prototype.trim ? function(t) {
        return t.trim();
    } : function(t) {
        return t.replace(/^\s+|\s+$/g, "");
    }, c = e.create("isotope", {
        layoutMode: "masonry",
        isJQueryFiltering: !0,
        sortAscending: !0
    });
    c.Item = s, c.LayoutMode = r;
    var d = c.prototype;
    d._create = function() {
        for (var t in this.itemGUID = 0, this._sorters = {}, this._getSorters(), e.prototype._create.call(this), 
        this.modes = {}, this.filteredItems = this.items, this.sortHistory = [ "original-order" ], 
        r.modes) this._initLayoutMode(t);
    }, d.reloadItems = function() {
        this.itemGUID = 0, e.prototype.reloadItems.call(this);
    }, d._itemize = function() {
        for (var t = e.prototype._itemize.apply(this, arguments), i = 0; i < t.length; i++) {
            t[i].id = this.itemGUID++;
        }
        return this._updateItemsSortData(t), t;
    }, d._initLayoutMode = function(t) {
        var e = r.modes[t], i = this.options[t] || {};
        this.options[t] = e.options ? o.extend(e.options, i) : i, this.modes[t] = new e(this);
    }, d.layout = function() {
        return !this._isLayoutInited && this._getOption("initLayout") ? void this.arrange() : void this._layout();
    }, d._layout = function() {
        var t = this._getIsInstant();
        this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, t), 
        this._isLayoutInited = !0;
    }, d.arrange = function(t) {
        this.option(t), this._getIsInstant();
        var e = this._filter(this.items);
        this.filteredItems = e.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [ e ]) : this._hideReveal(e), 
        this._sort(), this._layout();
    }, d._init = d.arrange, d._hideReveal = function(t) {
        this.reveal(t.needReveal), this.hide(t.needHide);
    }, d._getIsInstant = function() {
        var t = this._getOption("layoutInstant"), e = void 0 !== t ? t : !this._isLayoutInited;
        return this._isInstant = e, e;
    }, d._bindArrangeComplete = function() {
        function t() {
            e && i && n && o.dispatchEvent("arrangeComplete", null, [ o.filteredItems ]);
        }
        var e, i, n, o = this;
        this.once("layoutComplete", function() {
            e = !0, t();
        }), this.once("hideComplete", function() {
            i = !0, t();
        }), this.once("revealComplete", function() {
            n = !0, t();
        });
    }, d._filter = function(t) {
        var e = this.options.filter;
        e = e || "*";
        for (var i = [], n = [], o = [], s = this._getFilterTest(e), r = 0; r < t.length; r++) {
            var a = t[r];
            if (!a.isIgnored) {
                var l = s(a);
                l && i.push(a), l && a.isHidden ? n.push(a) : l || a.isHidden || o.push(a);
            }
        }
        return {
            matches: i,
            needReveal: n,
            needHide: o
        };
    }, d._getFilterTest = function(t) {
        return a && this.options.isJQueryFiltering ? function(e) {
            return a(e.element).is(t);
        } : "function" == typeof t ? function(e) {
            return t(e.element);
        } : function(e) {
            return n(e.element, t);
        };
    }, d.updateSortData = function(t) {
        var e;
        t ? (t = o.makeArray(t), e = this.getItems(t)) : e = this.items, this._getSorters(), 
        this._updateItemsSortData(e);
    }, d._getSorters = function() {
        var t = this.options.getSortData;
        for (var e in t) {
            var i = t[e];
            this._sorters[e] = u(i);
        }
    }, d._updateItemsSortData = function(t) {
        for (var e = t && t.length, i = 0; e && i < e; i++) {
            t[i].updateSortData();
        }
    };
    var u = function() {
        return function(t) {
            if ("string" != typeof t) return t;
            var e = l(t).split(" "), i = e[0], n = i.match(/^\[(.+)\]$/), o = function(t, e) {
                return t ? function(e) {
                    return e.getAttribute(t);
                } : function(t) {
                    var i = t.querySelector(e);
                    return i && i.textContent;
                };
            }(n && n[1], i), s = c.sortDataParsers[e[1]];
            return s ? function(t) {
                return t && s(o(t));
            } : function(t) {
                return t && o(t);
            };
        };
    }();
    c.sortDataParsers = {
        parseInt: function(t) {
            return parseInt(t, 10);
        },
        parseFloat: function(t) {
            return parseFloat(t);
        }
    }, d._sort = function() {
        if (this.options.sortBy) {
            var t = o.makeArray(this.options.sortBy);
            this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory));
            var e = function(t, e) {
                return function(i, n) {
                    for (var o = 0; o < t.length; o++) {
                        var s = t[o], r = i.sortData[s], a = n.sortData[s];
                        if (r > a || r < a) return (r > a ? 1 : -1) * ((void 0 !== e[s] ? e[s] : e) ? 1 : -1);
                    }
                    return 0;
                };
            }(this.sortHistory, this.options.sortAscending);
            this.filteredItems.sort(e);
        }
    }, d._getIsSameSortBy = function(t) {
        for (var e = 0; e < t.length; e++) if (t[e] != this.sortHistory[e]) return !1;
        return !0;
    }, d._mode = function() {
        var t = this.options.layoutMode, e = this.modes[t];
        if (!e) throw new Error("No layout mode: " + t);
        return e.options = this.options[t], e;
    }, d._resetLayout = function() {
        e.prototype._resetLayout.call(this), this._mode()._resetLayout();
    }, d._getItemLayoutPosition = function(t) {
        return this._mode()._getItemLayoutPosition(t);
    }, d._manageStamp = function(t) {
        this._mode()._manageStamp(t);
    }, d._getContainerSize = function() {
        return this._mode()._getContainerSize();
    }, d.needsResizeLayout = function() {
        return this._mode().needsResizeLayout();
    }, d.appended = function(t) {
        var e = this.addItems(t);
        if (e.length) {
            var i = this._filterRevealAdded(e);
            this.filteredItems = this.filteredItems.concat(i);
        }
    }, d.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            this._resetLayout(), this._manageStamps();
            var i = this._filterRevealAdded(e);
            this.layoutItems(this.filteredItems), this.filteredItems = i.concat(this.filteredItems), 
            this.items = e.concat(this.items);
        }
    }, d._filterRevealAdded = function(t) {
        var e = this._filter(t);
        return this.hide(e.needHide), this.reveal(e.matches), this.layoutItems(e.matches, !0), 
        e.matches;
    }, d.insert = function(t) {
        var e = this.addItems(t);
        if (e.length) {
            var i, n, o = e.length;
            for (i = 0; i < o; i++) n = e[i], this.element.appendChild(n.element);
            var s = this._filter(e).matches;
            for (i = 0; i < o; i++) e[i].isLayoutInstant = !0;
            for (this.arrange(), i = 0; i < o; i++) delete e[i].isLayoutInstant;
            this.reveal(s);
        }
    };
    var h = d.remove;
    return d.remove = function(t) {
        t = o.makeArray(t);
        var e = this.getItems(t);
        h.call(this, t);
        for (var i = e && e.length, n = 0; i && n < i; n++) {
            var s = e[n];
            o.removeFrom(this.filteredItems, s);
        }
    }, d.shuffle = function() {
        for (var t = 0; t < this.items.length; t++) {
            this.items[t].sortData.random = Math.random();
        }
        this.options.sortBy = "random", this._sort(), this._layout();
    }, d._noTransition = function(t, e) {
        var i = this.options.transitionDuration;
        this.options.transitionDuration = 0;
        var n = t.apply(this, e);
        return this.options.transitionDuration = i, n;
    }, d.getFilteredItemElements = function() {
        return this.filteredItems.map(function(t) {
            return t.element;
        });
    }, c;
}), function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define([ "jquery" ], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery);
}(function(t) {
    "use strict";
    var e = window.Slick || {};
    (e = function() {
        var e = 0;
        return function(i, n) {
            var o, s = this;
            s.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: t(i),
                appendDots: t(i),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, i) {
                    return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, s.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, t.extend(s, s.initials), s.activeBreakpoint = null, s.animType = null, s.animProp = null, 
            s.breakpoints = [], s.breakpointSettings = [], s.cssTransitions = !1, s.focussed = !1, 
            s.interrupted = !1, s.hidden = "hidden", s.paused = !0, s.positionProp = null, s.respondTo = null, 
            s.rowCount = 1, s.shouldClick = !0, s.$slider = t(i), s.$slidesCache = null, s.transformType = null, 
            s.transitionType = null, s.visibilityChange = "visibilitychange", s.windowWidth = 0, 
            s.windowTimer = null, o = t(i).data("slick") || {}, s.options = t.extend({}, s.defaults, n, o), 
            s.currentSlide = s.options.initialSlide, s.originalSettings = s.options, void 0 !== document.mozHidden ? (s.hidden = "mozHidden", 
            s.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (s.hidden = "webkitHidden", 
            s.visibilityChange = "webkitvisibilitychange"), s.autoPlay = t.proxy(s.autoPlay, s), 
            s.autoPlayClear = t.proxy(s.autoPlayClear, s), s.autoPlayIterator = t.proxy(s.autoPlayIterator, s), 
            s.changeSlide = t.proxy(s.changeSlide, s), s.clickHandler = t.proxy(s.clickHandler, s), 
            s.selectHandler = t.proxy(s.selectHandler, s), s.setPosition = t.proxy(s.setPosition, s), 
            s.swipeHandler = t.proxy(s.swipeHandler, s), s.dragHandler = t.proxy(s.dragHandler, s), 
            s.keyHandler = t.proxy(s.keyHandler, s), s.instanceUid = e++, s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, 
            s.registerBreakpoints(), s.init(!0);
        };
    }()).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        });
    }, e.prototype.addSlide = e.prototype.slickAdd = function(e, i, n) {
        var o = this;
        if ("boolean" == typeof i) n = i, i = null; else if (0 > i || i >= o.slideCount) return !1;
        o.unload(), "number" == typeof i ? 0 === i && 0 === o.$slides.length ? t(e).appendTo(o.$slideTrack) : n ? t(e).insertBefore(o.$slides.eq(i)) : t(e).insertAfter(o.$slides.eq(i)) : !0 === n ? t(e).prependTo(o.$slideTrack) : t(e).appendTo(o.$slideTrack), 
        o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), 
        o.$slideTrack.append(o.$slides), o.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e);
        }), o.$slidesCache = o.$slides, o.reinit();
    }, e.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed);
        }
    }, e.prototype.animateSlide = function(e, i) {
        var n = {}, o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (e = -e), 
        !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: e
        }, o.options.speed, o.options.easing, i) : o.$slideTrack.animate({
            top: e
        }, o.options.speed, o.options.easing, i) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), 
        t({
            animStart: o.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(t) {
                t = Math.ceil(t), !1 === o.options.vertical ? (n[o.animType] = "translate(" + t + "px, 0px)", 
                o.$slideTrack.css(n)) : (n[o.animType] = "translate(0px," + t + "px)", o.$slideTrack.css(n));
            },
            complete: function() {
                i && i.call();
            }
        })) : (o.applyTransition(), e = Math.ceil(e), !1 === o.options.vertical ? n[o.animType] = "translate3d(" + e + "px, 0px, 0px)" : n[o.animType] = "translate3d(0px," + e + "px, 0px)", 
        o.$slideTrack.css(n), i && setTimeout(function() {
            o.disableTransition(), i.call();
        }, o.options.speed));
    }, e.prototype.getNavTarget = function() {
        var e = this.options.asNavFor;
        return e && null !== e && (e = t(e).not(this.$slider)), e;
    }, e.prototype.asNavFor = function(e) {
        var i = this.getNavTarget();
        null !== i && "object" == typeof i && i.each(function() {
            var i = t(this).slick("getSlick");
            i.unslicked || i.slideHandler(e, !0);
        });
    }, e.prototype.applyTransition = function(t) {
        var e = this, i = {};
        !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, 
        !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
    }, e.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed));
    }, e.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
    }, e.prototype.autoPlayIterator = function() {
        var t = this, e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, 
        t.currentSlide - 1 == 0 && (t.direction = 1))), t.slideHandler(e));
    }, e.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), 
        e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), 
        e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), 
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), 
        !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }));
    }, e.prototype.buildDots = function() {
        var e, i, n = this;
        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
            for (n.$slider.addClass("slick-dotted"), i = t("<ul />").addClass(n.options.dotsClass), 
            e = 0; e <= n.getDotCount(); e += 1) i.append(t("<li />").append(n.options.customPaging.call(this, n, e)));
            n.$dots = i.appendTo(n.options.appendDots), n.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
        }
    }, e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), 
        e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "");
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), 
        e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), 
        e.$slideTrack.css("opacity", 0), (!0 === e.options.centerMode || !0 === e.options.swipeToSlide) && (e.options.slidesToScroll = 1), 
        t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), 
        e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), 
        !0 === e.options.draggable && e.$list.addClass("draggable");
    }, e.prototype.buildRows = function() {
        var t, e, i, n, o, s, r, a = this;
        if (n = document.createDocumentFragment(), s = a.$slider.children(), a.options.rows > 1) {
            for (r = a.options.slidesPerRow * a.options.rows, o = Math.ceil(s.length / r), t = 0; o > t; t++) {
                var l = document.createElement("div");
                for (e = 0; e < a.options.rows; e++) {
                    var c = document.createElement("div");
                    for (i = 0; i < a.options.slidesPerRow; i++) {
                        var d = t * r + (e * a.options.slidesPerRow + i);
                        s.get(d) && c.appendChild(s.get(d));
                    }
                    l.appendChild(c);
                }
                n.appendChild(l);
            }
            a.$slider.empty().append(n), a.$slider.children().children().children().css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block"
            });
        }
    }, e.prototype.checkResponsive = function(e, i) {
        var n, o, s, r = this, a = !1, l = r.$slider.width(), c = window.innerWidth || t(window).width();
        if ("window" === r.respondTo ? s = c : "slider" === r.respondTo ? s = l : "min" === r.respondTo && (s = Math.min(c, l)), 
        r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (n in o = null, r.breakpoints) r.breakpoints.hasOwnProperty(n) && (!1 === r.originalSettings.mobileFirst ? s < r.breakpoints[n] && (o = r.breakpoints[n]) : s > r.breakpoints[n] && (o = r.breakpoints[n]));
            null !== o ? null !== r.activeBreakpoint ? (o !== r.activeBreakpoint || i) && (r.activeBreakpoint = o, 
            "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), 
            !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : (r.activeBreakpoint = o, 
            "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), 
            !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, 
            r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), 
            r.refresh(e), a = o), e || !1 === a || r.$slider.trigger("breakpoint", [ r, a ]);
        }
    }, e.prototype.changeSlide = function(e, i) {
        var n, o, s = this, r = t(e.currentTarget);
        switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), n = s.slideCount % s.options.slidesToScroll != 0 ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, 
        e.data.message) {
          case "previous":
            o = 0 === n ? s.options.slidesToScroll : s.options.slidesToShow - n, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, i);
            break;

          case "next":
            o = 0 === n ? s.options.slidesToScroll : n, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, i);
            break;

          case "index":
            var a = 0 === e.data.index ? 0 : e.data.index || r.index() * s.options.slidesToScroll;
            s.slideHandler(s.checkNavigable(a), !1, i), r.children().trigger("focus");
            break;

          default:
            return;
        }
    }, e.prototype.checkNavigable = function(t) {
        var e, i;
        if (i = 0, t > (e = this.getNavigableIndexes())[e.length - 1]) t = e[e.length - 1]; else for (var n in e) {
            if (t < e[n]) {
                t = i;
                break;
            }
            i = e[n];
        }
        return t;
    }, e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && t("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", t.proxy(e.interrupt, e, !0)).off("mouseleave.slick", t.proxy(e.interrupt, e, !1)), 
        e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), 
        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), 
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), 
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), 
        t(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), 
        !0 === e.options.focusOnSelect && t(e.$slideTrack).children().off("click.slick", e.selectHandler), 
        t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), 
        t(window).off("resize.slick.slick-" + e.instanceUid, e.resize), t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), 
        t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
    }, e.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1));
    }, e.prototype.cleanUpRows = function() {
        var t, e = this;
        e.options.rows > 1 && ((t = e.$slides.children().children()).removeAttr("style"), 
        e.$slider.empty().append(t));
    }, e.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
    }, e.prototype.destroy = function(e) {
        var i = this;
        i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), 
        i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), 
        i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), 
        i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"));
        }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), 
        i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), 
        i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), 
        i.unslicked = !0, e || i.$slider.trigger("destroy", [ i ]);
    }, e.prototype.disableTransition = function(t) {
        var e = this, i = {};
        i[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
    }, e.prototype.fadeSlide = function(t, e) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), e && setTimeout(function() {
            i.disableTransition(t), e.call();
        }, i.options.speed));
    }, e.prototype.fadeSlideOut = function(t) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(t).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }));
    }, e.prototype.filterSlides = e.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), 
        e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit());
    }, e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(i) {
            i.stopImmediatePropagation();
            var n = t(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = n.is(":focus"), e.autoPlay());
            }, 0);
        });
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        return this.currentSlide;
    }, e.prototype.getDotCount = function() {
        var t = this, e = 0, i = 0, n = 0;
        if (!0 === t.options.infinite) for (;e < t.slideCount; ) ++n, e = i + t.options.slidesToScroll, 
        i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow; else if (!0 === t.options.centerMode) n = t.slideCount; else if (t.options.asNavFor) for (;e < t.slideCount; ) ++n, 
        e = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow; else n = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
        return n - 1;
    }, e.prototype.getLeft = function(t) {
        var e, i, n, o = this, s = 0;
        return o.slideOffset = 0, i = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, 
        s = i * o.options.slidesToShow * -1), o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (t > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1, 
        s = (o.options.slidesToShow - (t - o.slideCount)) * i * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, 
        s = o.slideCount % o.options.slidesToScroll * i * -1))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth, 
        s = (t + o.options.slidesToShow - o.slideCount) * i), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, 
        s = 0), !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, 
        o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), e = !1 === o.options.vertical ? t * o.slideWidth * -1 + o.slideOffset : t * i * -1 + s, 
        !0 === o.options.variableWidth && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow), 
        e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, 
        !0 === o.options.centerMode && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1), 
        e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, 
        e += (o.$list.width() - n.outerWidth()) / 2)), e;
    }, e.prototype.getOption = e.prototype.slickGetOption = function(t) {
        return this.options[t];
    }, e.prototype.getNavigableIndexes = function() {
        var t, e = this, i = 0, n = 0, o = [];
        for (!1 === e.options.infinite ? t = e.slideCount : (i = -1 * e.options.slidesToScroll, 
        n = -1 * e.options.slidesToScroll, t = 2 * e.slideCount); t > i; ) o.push(i), i = n + e.options.slidesToScroll, 
        n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return o;
    }, e.prototype.getSlick = function() {
        return this;
    }, e.prototype.getSlideCount = function() {
        var e, i, n = this;
        return i = !0 === n.options.centerMode ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0, 
        !0 === n.options.swipeToSlide ? (n.$slideTrack.find(".slick-slide").each(function(o, s) {
            return s.offsetLeft - i + t(s).outerWidth() / 2 > -1 * n.swipeLeft ? (e = s, !1) : void 0;
        }), Math.abs(t(e).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll;
    }, e.prototype.goTo = e.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e);
    }, e.prototype.init = function(e) {
        var i = this;
        t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), 
        i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), 
        i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), e && i.$slider.trigger("init", [ i ]), 
        !0 === i.options.accessibility && i.initADA(), i.options.autoplay && (i.paused = !1, 
        i.autoPlay());
    }, e.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
            t(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + i
            });
        }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
            t(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + i,
                id: "slick-slide" + e.instanceUid + i
            });
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), 
        e.activateADA();
    }, e.prototype.initArrowEvents = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, t.changeSlide), t.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, t.changeSlide));
    }, e.prototype.initDotEvents = function() {
        var e = this;
        !0 === e.options.dots && e.slideCount > e.options.slidesToShow && t("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.interrupt, e, !0)).on("mouseleave.slick", t.proxy(e.interrupt, e, !1));
    }, e.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)), 
        e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)));
    }, e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), t(document).on(e.visibilityChange, t.proxy(e.visibility, e)), 
        !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), 
        t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)), 
        t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)), t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), 
        t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
    }, e.prototype.initUI = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), 
        t.$nextArrow.show()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show();
    }, e.prototype.keyHandler = function(t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }));
    }, e.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this), i = t(this).attr("data-lazy"), n = document.createElement("img");
                n.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        e.attr("src", i).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy").removeClass("slick-loading");
                        }), o.$slider.trigger("lazyLoaded", [ o, e, i ]);
                    });
                }, n.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), 
                    o.$slider.trigger("lazyLoadError", [ o, e, i ]);
                }, n.src = i;
            });
        }
        var i, n, o = this;
        !0 === o.options.centerMode ? !0 === o.options.infinite ? n = (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)), 
        n = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide, 
        n = Math.ceil(i + o.options.slidesToShow), !0 === o.options.fade && (i > 0 && i--, 
        n <= o.slideCount && n++)), e(o.$slider.find(".slick-slide").slice(i, n)), o.slideCount <= o.options.slidesToShow ? e(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? e(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && e(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
    }, e.prototype.loadSlider = function() {
        var t = this;
        t.setPosition(), t.$slideTrack.css({
            opacity: 1
        }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad();
    }, e.prototype.next = e.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        });
    }, e.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition();
    }, e.prototype.pause = e.prototype.slickPause = function() {
        this.autoPlayClear(), this.paused = !0;
    }, e.prototype.play = e.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1;
    }, e.prototype.postSlide = function(t) {
        var e = this;
        e.unslicked || (e.$slider.trigger("afterChange", [ e, t ]), e.animating = !1, e.setPosition(), 
        e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA());
    }, e.prototype.prev = e.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        });
    }, e.prototype.preventDefault = function(t) {
        t.preventDefault();
    }, e.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var i, n, o, s = this, r = t("img[data-lazy]", s.$slider);
        r.length ? (i = r.first(), n = i.attr("data-lazy"), (o = document.createElement("img")).onload = function() {
            i.attr("src", n).removeAttr("data-lazy").removeClass("slick-loading"), !0 === s.options.adaptiveHeight && s.setPosition(), 
            s.$slider.trigger("lazyLoaded", [ s, i, n ]), s.progressiveLazyLoad();
        }, o.onerror = function() {
            3 > e ? setTimeout(function() {
                s.progressiveLazyLoad(e + 1);
            }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), 
            s.$slider.trigger("lazyLoadError", [ s, i, n ]), s.progressiveLazyLoad());
        }, o.src = n) : s.$slider.trigger("allImagesLoaded", [ s ]);
    }, e.prototype.refresh = function(e) {
        var i, n, o = this;
        n = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > n && (o.currentSlide = n), 
        o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), i = o.currentSlide, 
        o.destroy(!0), t.extend(o, o.initials, {
            currentSlide: i
        }), o.init(), e || o.changeSlide({
            data: {
                message: "index",
                index: i
            }
        }, !1);
    }, e.prototype.registerBreakpoints = function() {
        var e, i, n, o = this, s = o.options.responsive || null;
        if ("array" === t.type(s) && s.length) {
            for (e in o.respondTo = o.options.respondTo || "window", s) if (n = o.breakpoints.length - 1, 
            i = s[e].breakpoint, s.hasOwnProperty(e)) {
                for (;n >= 0; ) o.breakpoints[n] && o.breakpoints[n] === i && o.breakpoints.splice(n, 1), 
                n--;
                o.breakpoints.push(i), o.breakpointSettings[i] = s[e].settings;
            }
            o.breakpoints.sort(function(t, e) {
                return o.options.mobileFirst ? t - e : e - t;
            });
        }
    }, e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, 
        e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), 
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), 
        e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), 
        e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), 
        e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), 
        e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), 
        e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [ e ]);
    }, e.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
        }, 50));
    }, e.prototype.removeSlide = e.prototype.slickRemove = function(t, e, i) {
        var n = this;
        return "boolean" == typeof t ? t = !0 === (e = t) ? 0 : n.slideCount - 1 : t = !0 === e ? --t : t, 
        !(n.slideCount < 1 || 0 > t || t > n.slideCount - 1) && (n.unload(), !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(t).remove(), 
        n.$slides = n.$slideTrack.children(this.options.slide), n.$slideTrack.children(this.options.slide).detach(), 
        n.$slideTrack.append(n.$slides), n.$slidesCache = n.$slides, void n.reinit());
    }, e.prototype.setCSS = function(t) {
        var e, i, n = this, o = {};
        !0 === n.options.rtl && (t = -t), e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px", 
        i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px", o[n.positionProp] = t, 
        !1 === n.transformsEnabled ? n.$slideTrack.css(o) : (o = {}, !1 === n.cssTransitions ? (o[n.animType] = "translate(" + e + ", " + i + ")", 
        n.$slideTrack.css(o)) : (o[n.animType] = "translate3d(" + e + ", " + i + ", 0px)", 
        n.$slideTrack.css(o)));
    }, e.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), 
        !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), 
        t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), 
        t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e);
    }, e.prototype.setFade = function() {
        var e, i = this;
        i.$slides.each(function(n, o) {
            e = i.slideWidth * n * -1, !0 === i.options.rtl ? t(o).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            }) : t(o).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            });
        }), i.$slides.eq(i.currentSlide).css({
            zIndex: i.options.zIndex - 1,
            opacity: 1
        });
    }, e.prototype.setHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e);
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function() {
        var e, i, n, o, s, r = this, a = !1;
        if ("object" === t.type(arguments[0]) ? (n = arguments[0], a = arguments[1], s = "multiple") : "string" === t.type(arguments[0]) && (n = arguments[0], 
        o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? s = "responsive" : void 0 !== arguments[1] && (s = "single")), 
        "single" === s) r.options[n] = o; else if ("multiple" === s) t.each(n, function(t, e) {
            r.options[t] = e;
        }); else if ("responsive" === s) for (i in o) if ("array" !== t.type(r.options.responsive)) r.options.responsive = [ o[i] ]; else {
            for (e = r.options.responsive.length - 1; e >= 0; ) r.options.responsive[e].breakpoint === o[i].breakpoint && r.options.responsive.splice(e, 1), 
            e--;
            r.options.responsive.push(o[i]);
        }
        a && (r.unload(), r.reinit());
    }, e.prototype.setPosition = function() {
        var t = this;
        t.setDimensions(), t.setHeight(), !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), 
        t.$slider.trigger("setPosition", [ t ]);
    }, e.prototype.setProps = function() {
        var t = this, e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), 
        (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && !0 === t.options.useCSS && (t.cssTransitions = !0), 
        t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), 
        void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", 
        t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), 
        void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", 
        t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), 
        void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", 
        t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), 
        void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", 
        t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), 
        void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform", t.transformType = "transform", 
        t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType;
    }, e.prototype.setSlideClasses = function(t) {
        var e, i, n, o, s = this;
        i = s.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), 
        s.$slides.eq(t).addClass("slick-current"), !0 === s.options.centerMode ? (e = Math.floor(s.options.slidesToShow / 2), 
        !0 === s.options.infinite && (t >= e && t <= s.slideCount - 1 - e ? s.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = s.options.slidesToShow + t, 
        i.slice(n - e + 1, n + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 
        0 === t ? i.eq(i.length - 1 - s.options.slidesToShow).addClass("slick-center") : t === s.slideCount - 1 && i.eq(s.options.slidesToShow).addClass("slick-center")), 
        s.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= s.slideCount - s.options.slidesToShow ? s.$slides.slice(t, t + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= s.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = s.slideCount % s.options.slidesToShow, 
        n = !0 === s.options.infinite ? s.options.slidesToShow + t : t, s.options.slidesToShow == s.options.slidesToScroll && s.slideCount - t < s.options.slidesToShow ? i.slice(n - (s.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), 
        "ondemand" === s.options.lazyLoad && s.lazyLoad();
    }, e.prototype.setupInfinite = function() {
        var e, i, n, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (i = null, 
        o.slideCount > o.options.slidesToShow)) {
            for (n = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, 
            e = o.slideCount; e > o.slideCount - n; e -= 1) i = e - 1, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (e = 0; n > e; e += 1) i = e, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "");
            });
        }
    }, e.prototype.interrupt = function(t) {
        t || this.autoPlay(), this.interrupted = t;
    }, e.prototype.selectHandler = function(e) {
        var i = this, n = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide"), o = parseInt(n.attr("data-slick-index"));
        return o || (o = 0), i.slideCount <= i.options.slidesToShow ? (i.setSlideClasses(o), 
        void i.asNavFor(o)) : void i.slideHandler(o);
    }, e.prototype.slideHandler = function(t, e, i) {
        var n, o, s, r, a, l = null, c = this;
        return e = e || !1, !0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === t || c.slideCount <= c.options.slidesToShow ? void 0 : (!1 === e && c.asNavFor(t), 
        n = t, l = c.getLeft(n), r = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft, 
        !1 === c.options.infinite && !1 === c.options.centerMode && (0 > t || t > c.getDotCount() * c.options.slidesToScroll) ? void (!1 === c.options.fade && (n = c.currentSlide, 
        !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n);
        }) : c.postSlide(n))) : !1 === c.options.infinite && !0 === c.options.centerMode && (0 > t || t > c.slideCount - c.options.slidesToScroll) ? void (!1 === c.options.fade && (n = c.currentSlide, 
        !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n);
        }) : c.postSlide(n))) : (c.options.autoplay && clearInterval(c.autoPlayTimer), o = 0 > n ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n, 
        c.animating = !0, c.$slider.trigger("beforeChange", [ c, c.currentSlide, o ]), s = c.currentSlide, 
        c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && ((a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide)), 
        c.updateDots(), c.updateArrows(), !0 === c.options.fade ? (!0 !== i ? (c.fadeSlideOut(s), 
        c.fadeSlide(o, function() {
            c.postSlide(o);
        })) : c.postSlide(o), void c.animateHeight()) : void (!0 !== i ? c.animateSlide(l, function() {
            c.postSlide(o);
        }) : c.postSlide(o))));
    }, e.prototype.startLoad = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), 
        t.$nextArrow.hide()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(), 
        t.$slider.addClass("slick-loading");
    }, e.prototype.swipeDirection = function() {
        var t, e, i, n, o = this;
        return t = o.touchObject.startX - o.touchObject.curX, e = o.touchObject.startY - o.touchObject.curY, 
        i = Math.atan2(e, t), 0 > (n = Math.round(180 * i / Math.PI)) && (n = 360 - Math.abs(n)), 
        45 >= n && n >= 0 ? !1 === o.options.rtl ? "left" : "right" : 360 >= n && n >= 315 ? !1 === o.options.rtl ? "left" : "right" : n >= 135 && 225 >= n ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? n >= 35 && 135 >= n ? "down" : "up" : "vertical";
    }, e.prototype.swipeEnd = function(t) {
        var e, i, n = this;
        if (n.dragging = !1, n.interrupted = !1, n.shouldClick = !(n.touchObject.swipeLength > 10), 
        void 0 === n.touchObject.curX) return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [ n, n.swipeDirection() ]), 
        n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
              case "left":
              case "down":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(), 
                n.currentDirection = 0;
                break;

              case "right":
              case "up":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(), 
                n.currentDirection = 1;
            }
            "vertical" != i && (n.slideHandler(e), n.touchObject = {}, n.$slider.trigger("swipe", [ n, i ]));
        } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), 
        n.touchObject = {});
    }, e.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, 
        e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), 
        t.data.action) {
          case "start":
            e.swipeStart(t);
            break;

          case "move":
            e.swipeMove(t);
            break;

          case "end":
            e.swipeEnd(t);
        }
    }, e.prototype.swipeMove = function(t) {
        var e, i, n, o, s, r = this;
        return s = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !(!r.dragging || s && 1 !== s.length) && (e = r.getLeft(r.currentSlide), 
        r.touchObject.curX = void 0 !== s ? s[0].pageX : t.clientX, r.touchObject.curY = void 0 !== s ? s[0].pageY : t.clientY, 
        r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), 
        !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), 
        "vertical" !== (i = r.swipeDirection()) ? (void 0 !== t.originalEvent && r.touchObject.swipeLength > 4 && t.preventDefault(), 
        o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), 
        !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1), 
        n = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (n = r.touchObject.swipeLength * r.options.edgeFriction, 
        r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = e + n * o : r.swipeLeft = e + n * (r.$list.height() / r.listWidth) * o, 
        !0 === r.options.verticalSwiping && (r.swipeLeft = e + n * o), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, 
        !1) : void r.setCSS(r.swipeLeft))) : void 0);
    }, e.prototype.swipeStart = function(t) {
        var e, i = this;
        return i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, 
        !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), 
        i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, 
        i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, 
        void (i.dragging = !0));
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var t = this;
        null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), 
        t.$slidesCache.appendTo(t.$slideTrack), t.reinit());
    }, e.prototype.unload = function() {
        var e = this;
        t(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), 
        e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
    }, e.prototype.unslick = function(t) {
        var e = this;
        e.$slider.trigger("unslick", [ e, t ]), e.destroy();
    }, e.prototype.updateArrows = function() {
        var t = this;
        Math.floor(t.options.slidesToShow / 2), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && !t.options.infinite && (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === t.currentSlide ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), 
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), 
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), 
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
    }, e.prototype.updateDots = function() {
        var t = this;
        null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), 
        t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"));
    }, e.prototype.visibility = function() {
        var t = this;
        t.options.autoplay && (document[t.hidden] ? t.interrupted = !0 : t.interrupted = !1);
    }, t.fn.slick = function() {
        var t, i, n = this, o = arguments[0], s = Array.prototype.slice.call(arguments, 1), r = n.length;
        for (t = 0; r > t; t++) if ("object" == typeof o || void 0 === o ? n[t].slick = new e(n[t], o) : i = n[t].slick[o].apply(n[t].slick, s), 
        void 0 !== i) return i;
        return n;
    };
}), function(t, e, i, n) {
    "use strict";
    function o(t) {
        var e = t.currentTarget, n = t.data ? t.data.options : {}, o = t.data ? t.data.items : [], s = i(e).attr("data-fancybox") || "", r = 0;
        t.preventDefault(), t.stopPropagation(), s ? (r = (o = o.length ? o.filter('[data-fancybox="' + s + '"]') : i('[data-fancybox="' + s + '"]')).index(e)) < 0 && (r = 0) : o = [ e ], 
        i.fancybox.open(o, n, r);
    }
    if (i) {
        if (i.fn.fancybox) return void i.error("fancyBox already initialized");
        var s = {
            loop: !1,
            margin: [ 44, 0 ],
            gutter: 50,
            keyboard: !0,
            arrows: !0,
            infobar: !1,
            toolbar: !0,
            buttons: [ "slideShow", "fullScreen", "thumbs", "close" ],
            idleTime: 4,
            smallBtn: "auto",
            protect: !1,
            modal: !1,
            image: {
                preload: "auto"
            },
            ajax: {
                settings: {
                    data: {
                        fancybox: !0
                    }
                }
            },
            iframe: {
                tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',
                preload: !0,
                css: {},
                attr: {
                    scrolling: "auto"
                }
            },
            animationEffect: "zoom",
            animationDuration: 366,
            zoomOpacity: "auto",
            transitionEffect: "fade",
            transitionDuration: 366,
            slideClass: "",
            baseClass: "",
            baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><button data-fancybox-prev title="{{PREV}}" class="fancybox-button fancybox-button--left"></button><div class="fancybox-infobar__body"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><button data-fancybox-next title="{{NEXT}}" class="fancybox-button fancybox-button--right"></button></div><div class="fancybox-toolbar">{{BUTTONS}}</div><div class="fancybox-navigation"><button data-fancybox-prev title="{{PREV}}" class="fancybox-arrow fancybox-arrow--left" /><button data-fancybox-next title="{{NEXT}}" class="fancybox-arrow fancybox-arrow--right" /></div><div class="fancybox-stage"></div><div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div></div></div>',
            spinnerTpl: '<div class="fancybox-loading"></div>',
            errorTpl: '<div class="fancybox-error"><p>{{ERROR}}<p></div>',
            btnTpl: {
                slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"></button>',
                fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="{{FULL_SCREEN}}"></button>',
                thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"></button>',
                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"></button>',
                smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>'
            },
            parentEl: "body",
            autoFocus: !0,
            backFocus: !0,
            trapFocus: !0,
            fullScreen: {
                autoStart: !1
            },
            touch: {
                vertical: !0,
                momentum: !0
            },
            hash: null,
            media: {},
            slideShow: {
                autoStart: !1,
                speed: 4e3
            },
            thumbs: {
                autoStart: !1,
                hideOnClose: !0
            },
            onInit: i.noop,
            beforeLoad: i.noop,
            afterLoad: i.noop,
            beforeShow: i.noop,
            afterShow: i.noop,
            beforeClose: i.noop,
            afterClose: i.noop,
            onActivate: i.noop,
            onDeactivate: i.noop,
            clickContent: function(t, e) {
                return "image" === t.type && "zoom";
            },
            clickSlide: "close",
            clickOutside: "close",
            dblclickContent: !1,
            dblclickSlide: !1,
            dblclickOutside: !1,
            mobile: {
                clickContent: function(t, e) {
                    return "image" === t.type && "toggleControls";
                },
                clickSlide: function(t, e) {
                    return "image" === t.type ? "toggleControls" : "close";
                },
                dblclickContent: function(t, e) {
                    return "image" === t.type && "zoom";
                },
                dblclickSlide: function(t, e) {
                    return "image" === t.type && "zoom";
                },
                  clickOutside: "close",
                   clickSlide: "close"
            },
            lang: "en",
            i18n: {
                en: {
                    CLOSE: "Close",
                    NEXT: "Next",
                    PREV: "Previous",
                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                    PLAY_START: "Start slideshow",
                    PLAY_STOP: "Pause slideshow",
                    FULL_SCREEN: "Full screen",
                    THUMBS: "Thumbnails"
                },
                de: {
                    CLOSE: "Schliessen",
                    NEXT: "Weiter",
                    PREV: "Zurück",
                    ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                    PLAY_START: "Diaschau starten",
                    PLAY_STOP: "Diaschau beenden",
                    FULL_SCREEN: "Vollbild",
                    THUMBS: "Vorschaubilder"
                }
            }
        }, r = i(t), a = i(e), l = 0, c = t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
            return t.setTimeout(e, 1e3 / 60);
        }, d = function() {
            var t, i = e.createElement("fakeelement"), o = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for (t in o) if (i.style[t] !== n) return o[t];
        }(), u = function(t) {
            return t && t.length && t[0].offsetHeight;
        }, h = function(t, n, o) {
            var r = this;
            r.opts = i.extend(!0, {
                index: o
            }, s, n || {}), n && i.isArray(n.buttons) && (r.opts.buttons = n.buttons), r.id = r.opts.id || ++l, 
            r.group = [], r.currIndex = parseInt(r.opts.index, 10) || 0, r.prevIndex = null, 
            r.prevPos = null, r.currPos = 0, r.firstRun = null, r.createGroup(t), r.group.length && (r.$lastFocus = i(e.activeElement).blur(), 
            r.slides = {}, r.init(t));
        };
        i.extend(h.prototype, {
            init: function() {
                var t, e, n, o = this, s = o.group[o.currIndex].opts;
                o.scrollTop = a.scrollTop(), o.scrollLeft = a.scrollLeft(), i.fancybox.getInstance() || i.fancybox.isMobile || "hidden" === i("body").css("overflow") || (t = i("body").width(), 
                i("html").addClass("fancybox-enabled"), (t = i("body").width() - t) > 1 && i("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar, .fancybox-enabled body { margin-right: ' + t + "px; }</style>")), 
                n = "", i.each(s.buttons, function(t, e) {
                    n += s.btnTpl[e] || "";
                }), e = i(o.translate(o, s.baseTpl.replace("{{BUTTONS}}", n))).addClass("fancybox-is-hidden").attr("id", "fancybox-container-" + o.id).addClass(s.baseClass).data("FancyBox", o).prependTo(s.parentEl), 
                o.$refs = {
                    container: e
                }, [ "bg", "inner", "infobar", "toolbar", "stage", "caption" ].forEach(function(t) {
                    o.$refs[t] = e.find(".fancybox-" + t);
                }), (!s.arrows || o.group.length < 2) && e.find(".fancybox-navigation").remove(), 
                s.infobar || o.$refs.infobar.remove(), s.toolbar || o.$refs.toolbar.remove(), o.trigger("onInit"), 
                o.activate(), o.jumpTo(o.currIndex);
            },
            translate: function(t, e) {
                var i = t.opts.i18n[t.opts.lang];
                return e.replace(/\{\{(\w+)\}\}/g, function(t, e) {
                    var o = i[e];
                    return o === n ? t : o;
                });
            },
            createGroup: function(t) {
                var e = this, o = i.makeArray(t);
                i.each(o, function(t, o) {
                    var s, r, a, l, c = {}, d = {}, u = [];
                    i.isPlainObject(o) ? (c = o, d = o.opts || o) : "object" === i.type(o) && i(o).length ? (s = i(o), 
                    u = s.data(), d = "options" in u ? u.options : {}, d = "object" === i.type(d) ? d : {}, 
                    c.src = "src" in u ? u.src : d.src || s.attr("href"), [ "width", "height", "thumb", "type", "filter" ].forEach(function(t) {
                        t in u && (d[t] = u[t]);
                    }), "srcset" in u && (d.image = {
                        srcset: u.srcset
                    }), d.$orig = s, c.type || c.src || (c.type = "inline", c.src = o)) : c = {
                        type: "html",
                        src: o + ""
                    }, c.opts = i.extend(!0, {}, e.opts, d), i.fancybox.isMobile && (c.opts = i.extend(!0, {}, c.opts, c.opts.mobile)), 
                    r = c.type || c.opts.type, a = c.src || "", !r && a && (a.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? r = "image" : a.match(/\.(pdf)((\?|#).*)?$/i) ? r = "pdf" : "#" === a.charAt(0) && (r = "inline")), 
                    c.type = r, c.index = e.group.length, c.opts.$orig && !c.opts.$orig.length && delete c.opts.$orig, 
                    !c.opts.$thumb && c.opts.$orig && (c.opts.$thumb = c.opts.$orig.find("img:first")), 
                    c.opts.$thumb && !c.opts.$thumb.length && delete c.opts.$thumb, "function" === i.type(c.opts.caption) ? c.opts.caption = c.opts.caption.apply(o, [ e, c ]) : "caption" in u && (c.opts.caption = u.caption), 
                    c.opts.caption = c.opts.caption === n ? "" : c.opts.caption + "", "ajax" === r && ((l = a.split(/\s+/, 2)).length > 1 && (c.src = l.shift(), 
                    c.opts.filter = l.shift())), "auto" == c.opts.smallBtn && (i.inArray(r, [ "html", "inline", "ajax" ]) > -1 ? (c.opts.toolbar = !1, 
                    c.opts.smallBtn = !0) : c.opts.smallBtn = !1), "pdf" === r && (c.type = "iframe", 
                    c.opts.iframe.preload = !1), c.opts.modal && (c.opts = i.extend(!0, c.opts, {
                        infobar: 0,
                        toolbar: 0,
                        smallBtn: 0,
                        keyboard: 0,
                        slideShow: 0,
                        fullScreen: 0,
                        thumbs: 0,
                        touch: 0,
                        clickContent: !1,
                        clickSlide: !1,
                        clickOutside: !1,
                        dblclickContent: !1,
                        dblclickSlide: !1,
                        dblclickOutside: !1
                    })), e.group.push(c);
                });
            },
            addEvents: function() {
                var n = this;
                n.removeEvents(), n.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(t) {
                    t.stopPropagation(), t.preventDefault(), n.close(t);
                }).on("click.fb-prev touchend.fb-prev", "[data-fancybox-prev]", function(t) {
                    t.stopPropagation(), t.preventDefault(), n.previous();
                }).on("click.fb-next touchend.fb-next", "[data-fancybox-next]", function(t) {
                    t.stopPropagation(), t.preventDefault(), n.next();
                }), r.on("orientationchange.fb resize.fb", function(t) {
                    t && t.originalEvent && "resize" === t.originalEvent.type ? c(function() {
                        n.update();
                    }) : (n.$refs.stage.hide(), setTimeout(function() {
                        n.$refs.stage.show(), n.update();
                    }, 500));
                }), a.on("focusin.fb", function(t) {
                    var o = i.fancybox ? i.fancybox.getInstance() : null;
                    o.isClosing || !o.current || !o.current.opts.trapFocus || i(t.target).hasClass("fancybox-container") || i(t.target).is(e) || o && "fixed" !== i(t.target).css("position") && !o.$refs.container.has(t.target).length && (t.stopPropagation(), 
                    o.focus(), r.scrollTop(n.scrollTop).scrollLeft(n.scrollLeft));
                }), a.on("keydown.fb", function(t) {
                    var e = n.current, o = t.keyCode || t.which;
                    if (e && e.opts.keyboard && !i(t.target).is("input") && !i(t.target).is("textarea")) return 8 === o || 27 === o ? (t.preventDefault(), 
                    void n.close(t)) : 37 === o || 38 === o ? (t.preventDefault(), void n.previous()) : 39 === o || 40 === o ? (t.preventDefault(), 
                    void n.next()) : void n.trigger("afterKeydown", t, o);
                }), n.group[n.currIndex].opts.idleTime && (n.idleSecondsCounter = 0, a.on("mousemove.fb-idle mouseenter.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function() {
                    n.idleSecondsCounter = 0, n.isIdle && n.showControls(), n.isIdle = !1;
                }), n.idleInterval = t.setInterval(function() {
                    n.idleSecondsCounter++, n.idleSecondsCounter >= n.group[n.currIndex].opts.idleTime && (n.isIdle = !0, 
                    n.idleSecondsCounter = 0, n.hideControls());
                }, 1e3));
            },
            removeEvents: function() {
                var e = this;
                r.off("orientationchange.fb resize.fb"), a.off("focusin.fb keydown.fb .fb-idle"), 
                this.$refs.container.off(".fb-close .fb-prev .fb-next"), e.idleInterval && (t.clearInterval(e.idleInterval), 
                e.idleInterval = null);
            },
            previous: function(t) {
                return this.jumpTo(this.currPos - 1, t);
            },
            next: function(t) {
                return this.jumpTo(this.currPos + 1, t);
            },
            jumpTo: function(t, e, o) {
                var s, r, a, l, c, d, h, p = this, f = p.group.length;
                if (!(p.isSliding || p.isClosing || p.isAnimating && p.firstRun)) {
                    if (t = parseInt(t, 10), !(r = p.current ? p.current.opts.loop : p.opts.loop) && (t < 0 || t >= f)) return !1;
                    if (s = p.firstRun = null === p.firstRun, !(f < 2 && !s && p.isSliding)) {
                        if (l = p.current, p.prevIndex = p.currIndex, p.prevPos = p.currPos, a = p.createSlide(t), 
                        f > 1 && ((r || a.index > 0) && p.createSlide(t - 1), (r || a.index < f - 1) && p.createSlide(t + 1)), 
                        p.current = a, p.currIndex = a.index, p.currPos = a.pos, p.trigger("beforeShow", s), 
                        p.updateControls(), d = i.fancybox.getTranslate(a.$slide), a.isMoved = (0 !== d.left || 0 !== d.top) && !a.$slide.hasClass("fancybox-animated"), 
                        a.forcedDuration = n, i.isNumeric(e) ? a.forcedDuration = e : e = a.opts[s ? "animationDuration" : "transitionDuration"], 
                        e = parseInt(e, 10), s) return a.opts.animationEffect && e && p.$refs.container.css("transition-duration", e + "ms"), 
                        p.$refs.container.removeClass("fancybox-is-hidden"), u(p.$refs.container), p.$refs.container.addClass("fancybox-is-open"), 
                        a.$slide.addClass("fancybox-slide--current"), p.loadSlide(a), void p.preload();
                        i.each(p.slides, function(t, e) {
                            i.fancybox.stop(e.$slide);
                        }), a.$slide.removeClass("fancybox-slide--next fancybox-slide--previous").addClass("fancybox-slide--current"), 
                        a.isMoved ? (c = Math.round(a.$slide.width()), i.each(p.slides, function(t, n) {
                            var o = n.pos - a.pos;
                            i.fancybox.animate(n.$slide, {
                                top: 0,
                                left: o * c + o * n.opts.gutter
                            }, e, function() {
                                n.$slide.removeAttr("style").removeClass("fancybox-slide--next fancybox-slide--previous"), 
                                n.pos === p.currPos && (a.isMoved = !1, p.complete());
                            });
                        })) : p.$refs.stage.children().removeAttr("style"), a.isLoaded ? p.revealContent(a) : p.loadSlide(a), 
                        p.preload(), l.pos !== a.pos && (h = "fancybox-slide--" + (l.pos > a.pos ? "next" : "previous"), 
                        l.$slide.removeClass("fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous"), 
                        l.isComplete = !1, e && (a.isMoved || a.opts.transitionEffect) && (a.isMoved ? l.$slide.addClass(h) : (h = "fancybox-animated " + h + " fancybox-fx-" + a.opts.transitionEffect, 
                        i.fancybox.animate(l.$slide, h, e, function() {
                            l.$slide.removeClass(h).removeAttr("style");
                        }))));
                    }
                }
            },
            createSlide: function(t) {
                var e, n, o = this;
                return n = (n = t % o.group.length) < 0 ? o.group.length + n : n, !o.slides[t] && o.group[n] && (e = i('<div class="fancybox-slide"></div>').appendTo(o.$refs.stage), 
                o.slides[t] = i.extend(!0, {}, o.group[n], {
                    pos: t,
                    $slide: e,
                    isLoaded: !1
                }), o.updateSlide(o.slides[t])), o.slides[t];
            },
            scaleToActual: function(t, e, o) {
                var s, r, a, l, c, d = this, u = d.current, h = u.$content, p = parseInt(u.$slide.width(), 10), f = parseInt(u.$slide.height(), 10), g = u.width, m = u.height;
                "image" != u.type || u.hasError || !h || d.isAnimating || (i.fancybox.stop(h), d.isAnimating = !0, 
                t = t === n ? .5 * p : t, e = e === n ? .5 * f : e, l = g / (s = i.fancybox.getTranslate(h)).width, 
                c = m / s.height, r = .5 * p - .5 * g, a = .5 * f - .5 * m, g > p && ((r = s.left * l - (t * l - t)) > 0 && (r = 0), 
                r < p - g && (r = p - g)), m > f && ((a = s.top * c - (e * c - e)) > 0 && (a = 0), 
                a < f - m && (a = f - m)), d.updateCursor(g, m), i.fancybox.animate(h, {
                    top: a,
                    left: r,
                    scaleX: l,
                    scaleY: c
                }, o || 330, function() {
                    d.isAnimating = !1;
                }), d.SlideShow && d.SlideShow.isActive && d.SlideShow.stop());
            },
            scaleToFit: function(t) {
                var e, n = this, o = n.current, s = o.$content;
                "image" != o.type || o.hasError || !s || n.isAnimating || (i.fancybox.stop(s), n.isAnimating = !0, 
                e = n.getFitPos(o), n.updateCursor(e.width, e.height), i.fancybox.animate(s, {
                    top: e.top,
                    left: e.left,
                    scaleX: e.width / s.width(),
                    scaleY: e.height / s.height()
                }, t || 330, function() {
                    n.isAnimating = !1;
                }));
            },
            getFitPos: function(t) {
                var e, n, o, s, a, l = t.$content, c = t.width, d = t.height, u = t.opts.margin;
                return !(!l || !l.length || !c && !d) && ("number" === i.type(u) && (u = [ u, u ]), 
                2 == u.length && (u = [ u[0], u[1], u[0], u[1] ]), r.width() < 800 && (u = [ 0, 0, 0, 0 ]), 
                e = parseInt(this.$refs.stage.width(), 10) - (u[1] + u[3]), n = parseInt(this.$refs.stage.height(), 10) - (u[0] + u[2]), 
                o = Math.min(1, e / c, n / d), s = Math.floor(o * c), a = Math.floor(o * d), {
                    top: Math.floor(.5 * (n - a)) + u[0],
                    left: Math.floor(.5 * (e - s)) + u[3],
                    width: s,
                    height: a
                });
            },
            update: function() {
                var t = this;
                i.each(t.slides, function(e, i) {
                    t.updateSlide(i);
                });
            },
            updateSlide: function(t) {
                var e = this, n = t.$content;
                n && (t.width || t.height) && (i.fancybox.stop(n), i.fancybox.setTranslate(n, e.getFitPos(t)), 
                t.pos === e.currPos && e.updateCursor()), t.$slide.trigger("refresh"), e.trigger("onUpdate", t);
            },
            updateCursor: function(t, e) {
                var i = this, o = i.$refs.container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut");
                i.current && !i.isClosing && (i.isZoomable() ? (o.addClass("fancybox-is-zoomable"), 
                (t !== n && e !== n ? t < i.current.width && e < i.current.height : i.isScaledDown()) ? o.addClass("fancybox-can-zoomIn") : i.current.opts.touch ? o.addClass("fancybox-can-drag") : o.addClass("fancybox-can-zoomOut")) : i.current.opts.touch && o.addClass("fancybox-can-drag"));
            },
            isZoomable: function() {
                var t, e = this, n = e.current;
                if (n && !e.isClosing) return !!("image" === n.type && n.isLoaded && !n.hasError && ("zoom" === n.opts.clickContent || i.isFunction(n.opts.clickContent) && "zoom" === n.opts.clickContent(n)) && (t = e.getFitPos(n), 
                n.width > t.width || n.height > t.height));
            },
            isScaledDown: function() {
                var t = this.current, e = t.$content, n = !1;
                return e && (n = (n = i.fancybox.getTranslate(e)).width < t.width || n.height < t.height), 
                n;
            },
            canPan: function() {
                var t = this.current, e = t.$content, i = !1;
                return e && (i = this.getFitPos(t), i = Math.abs(e.width() - i.width) > 1 || Math.abs(e.height() - i.height) > 1), 
                i;
            },
            loadSlide: function(t) {
                var e, n, o, s = this;
                if (!t.isLoading && !t.isLoaded) {
                    switch (t.isLoading = !0, s.trigger("beforeLoad", t), e = t.type, (n = t.$slide).off("refresh").trigger("onReset").addClass("fancybox-slide--" + (e || "unknown")).addClass(t.opts.slideClass), 
                    e) {
                      case "image":
                        s.setImage(t);
                        break;

                      case "iframe":
                        s.setIframe(t);
                        break;

                      case "html":
                        s.setContent(t, t.src || t.content);
                        break;

                      case "inline":
                        i(t.src).length ? s.setContent(t, i(t.src)) : s.setError(t);
                        break;

                      case "ajax":
                        s.showLoading(t), o = i.ajax(i.extend({}, t.opts.ajax.settings, {
                            url: t.src,
                            success: function(e, i) {
                                "success" === i && s.setContent(t, e);
                            },
                            error: function(e, i) {
                                e && "abort" !== i && s.setError(t);
                            }
                        })), n.one("onReset", function() {
                            o.abort();
                        });
                        break;

                      default:
                        s.setError(t);
                    }
                    return !0;
                }
            },
            setImage: function(e) {
                var n, o, s, r, a = this, l = e.opts.image.srcset;
                if (l) {
                    s = t.devicePixelRatio || 1, r = t.innerWidth * s, (o = l.split(",").map(function(t) {
                        var e = {};
                        return t.trim().split(/\s+/).forEach(function(t, i) {
                            var n = parseInt(t.substring(0, t.length - 1), 10);
                            return 0 === i ? e.url = t : void (n && (e.value = n, e.postfix = t[t.length - 1]));
                        }), e;
                    })).sort(function(t, e) {
                        return t.value - e.value;
                    });
                    for (var c = 0; c < o.length; c++) {
                        var d = o[c];
                        if ("w" === d.postfix && d.value >= r || "x" === d.postfix && d.value >= s) {
                            n = d;
                            break;
                        }
                    }
                    !n && o.length && (n = o[o.length - 1]), n && (e.src = n.url, e.width && e.height && "w" == n.postfix && (e.height = e.width / e.height * n.value, 
                    e.width = n.value));
                }
                e.$content = i('<div class="fancybox-image-wrap"></div>').addClass("fancybox-is-hidden").appendTo(e.$slide), 
                !1 !== e.opts.preload && e.opts.width && e.opts.height && (e.opts.thumb || e.opts.$thumb) ? (e.width = e.opts.width, 
                e.height = e.opts.height, e.$ghost = i("<img />").one("error", function() {
                    i(this).remove(), e.$ghost = null, a.setBigImage(e);
                }).one("load", function() {
                    a.afterLoad(e), a.setBigImage(e);
                }).addClass("fancybox-image").appendTo(e.$content).attr("src", e.opts.thumb || e.opts.$thumb.attr("src"))) : a.setBigImage(e);
            },
            setBigImage: function(t) {
                var e = this, n = i("<img />");
                t.$image = n.one("error", function() {
                    e.setError(t);
                }).one("load", function() {
                    clearTimeout(t.timouts), t.timouts = null, e.isClosing || (t.width = this.naturalWidth, 
                    t.height = this.naturalHeight, t.opts.image.srcset && n.attr("sizes", "100vw").attr("srcset", t.opts.image.srcset), 
                    e.hideLoading(t), t.$ghost ? t.timouts = setTimeout(function() {
                        t.timouts = null, t.$ghost.hide();
                    }, Math.min(300, Math.max(1e3, t.height / 1600))) : e.afterLoad(t));
                }).addClass("fancybox-image").attr("src", t.src).appendTo(t.$content), n[0].complete ? n.trigger("load") : n[0].error ? n.trigger("error") : t.timouts = setTimeout(function() {
                    n[0].complete || t.hasError || e.showLoading(t);
                }, 100);
            },
            setIframe: function(t) {
                var e, o = this, s = t.opts.iframe, r = t.$slide;
                t.$content = i('<div class="fancybox-content' + (s.preload ? " fancybox-is-hidden" : "") + '"></div>').css(s.css).appendTo(r), 
                e = i(s.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr(s.attr).appendTo(t.$content), 
                s.preload ? (o.showLoading(t), e.on("load.fb error.fb", function(e) {
                    this.isReady = 1, t.$slide.trigger("refresh"), o.afterLoad(t);
                }), r.on("refresh.fb", function() {
                    var i, o, r, a, l = t.$content;
                    if (1 === e[0].isReady) {
                        try {
                            i = e.contents().find("body");
                        } catch (t) {}
                        i && i.length && (s.css.width === n || s.css.height === n) && (o = e[0].contentWindow.document.documentElement.scrollWidth, 
                        r = Math.ceil(i.outerWidth(!0) + (l.width() - o)), a = Math.ceil(i.outerHeight(!0)), 
                        l.css({
                            width: s.css.width === n ? r + (l.outerWidth() - l.innerWidth()) : s.css.width,
                            height: s.css.height === n ? a + (l.outerHeight() - l.innerHeight()) : s.css.height
                        })), l.removeClass("fancybox-is-hidden");
                    }
                })) : this.afterLoad(t), e.attr("src", t.src), !0 === t.opts.smallBtn && t.$content.prepend(o.translate(t, t.opts.btnTpl.smallBtn)), 
                r.one("onReset", function() {
                    try {
                        i(this).find("iframe").hide().attr("src", "//about:blank");
                    } catch (t) {}
                    i(this).empty(), t.isLoaded = !1;
                });
            },
            setContent: function(t, e) {
                var n = this;
                n.isClosing || (n.hideLoading(t), t.$slide.empty(), function(t) {
                    return t && t.hasOwnProperty && t instanceof i;
                }(e) && e.parent().length ? (e.parent(".fancybox-slide--inline").trigger("onReset"), 
                t.$placeholder = i("<div></div>").hide().insertAfter(e), e.css("display", "inline-block")) : t.hasError || ("string" === i.type(e) && (3 === (e = i("<div>").append(i.trim(e)).contents())[0].nodeType && (e = i("<div>").html(e))), 
                t.opts.filter && (e = i("<div>").html(e).find(t.opts.filter))), t.$slide.one("onReset", function() {
                    t.$placeholder && (t.$placeholder.after(e.hide()).remove(), t.$placeholder = null), 
                    t.$smallBtn && (t.$smallBtn.remove(), t.$smallBtn = null), t.hasError || (i(this).empty(), 
                    t.isLoaded = !1);
                }), t.$content = i(e).appendTo(t.$slide), t.opts.smallBtn && !t.$smallBtn && (t.$smallBtn = i(n.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)), 
                this.afterLoad(t));
            },
            setError: function(t) {
                t.hasError = !0, t.$slide.removeClass("fancybox-slide--" + t.type), this.setContent(t, this.translate(t, t.opts.errorTpl));
            },
            showLoading: function(t) {
                (t = t || this.current) && !t.$spinner && (t.$spinner = i(this.opts.spinnerTpl).appendTo(t.$slide));
            },
            hideLoading: function(t) {
                (t = t || this.current) && t.$spinner && (t.$spinner.remove(), delete t.$spinner);
            },
            afterLoad: function(t) {
                var e = this;
                e.isClosing || (t.isLoading = !1, t.isLoaded = !0, e.trigger("afterLoad", t), e.hideLoading(t), 
                t.opts.protect && t.$content && !t.hasError && (t.$content.on("contextmenu.fb", function(t) {
                    return 2 == t.button && t.preventDefault(), !0;
                }), "image" === t.type && i('<div class="fancybox-spaceball"></div>').appendTo(t.$content)), 
                e.revealContent(t));
            },
            revealContent: function(t) {
                var e, o, s, r, a, l = this, c = t.$slide, d = !1;
                return e = t.opts[l.firstRun ? "animationEffect" : "transitionEffect"], s = t.opts[l.firstRun ? "animationDuration" : "transitionDuration"], 
                s = parseInt(t.forcedDuration === n ? s : t.forcedDuration, 10), !t.isMoved && t.pos === l.currPos && s || (e = !1), 
                "zoom" !== e || t.pos === l.currPos && s && "image" === t.type && !t.hasError && (d = l.getThumbPos(t)) || (e = "fade"), 
                "zoom" === e ? ((a = l.getFitPos(t)).scaleX = Math.round(a.width / d.width * 100) / 100, 
                a.scaleY = Math.round(a.height / d.height * 100) / 100, delete a.width, delete a.height, 
                "auto" == (r = t.opts.zoomOpacity) && (r = Math.abs(t.width / t.height - d.width / d.height) > .1), 
                r && (d.opacity = .1, a.opacity = 1), i.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), d), 
                u(t.$content), void i.fancybox.animate(t.$content, a, s, function() {
                    l.complete();
                })) : (l.updateSlide(t), e ? (i.fancybox.stop(c), o = "fancybox-animated fancybox-slide--" + (t.pos > l.prevPos ? "next" : "previous") + " fancybox-fx-" + e, 
                c.removeAttr("style").removeClass("fancybox-slide--current fancybox-slide--next fancybox-slide--previous").addClass(o), 
                t.$content.removeClass("fancybox-is-hidden"), u(c), void i.fancybox.animate(c, "fancybox-slide--current", s, function(e) {
                    c.removeClass(o).removeAttr("style"), t.pos === l.currPos && l.complete();
                }, !0)) : (u(c), t.$content.removeClass("fancybox-is-hidden"), void (t.pos === l.currPos && l.complete())));
            },
            getThumbPos: function(n) {
                var o, s = !1, r = n.opts.$thumb, a = r ? r.offset() : 0;
                return a && r[0].ownerDocument === e && function(e) {
                    for (var n = e[0], o = n.getBoundingClientRect(), s = []; null !== n.parentElement; ) "hidden" !== i(n.parentElement).css("overflow") && "auto" !== i(n.parentElement).css("overflow") || s.push(n.parentElement.getBoundingClientRect()), 
                    n = n.parentElement;
                    return s.every(function(t) {
                        var e = Math.min(o.right, t.right) - Math.max(o.left, t.left), i = Math.min(o.bottom, t.bottom) - Math.max(o.top, t.top);
                        return e > 0 && i > 0;
                    }) && o.bottom > 0 && o.right > 0 && o.left < i(t).width() && o.top < i(t).height();
                }(r) && (o = this.$refs.stage.offset(), s = {
                    top: a.top - o.top + parseFloat(r.css("border-top-width") || 0),
                    left: a.left - o.left + parseFloat(r.css("border-left-width") || 0),
                    width: r.width(),
                    height: r.height(),
                    scaleX: 1,
                    scaleY: 1
                }), s;
            },
            complete: function() {
                var t = this, n = t.current, o = {};
                n.isMoved || !n.isLoaded || n.isComplete || (n.isComplete = !0, n.$slide.siblings().trigger("onReset"), 
                u(n.$slide), n.$slide.addClass("fancybox-slide--complete"), i.each(t.slides, function(e, n) {
                    n.pos >= t.currPos - 1 && n.pos <= t.currPos + 1 ? o[n.pos] = n : n && (i.fancybox.stop(n.$slide), 
                    n.$slide.unbind().remove());
                }), t.slides = o, t.updateCursor(), t.trigger("afterShow"), (i(e.activeElement).is("[disabled]") || n.opts.autoFocus && "image" != n.type && "iframe" !== n.type) && t.focus());
            },
            preload: function() {
                var t, e, i = this;
                i.group.length < 2 || (t = i.slides[i.currPos + 1], e = i.slides[i.currPos - 1], 
                t && "image" === t.type && i.loadSlide(t), e && "image" === e.type && i.loadSlide(e));
            },
            focus: function() {
                var t, e = this.current;
                this.isClosing || (t = (t = e && e.isComplete ? e.$slide.find("button,:input,[tabindex],a").filter(":not([disabled]):visible:first") : null) && t.length ? t : this.$refs.container).focus();
            },
            activate: function() {
                var t = this;
                i(".fancybox-container").each(function() {
                    var e = i(this).data("FancyBox");
                    e && e.uid !== t.uid && !e.isClosing && e.trigger("onDeactivate");
                }), t.current && (t.$refs.container.index() > 0 && t.$refs.container.prependTo(e.body), 
                t.updateControls()), t.trigger("onActivate"), t.addEvents();
            },
            close: function(t, e) {
                var n, o, s, r, a, l, u = this, h = u.current, p = function() {
                    u.cleanUp(t);
                };
                return !(u.isClosing || (u.isClosing = !0, !1 === u.trigger("beforeClose", t) ? (u.isClosing = !1, 
                c(function() {
                    u.update();
                }), 1) : (u.removeEvents(), h.timouts && clearTimeout(h.timouts), s = h.$content, 
                n = h.opts.animationEffect, o = i.isNumeric(e) ? e : n ? h.opts.animationDuration : 0, 
                h.$slide.off(d).removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"), 
                h.$slide.siblings().trigger("onReset").remove(), o && u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing"), 
                u.hideLoading(h), u.hideControls(), u.updateCursor(), "zoom" !== n || !0 !== t && s && o && "image" === h.type && !h.hasError && (l = u.getThumbPos(h)) || (n = "fade"), 
                "zoom" === n ? (i.fancybox.stop(s), a = i.fancybox.getTranslate(s), a.width = a.width * a.scaleX, 
                a.height = a.height * a.scaleY, r = h.opts.zoomOpacity, "auto" == r && (r = Math.abs(h.width / h.height - l.width / l.height) > .1), 
                r && (l.opacity = 0), a.scaleX = a.width / l.width, a.scaleY = a.height / l.height, 
                a.width = l.width, a.height = l.height, i.fancybox.setTranslate(h.$content, a), 
                i.fancybox.animate(h.$content, l, o, p), 0) : (n && o ? !0 === t ? setTimeout(p, o) : i.fancybox.animate(h.$slide.removeClass("fancybox-slide--current"), "fancybox-animated fancybox-slide--previous fancybox-fx-" + n, o, p) : p(), 
                0))));
            },
            cleanUp: function(t) {
                var e, n = this;
                n.current.$slide.trigger("onReset"), n.$refs.container.empty().remove(), n.trigger("afterClose", t), 
                n.$lastFocus && !n.current.focusBack && n.$lastFocus.focus(), n.current = null, 
                (e = i.fancybox.getInstance()) ? e.activate() : (r.scrollTop(n.scrollTop).scrollLeft(n.scrollLeft), 
                i("html").removeClass("fancybox-enabled"), i("#fancybox-style-noscroll").remove());
            },
            trigger: function(t, e) {
                var n, o = Array.prototype.slice.call(arguments, 1), s = this, r = e && e.opts ? e : s.current;
                return r ? o.unshift(r) : r = s, o.unshift(s), i.isFunction(r.opts[t]) && (n = r.opts[t].apply(r, o)), 
                !1 === n ? n : void ("afterClose" === t ? a.trigger(t + ".fb", o) : s.$refs.container.trigger(t + ".fb", o));
            },
            updateControls: function(t) {
                var e = this, n = e.current, o = n.index, s = n.opts, r = s.caption, a = e.$refs.caption;
                n.$slide.trigger("refresh"), e.$caption = r && r.length ? a.html(r) : null, e.isHiddenControls || e.showControls(), 
                i("[data-fancybox-count]").html(e.group.length), i("[data-fancybox-index]").html(o + 1), 
                i("[data-fancybox-prev]").prop("disabled", !s.loop && o <= 0), i("[data-fancybox-next]").prop("disabled", !s.loop && o >= e.group.length - 1);
            },
            hideControls: function() {
                this.isHiddenControls = !0, this.$refs.container.removeClass("fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav");
            },
            showControls: function() {
                var t = this, e = t.current ? t.current.opts : t.opts, i = t.$refs.container;
                t.isHiddenControls = !1, t.idleSecondsCounter = 0, i.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1)).toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal), 
                t.$caption ? i.addClass("fancybox-show-caption ") : i.removeClass("fancybox-show-caption");
            },
            toggleControls: function() {
                this.isHiddenControls ? this.showControls() : this.hideControls();
            }
        }), i.fancybox = {
            version: "3.1.20",
            defaults: s,
            getInstance: function(t) {
                var e = i('.fancybox-container:not(".fancybox-is-closing"):first').data("FancyBox"), n = Array.prototype.slice.call(arguments, 1);
                return e instanceof h && ("string" === i.type(t) ? e[t].apply(e, n) : "function" === i.type(t) && t.apply(e, n), 
                e);
            },
            open: function(t, e, i) {
                return new h(t, e, i);
            },
            close: function(t) {
                var e = this.getInstance();
                e && (e.close(), !0 === t && this.close());
            },
            destroy: function() {
                this.close(!0), a.off("click.fb-start");
            },
            isMobile: e.createTouch !== n && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
            use3d: function() {
                var i = e.createElement("div");
                return t.getComputedStyle && t.getComputedStyle(i).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11);
            }(),
            getTranslate: function(t) {
                var e;
                if (!t || !t.length) return !1;
                if ((e = t.eq(0).css("transform")) && -1 !== e.indexOf("matrix") ? e = (e = (e = e.split("(")[1]).split(")")[0]).split(",") : e = [], 
                e.length) e = (e = e.length > 10 ? [ e[13], e[12], e[0], e[5] ] : [ e[5], e[4], e[0], e[3] ]).map(parseFloat); else {
                    e = [ 0, 0, 1, 1 ];
                    var i = /\.*translate\((.*)px,(.*)px\)/i.exec(t.eq(0).attr("style"));
                    i && (e[0] = parseFloat(i[2]), e[1] = parseFloat(i[1]));
                }
                return {
                    top: e[0],
                    left: e[1],
                    scaleX: e[2],
                    scaleY: e[3],
                    opacity: parseFloat(t.css("opacity")),
                    width: t.width(),
                    height: t.height()
                };
            },
            setTranslate: function(t, e) {
                var i = "", o = {};
                if (t && e) return e.left === n && e.top === n || (i = (e.left === n ? t.position().left : e.left) + "px, " + (e.top === n ? t.position().top : e.top) + "px", 
                i = this.use3d ? "translate3d(" + i + ", 0px)" : "translate(" + i + ")"), e.scaleX !== n && e.scaleY !== n && (i = (i.length ? i + " " : "") + "scale(" + e.scaleX + ", " + e.scaleY + ")"), 
                i.length && (o.transform = i), e.opacity !== n && (o.opacity = e.opacity), e.width !== n && (o.width = e.width), 
                e.height !== n && (o.height = e.height), t.css(o);
            },
            animate: function(t, e, o, s, r) {
                var a = d || "transitionend";
                i.isFunction(o) && (s = o, o = null), i.isPlainObject(e) || t.removeAttr("style"), 
                t.on(a, function(o) {
                    (!o || !o.originalEvent || t.is(o.originalEvent.target) && "z-index" != o.originalEvent.propertyName) && (t.off(a), 
                    i.isPlainObject(e) ? e.scaleX !== n && e.scaleY !== n && (t.css("transition-duration", "0ms"), 
                    e.width = t.width() * e.scaleX, e.height = t.height() * e.scaleY, e.scaleX = 1, 
                    e.scaleY = 1, i.fancybox.setTranslate(t, e)) : !0 !== r && t.removeClass(e), i.isFunction(s) && s(o));
                }), i.isNumeric(o) && t.css("transition-duration", o + "ms"), i.isPlainObject(e) ? i.fancybox.setTranslate(t, e) : t.addClass(e), 
                t.data("timer", setTimeout(function() {
                    t.trigger("transitionend");
                }, o + 16));
            },
            stop: function(t) {
                clearTimeout(t.data("timer")), t.off(d);
            }
        }, i.fn.fancybox = function(t) {
            var e;
            return (e = (t = t || {}).selector || !1) ? i("body").off("click.fb-start", e).on("click.fb-start", e, {
                items: i(e),
                options: t
            }, o) : this.off("click.fb-start").on("click.fb-start", {
                items: this,
                options: t
            }, o), this;
        }, a.on("click.fb-start", "[data-fancybox]", o);
    }
}(window, document, window.jQuery), function(t) {
    "use strict";
    var e = function(e, i, n) {
        if (e) return n = n || "", "object" === t.type(n) && (n = t.param(n, !0)), t.each(i, function(t, i) {
            e = e.replace("$" + t, i || "");
        }), n.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + n), e;
    }, i = {
        youtube: {
            matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
            params: {
                autoplay: 1,
                autohide: 1,
                fs: 1,
                rel: 0,
                hd: 1,
                wmode: "transparent",
                enablejsapi: 1,
                html5: 1
            },
            paramPlace: 8,
            type: "iframe",
            url: "//www.youtube.com/embed/$4",
            thumb: "//img.youtube.com/vi/$4/hqdefault.jpg"
        },
        vimeo: {
            matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
            params: {
                autoplay: 1,
                hd: 1,
                show_title: 1,
                show_byline: 1,
                show_portrait: 0,
                fullscreen: 1,
                api: 1
            },
            paramPlace: 3,
            type: "iframe",
            url: "//player.vimeo.com/video/$2"
        },
        metacafe: {
            matcher: /metacafe.com\/watch\/(\d+)\/(.*)?/,
            type: "iframe",
            url: "//www.metacafe.com/embed/$1/?ap=1"
        },
        dailymotion: {
            matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
            params: {
                additionalInfos: 0,
                autoStart: 1
            },
            type: "iframe",
            url: "//www.dailymotion.com/embed/video/$1"
        },
        vine: {
            matcher: /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/,
            type: "iframe",
            url: "//vine.co/v/$1/embed/simple"
        },
        instagram: {
            matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
            type: "image",
            url: "//$1/p/$2/media/?size=l"
        },
        google_maps: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
            type: "iframe",
            url: function(t) {
                return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12]) + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed");
            }
        }
    };
    t(document).on("onInit.fb", function(n, o) {
        t.each(o.group, function(n, o) {
            var s, r, a, l, c, d, u, h = o.src || "", p = !1;
            o.type || (s = t.extend(!0, {}, i, o.opts.media), t.each(s, function(i, n) {
                if (a = h.match(n.matcher), d = {}, u = i, a) {
                    if (p = n.type, n.paramPlace && a[n.paramPlace]) {
                        "?" == (c = a[n.paramPlace])[0] && (c = c.substring(1)), c = c.split("&");
                        for (var s = 0; s < c.length; ++s) {
                            var f = c[s].split("=", 2);
                            2 == f.length && (d[f[0]] = decodeURIComponent(f[1].replace(/\+/g, " ")));
                        }
                    }
                    return l = t.extend(!0, {}, n.params, o.opts[i], d), h = "function" === t.type(n.url) ? n.url.call(this, a, l, o) : e(n.url, a, l), 
                    r = "function" === t.type(n.thumb) ? n.thumb.call(this, a, l, o) : e(n.thumb, a), 
                    "vimeo" === u && (h = h.replace("&%23", "#")), !1;
                }
            }), p ? (o.src = h, o.type = p, o.opts.thumb || o.opts.$thumb && o.opts.$thumb.length || (o.opts.thumb = r), 
            "iframe" === p && (t.extend(!0, o.opts, {
                iframe: {
                    preload: !1,
                    attr: {
                        scrolling: "no"
                    }
                }
            }), o.contentProvider = u, o.opts.slideClass += " fancybox-slide--" + ("google_maps" == u ? "map" : "video"))) : o.type = "image");
        });
    });
}(window.jQuery), function(t, e, i) {
    "use strict";
    var n = t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
        return t.setTimeout(e, 1e3 / 60);
    }, o = t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
        t.clearTimeout(e);
    }, s = function(e) {
        var i = [];
        for (var n in e = (e = e.originalEvent || e || t.e).touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [ e ]) e[n].pageX ? i.push({
            x: e[n].pageX,
            y: e[n].pageY
        }) : e[n].clientX && i.push({
            x: e[n].clientX,
            y: e[n].clientY
        });
        return i;
    }, r = function(t, e, i) {
        return e && t ? "x" === i ? t.x - e.x : "y" === i ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0;
    }, a = function(t) {
        if (t.is("a,button,input,select,textarea") || i.isFunction(t.get(0).onclick)) return !0;
        for (var e = 0, n = t[0].attributes, o = n.length; e < o; e++) if ("data-fancybox-" === n[e].nodeName.substr(0, 14)) return !0;
        return !1;
    }, l = function(e) {
        var i = t.getComputedStyle(e)["overflow-y"], n = t.getComputedStyle(e)["overflow-x"], o = ("scroll" === i || "auto" === i) && e.scrollHeight > e.clientHeight, s = ("scroll" === n || "auto" === n) && e.scrollWidth > e.clientWidth;
        return o || s;
    }, c = function(t) {
        for (var e = !1; !(e = l(t.get(0))) && ((t = t.parent()).length && !t.hasClass("fancybox-stage") && !t.is("body")); ) ;
        return e;
    }, d = function(t) {
        var e = this;
        e.instance = t, e.$bg = t.$refs.bg, e.$stage = t.$refs.stage, e.$container = t.$refs.container, 
        e.destroy(), e.$container.on("touchstart.fb.touch mousedown.fb.touch", i.proxy(e, "ontouchstart"));
    };
    d.prototype.destroy = function() {
        this.$container.off(".fb.touch");
    }, d.prototype.ontouchstart = function(n) {
        var o = this, l = i(n.target), d = o.instance, u = d.current, h = u.$content, p = "touchstart" == n.type;
        if (p && o.$container.off("mousedown.fb.touch"), !u || o.instance.isAnimating || o.instance.isClosing) return n.stopPropagation(), 
        void n.preventDefault();
        if ((!n.originalEvent || 2 != n.originalEvent.button) && l.length && !a(l) && !a(l.parent()) && !(n.originalEvent.clientX > l[0].clientWidth + l.offset().left) && (o.startPoints = s(n), 
        o.startPoints && !(o.startPoints.length > 1 && d.isSliding))) {
            if (o.$target = l, o.$content = h, o.canTap = !0, i(e).off(".fb.touch"), i(e).on(p ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", i.proxy(o, "ontouchend")), 
            i(e).on(p ? "touchmove.fb.touch" : "mousemove.fb.touch", i.proxy(o, "ontouchmove")), 
            n.stopPropagation(), !d.current.opts.touch && !d.canPan() || !l.is(o.$stage) && !o.$stage.find(l).length) return void (l.is("img") && n.preventDefault());
            i.fancybox.isMobile && (c(o.$target) || c(o.$target.parent())) || n.preventDefault(), 
            o.canvasWidth = Math.round(u.$slide[0].clientWidth), o.canvasHeight = Math.round(u.$slide[0].clientHeight), 
            o.startTime = new Date().getTime(), o.distanceX = o.distanceY = o.distance = 0, 
            o.isPanning = !1, o.isSwiping = !1, o.isZooming = !1, o.sliderStartPos = o.sliderLastPos || {
                top: 0,
                left: 0
            }, o.contentStartPos = i.fancybox.getTranslate(o.$content), o.contentLastPos = null, 
            1 !== o.startPoints.length || o.isZooming || (o.canTap = !d.isSliding, "image" === u.type && (o.contentStartPos.width > o.canvasWidth + 1 || o.contentStartPos.height > o.canvasHeight + 1) ? (i.fancybox.stop(o.$content), 
            o.$content.css("transition-duration", "0ms"), o.isPanning = !0) : o.isSwiping = !0, 
            o.$container.addClass("fancybox-controls--isGrabbing")), 2 !== o.startPoints.length || d.isAnimating || u.hasError || "image" !== u.type || !u.isLoaded && !u.$ghost || (o.isZooming = !0, 
            o.isSwiping = !1, o.isPanning = !1, i.fancybox.stop(o.$content), o.$content.css("transition-duration", "0ms"), 
            o.centerPointStartX = .5 * (o.startPoints[0].x + o.startPoints[1].x) - i(t).scrollLeft(), 
            o.centerPointStartY = .5 * (o.startPoints[0].y + o.startPoints[1].y) - i(t).scrollTop(), 
            o.percentageOfImageAtPinchPointX = (o.centerPointStartX - o.contentStartPos.left) / o.contentStartPos.width, 
            o.percentageOfImageAtPinchPointY = (o.centerPointStartY - o.contentStartPos.top) / o.contentStartPos.height, 
            o.startDistanceBetweenFingers = r(o.startPoints[0], o.startPoints[1]));
        }
    }, d.prototype.ontouchmove = function(t) {
        var e = this;
        if (e.newPoints = s(t), i.fancybox.isMobile && (c(e.$target) || c(e.$target.parent()))) return t.stopPropagation(), 
        void (e.canTap = !1);
        if ((e.instance.current.opts.touch || e.instance.canPan()) && e.newPoints && e.newPoints.length && (e.distanceX = r(e.newPoints[0], e.startPoints[0], "x"), 
        e.distanceY = r(e.newPoints[0], e.startPoints[0], "y"), e.distance = r(e.newPoints[0], e.startPoints[0]), 
        e.distance > 0)) {
            if (!e.$target.is(e.$stage) && !e.$stage.find(e.$target).length) return;
            t.stopPropagation(), t.preventDefault(), e.isSwiping ? e.onSwipe() : e.isPanning ? e.onPan() : e.isZooming && e.onZoom();
        }
    }, d.prototype.onSwipe = function() {
        var e, s = this, r = s.isSwiping, a = s.sliderStartPos.left || 0;
        !0 === r ? Math.abs(s.distance) > 10 && (s.canTap = !1, s.instance.group.length < 2 && s.instance.opts.touch.vertical ? s.isSwiping = "y" : s.instance.isSliding || !1 === s.instance.opts.touch.vertical || "auto" === s.instance.opts.touch.vertical && i(t).width() > 800 ? s.isSwiping = "x" : (e = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI), 
        s.isSwiping = e > 45 && e < 135 ? "y" : "x"), s.instance.isSliding = s.isSwiping, 
        s.startPoints = s.newPoints, i.each(s.instance.slides, function(t, e) {
            i.fancybox.stop(e.$slide), e.$slide.css("transition-duration", "0ms"), e.inTransition = !1, 
            e.pos === s.instance.current.pos && (s.sliderStartPos.left = i.fancybox.getTranslate(e.$slide).left);
        }), s.instance.SlideShow && s.instance.SlideShow.isActive && s.instance.SlideShow.stop()) : ("x" == r && (s.distanceX > 0 && (s.instance.group.length < 2 || 0 === s.instance.current.index && !s.instance.current.opts.loop) ? a += Math.pow(s.distanceX, .8) : s.distanceX < 0 && (s.instance.group.length < 2 || s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop) ? a -= Math.pow(-s.distanceX, .8) : a += s.distanceX), 
        s.sliderLastPos = {
            top: "x" == r ? 0 : s.sliderStartPos.top + s.distanceY,
            left: a
        }, s.requestId && (o(s.requestId), s.requestId = null), s.requestId = n(function() {
            s.sliderLastPos && (i.each(s.instance.slides, function(t, e) {
                var n = e.pos - s.instance.currPos;
                i.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left: s.sliderLastPos.left + n * s.canvasWidth + n * e.opts.gutter
                });
            }), s.$container.addClass("fancybox-is-sliding"));
        }));
    }, d.prototype.onPan = function() {
        var t, e, s, r = this;
        r.canTap = !1, t = r.contentStartPos.width > r.canvasWidth ? r.contentStartPos.left + r.distanceX : r.contentStartPos.left, 
        e = r.contentStartPos.top + r.distanceY, (s = r.limitMovement(t, e, r.contentStartPos.width, r.contentStartPos.height)).scaleX = r.contentStartPos.scaleX, 
        s.scaleY = r.contentStartPos.scaleY, r.contentLastPos = s, r.requestId && (o(r.requestId), 
        r.requestId = null), r.requestId = n(function() {
            i.fancybox.setTranslate(r.$content, r.contentLastPos);
        });
    }, d.prototype.limitMovement = function(t, e, i, n) {
        var o, s, r, a, l = this, c = l.canvasWidth, d = l.canvasHeight, u = l.contentStartPos.left, h = l.contentStartPos.top, p = l.distanceX, f = l.distanceY;
        return o = Math.max(0, .5 * c - .5 * i), s = Math.max(0, .5 * d - .5 * n), r = Math.min(c - i, .5 * c - .5 * i), 
        a = Math.min(d - n, .5 * d - .5 * n), i > c && (p > 0 && t > o && (t = o - 1 + Math.pow(-o + u + p, .8) || 0), 
        p < 0 && t < r && (t = r + 1 - Math.pow(r - u - p, .8) || 0)), n > d && (f > 0 && e > s && (e = s - 1 + Math.pow(-s + h + f, .8) || 0), 
        f < 0 && e < a && (e = a + 1 - Math.pow(a - h - f, .8) || 0)), {
            top: e,
            left: t
        };
    }, d.prototype.limitPosition = function(t, e, i, n) {
        var o = this.canvasWidth, s = this.canvasHeight;
        return i > o ? t = (t = t > 0 ? 0 : t) < o - i ? o - i : t : t = Math.max(0, o / 2 - i / 2), 
        n > s ? e = (e = e > 0 ? 0 : e) < s - n ? s - n : e : e = Math.max(0, s / 2 - n / 2), 
        {
            top: e,
            left: t
        };
    }, d.prototype.onZoom = function() {
        var e = this, s = e.contentStartPos.width, a = e.contentStartPos.height, l = e.contentStartPos.left, c = e.contentStartPos.top, d = r(e.newPoints[0], e.newPoints[1]) / e.startDistanceBetweenFingers, u = Math.floor(s * d), h = Math.floor(a * d), p = (s - u) * e.percentageOfImageAtPinchPointX, f = (a - h) * e.percentageOfImageAtPinchPointY, g = (e.newPoints[0].x + e.newPoints[1].x) / 2 - i(t).scrollLeft(), m = (e.newPoints[0].y + e.newPoints[1].y) / 2 - i(t).scrollTop(), v = g - e.centerPointStartX, y = {
            top: c + (f + (m - e.centerPointStartY)),
            left: l + (p + v),
            scaleX: e.contentStartPos.scaleX * d,
            scaleY: e.contentStartPos.scaleY * d
        };
        e.canTap = !1, e.newWidth = u, e.newHeight = h, e.contentLastPos = y, e.requestId && (o(e.requestId), 
        e.requestId = null), e.requestId = n(function() {
            i.fancybox.setTranslate(e.$content, e.contentLastPos);
        });
    }, d.prototype.ontouchend = function(t) {
        var n = this, r = Math.max(new Date().getTime() - n.startTime, 1), a = n.isSwiping, l = n.isPanning, c = n.isZooming;
        return n.endPoints = s(t), n.$container.removeClass("fancybox-controls--isGrabbing"), 
        i(e).off(".fb.touch"), n.requestId && (o(n.requestId), n.requestId = null), n.isSwiping = !1, 
        n.isPanning = !1, n.isZooming = !1, n.canTap ? n.onTap(t) : (n.speed = 366, n.velocityX = n.distanceX / r * .5, 
        n.velocityY = n.distanceY / r * .5, n.speedX = Math.max(.5 * n.speed, Math.min(1.5 * n.speed, 1 / Math.abs(n.velocityX) * n.speed)), 
        void (l ? n.endPanning() : c ? n.endZooming() : n.endSwiping(a)));
    }, d.prototype.endSwiping = function(t) {
        var e = this, n = !1;
        e.instance.isSliding = !1, e.sliderLastPos = null, "y" == t && Math.abs(e.distanceY) > 50 ? (i.fancybox.animate(e.instance.current.$slide, {
            top: e.sliderStartPos.top + e.distanceY + 150 * e.velocityY,
            opacity: 0
        }, 150), n = e.instance.close(!0, 300)) : "x" == t && e.distanceX > 50 && e.instance.group.length > 1 ? n = e.instance.previous(e.speedX) : "x" == t && e.distanceX < -50 && e.instance.group.length > 1 && (n = e.instance.next(e.speedX)), 
        !1 !== n || "x" != t && "y" != t || e.instance.jumpTo(e.instance.current.index, 150), 
        e.$container.removeClass("fancybox-is-sliding");
    }, d.prototype.endPanning = function() {
        var t, e, n, o = this;
        o.contentLastPos && (!1 === o.instance.current.opts.touch.momentum ? (t = o.contentLastPos.left, 
        e = o.contentLastPos.top) : (t = o.contentLastPos.left + o.velocityX * o.speed, 
        e = o.contentLastPos.top + o.velocityY * o.speed), (n = o.limitPosition(t, e, o.contentStartPos.width, o.contentStartPos.height)).width = o.contentStartPos.width, 
        n.height = o.contentStartPos.height, i.fancybox.animate(o.$content, n, 330));
    }, d.prototype.endZooming = function() {
        var t, e, n, o, s = this, r = s.instance.current, a = s.newWidth, l = s.newHeight;
        s.contentLastPos && (t = s.contentLastPos.left, o = {
            top: e = s.contentLastPos.top,
            left: t,
            width: a,
            height: l,
            scaleX: 1,
            scaleY: 1
        }, i.fancybox.setTranslate(s.$content, o), a < s.canvasWidth && l < s.canvasHeight ? s.instance.scaleToFit(150) : a > r.width || l > r.height ? s.instance.scaleToActual(s.centerPointStartX, s.centerPointStartY, 150) : (n = s.limitPosition(t, e, a, l), 
        i.fancybox.setTranslate(s.content, i.fancybox.getTranslate(s.$content)), i.fancybox.animate(s.$content, n, 150)));
    }, d.prototype.onTap = function(t) {
        var e, n = this, o = i(t.target), r = n.instance, a = r.current, l = t && s(t) || n.startPoints, c = l[0] ? l[0].x - n.$stage.offset().left : 0, d = l[0] ? l[0].y - n.$stage.offset().top : 0, u = function(e) {
            var o = a.opts[e];
            if (i.isFunction(o) && (o = o.apply(r, [ a, t ])), o) switch (o) {
              case "close":
                r.close(n.startEvent);
                break;

              case "toggleControls":
                r.toggleControls(!0);
                break;

              case "next":
                r.next();
                break;

              case "nextOrClose":
                r.group.length > 1 ? r.next() : r.close(n.startEvent);
                break;

              case "zoom":
                "image" == a.type && (a.isLoaded || a.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(c, d) : r.group.length < 2 && r.close(n.startEvent));
            }
        };
        if (!(t.originalEvent && 2 == t.originalEvent.button || r.isSliding || c > o[0].clientWidth + o.offset().left)) {
            if (o.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) e = "Outside"; else if (o.is(".fancybox-slide")) e = "Slide"; else {
                if (!r.current.$content || !r.current.$content.has(t.target).length) return;
                e = "Content";
            }
            if (n.tapped) {
                if (clearTimeout(n.tapped), n.tapped = null, Math.abs(c - n.tapX) > 50 || Math.abs(d - n.tapY) > 50 || r.isSliding) return this;
                u("dblclick" + e);
            } else n.tapX = c, n.tapY = d, a.opts["dblclick" + e] && a.opts["dblclick" + e] !== a.opts["click" + e] ? n.tapped = setTimeout(function() {
                n.tapped = null, u("click" + e);
            }, 300) : u("click" + e);
            return this;
        }
    }, i(e).on("onActivate.fb", function(t, e) {
        e && !e.Guestures && (e.Guestures = new d(e));
    }), i(e).on("beforeClose.fb", function(t, e) {
        e && e.Guestures && e.Guestures.destroy();
    });
}(window, document, window.jQuery), function(t, e) {
    "use strict";
    var i = function(t) {
        this.instance = t, this.init();
    };
    e.extend(i.prototype, {
        timer: null,
        isActive: !1,
        $button: null,
        speed: 3e3,
        init: function() {
            var t = this;
            t.$button = t.instance.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                t.toggle();
            }), (t.instance.group.length < 2 || !t.instance.group[t.instance.currIndex].opts.slideShow) && t.$button.hide();
        },
        set: function() {
            var t = this;
            t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) ? t.timer = setTimeout(function() {
                t.instance.next();
            }, t.instance.current.opts.slideShow.speed || t.speed) : (t.stop(), t.instance.idleSecondsCounter = 0, 
            t.instance.showControls());
        },
        clear: function() {
            clearTimeout(this.timer), this.timer = null;
        },
        start: function() {
            var t = this, e = t.instance.current;
            t.instance && e && (e.opts.loop || e.index < t.instance.group.length - 1) && (t.isActive = !0, 
            t.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_STOP).addClass("fancybox-button--pause"), 
            e.isComplete && t.set());
        },
        stop: function() {
            var t = this, e = t.instance.current;
            t.clear(), t.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_START).removeClass("fancybox-button--pause"), 
            t.isActive = !1;
        },
        toggle: function() {
            var t = this;
            t.isActive ? t.stop() : t.start();
        }
    }), e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.SlideShow && (e.SlideShow = new i(e));
        },
        "beforeShow.fb": function(t, e, i, n) {
            var o = e && e.SlideShow;
            n ? o && i.opts.slideShow.autoStart && o.start() : o && o.isActive && o.clear();
        },
        "afterShow.fb": function(t, e, i) {
            var n = e && e.SlideShow;
            n && n.isActive && n.set();
        },
        "afterKeydown.fb": function(i, n, o, s, r) {
            var a = n && n.SlideShow;
            !a || !o.opts.slideShow || 80 !== r && 32 !== r || e(t.activeElement).is("button,a,input") || (s.preventDefault(), 
            a.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function(t, e) {
            var i = e && e.SlideShow;
            i && i.stop();
        }
    }), e(t).on("visibilitychange", function() {
        var i = e.fancybox.getInstance(), n = i && i.SlideShow;
        n && n.isActive && (t.hidden ? n.clear() : n.set());
    });
}(document, window.jQuery), function(t, e) {
    "use strict";
    var i = function() {
        var e, i, n, o = [ [ "requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror" ], [ "webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror" ], [ "webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror" ], [ "mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror" ], [ "msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError" ] ], s = {};
        for (i = 0; i < o.length; i++) if ((e = o[i]) && e[1] in t) {
            for (n = 0; n < e.length; n++) s[o[0][n]] = e[n];
            return s;
        }
        return !1;
    }();
    if (i) {
        var n = {
            request: function(e) {
                (e = e || t.documentElement)[i.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
            },
            exit: function() {
                t[i.exitFullscreen]();
            },
            toggle: function(e) {
                e = e || t.documentElement, this.isFullscreen() ? this.exit() : this.request(e);
            },
            isFullscreen: function() {
                return Boolean(t[i.fullscreenElement]);
            },
            enabled: function() {
                return Boolean(t[i.fullscreenEnabled]);
            }
        };
        e(t).on({
            "onInit.fb": function(t, e) {
                var i, o = e.$refs.toolbar.find("[data-fancybox-fullscreen]");
                e && !e.FullScreen && e.group[e.currIndex].opts.fullScreen ? ((i = e.$refs.container).on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(t) {
                    t.stopPropagation(), t.preventDefault(), n.toggle(i[0]);
                }), e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && n.request(i[0]), 
                e.FullScreen = n) : o.hide();
            },
            "afterKeydown.fb": function(t, e, i, n, o) {
                e && e.FullScreen && 70 === o && (n.preventDefault(), e.FullScreen.toggle(e.$refs.container[0]));
            },
            "beforeClose.fb": function(t) {
                t && t.FullScreen && n.exit();
            }
        }), e(t).on(i.fullscreenchange, function() {
            var t = e.fancybox.getInstance();
            t.current && "image" === t.current.type && t.isAnimating && (t.current.$content.css("transition", "none"), 
            t.isAnimating = !1, t.update(!0, !0, 0));
        });
    } else e.fancybox.defaults.btnTpl.fullScreen = !1;
}(document, window.jQuery), function(t, e) {
    "use strict";
    var i = function(t) {
        this.instance = t, this.init();
    };
    e.extend(i.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: !1,
        init: function() {
            var t = this, e = t.instance.group[0], i = t.instance.group[1];
            t.$button = t.instance.$refs.toolbar.find("[data-fancybox-thumbs]"), t.instance.group.length > 1 && t.instance.group[t.instance.currIndex].opts.thumbs && ("image" == e.type || e.opts.thumb || e.opts.$thumb) && ("image" == i.type || i.opts.thumb || i.opts.$thumb) ? (t.$button.on("click", function() {
                t.toggle();
            }), t.isActive = !0) : (t.$button.hide(), t.isActive = !1);
        },
        create: function() {
            var t, i, n = this.instance;
            this.$grid = e('<div class="fancybox-thumbs"></div>').appendTo(n.$refs.container), 
            t = "<ul>", e.each(n.group, function(e, n) {
                (i = n.opts.thumb || (n.opts.$thumb ? n.opts.$thumb.attr("src") : null)) || "image" !== n.type || (i = n.src), 
                i && i.length && (t += '<li data-index="' + e + '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' + i + '" /></li>');
            }), t += "</ul>", this.$list = e(t).appendTo(this.$grid).on("click", "li", function() {
                n.jumpTo(e(this).data("index"));
            }), this.$list.find("img").hide().one("load", function() {
                var t, i, n, o, s = e(this).parent().removeClass("fancybox-thumbs-loading"), r = s.outerWidth(), a = s.outerHeight();
                t = this.naturalWidth || this.width, o = (i = this.naturalHeight || this.height) / a, 
                (n = t / r) >= 1 && o >= 1 && (n > o ? (t /= o, i = a) : (t = r, i /= n)), e(this).css({
                    width: Math.floor(t),
                    height: Math.floor(i),
                    "margin-top": Math.min(0, Math.floor(.3 * a - .3 * i)),
                    "margin-left": Math.min(0, Math.floor(.5 * r - .5 * t))
                }).show();
            }).each(function() {
                this.src = e(this).data("src");
            });
        },
        focus: function() {
            this.instance.current && this.$list.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + this.instance.current.index + '"]').addClass("fancybox-thumbs-active").focus();
        },
        close: function() {
            this.$grid.hide();
        },
        update: function() {
            this.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible), 
            this.isVisible ? (this.$grid || this.create(), this.instance.trigger("onThumbsShow"), 
            this.focus()) : this.$grid && this.instance.trigger("onThumbsHide"), this.instance.update();
        },
        hide: function() {
            this.isVisible = !1, this.update();
        },
        show: function() {
            this.isVisible = !0, this.update();
        },
        toggle: function() {
            this.isVisible = !this.isVisible, this.update();
        }
    }), e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.Thumbs && (e.Thumbs = new i(e));
        },
        "beforeShow.fb": function(t, e, i, n) {
            var o = e && e.Thumbs;
            if (o && o.isActive) {
                if (i.modal) return o.$button.hide(), void o.hide();
                n && !0 === e.opts.thumbs.autoStart && o.show(), o.isVisible && o.focus();
            }
        },
        "afterKeydown.fb": function(t, e, i, n, o) {
            var s = e && e.Thumbs;
            s && s.isActive && 71 === o && (n.preventDefault(), s.toggle());
        },
        "beforeClose.fb": function(t, e) {
            var i = e && e.Thumbs;
            i && i.isVisible && !1 !== e.opts.thumbs.hideOnClose && i.close();
        }
    });
}(document, window.jQuery), function(t, e, i) {
    "use strict";
    function n() {
        var t = e.location.hash.substr(1), i = t.split("-"), n = i.length > 1 && /^\+?\d+$/.test(i[i.length - 1]) && parseInt(i.pop(-1), 10) || 1;
        return n < 1 && (n = 1), {
            hash: t,
            index: n,
            gallery: i.join("-")
        };
    }
    function o(t) {
        var e;
        "" !== t.gallery && ((e = i("[data-fancybox='" + i.escapeSelector(t.gallery) + "']").eq(t.index - 1)).length ? e.trigger("click") : i("#" + i.escapeSelector(t.gallery)).trigger("click"));
    }
    function s(t) {
        var e;
        return !!t && ((e = t.current ? t.current.opts : t.opts).$orig ? e.$orig.data("fancybox") : e.hash || "");
    }
    i.escapeSelector || (i.escapeSelector = function(t) {
        return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(t, e) {
            return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t;
        });
    });
    var r = null, a = null;
    i(function() {
        setTimeout(function() {
            !1 !== i.fancybox.defaults.hash && (i(t).on({
                "onInit.fb": function(t, e) {
                    var i, o;
                    !1 !== e.group[e.currIndex].opts.hash && (i = n(), (o = s(e)) && i.gallery && o == i.gallery && (e.currIndex = i.index - 1));
                },
                "beforeShow.fb": function(i, n, o, l) {
                    var c;
                    !1 !== o.opts.hash && ((c = s(n)) && "" !== c && (e.location.hash.indexOf(c) < 0 && (n.opts.origHash = e.location.hash), 
                    r = c + (n.group.length > 1 ? "-" + (o.index + 1) : ""), "replaceState" in e.history ? (a && clearTimeout(a), 
                    a = setTimeout(function() {
                        e.history[l ? "pushState" : "replaceState"]({}, t.title, e.location.pathname + e.location.search + "#" + r), 
                        a = null;
                    }, 300)) : e.location.hash = r));
                },
                "beforeClose.fb": function(n, o, l) {
                    var c, d;
                    a && clearTimeout(a), !1 !== l.opts.hash && (c = s(o), d = o && o.opts.origHash ? o.opts.origHash : "", 
                    c && "" !== c && ("replaceState" in history ? e.history.replaceState({}, t.title, e.location.pathname + e.location.search + d) : (e.location.hash = d, 
                    i(e).scrollTop(o.scrollTop).scrollLeft(o.scrollLeft))), r = null);
                }
            }), i(e).on("hashchange.fb", function() {
                var t = n();
                i.fancybox.getInstance() ? !r || r === t.gallery + "-" + t.index || 1 === t.index && r == t.gallery || (r = null, 
                i.fancybox.close()) : "" !== t.gallery && o(t);
            }), i(e).one("unload.fb popstate.fb", function() {
                i.fancybox.getInstance("close", !0, 0);
            }), o(n()));
        }, 50);
    });
}(document, window, window.jQuery), function(t) {
    var e = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    t.zoom = function(e, i, n, o) {
        var s, r, a, l, c, d, u, h = t(e), p = h.css("position"), f = t(i);
        return e.style.position = /(absolute|fixed)/.test(p) ? p : "relative", e.style.overflow = "hidden", 
        n.style.width = n.style.height = "", t(n).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: n.width * o,
            height: n.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(e), {
            init: function() {
                r = h.outerWidth(), s = h.outerHeight(), i === e ? (l = r, a = s) : (l = f.outerWidth(), 
                a = f.outerHeight()), c = (n.width - r) / l, d = (n.height - s) / a, u = f.offset();
            },
            move: function(t) {
                var e = t.pageX - u.left, i = t.pageY - u.top;
                i = Math.max(Math.min(i, a), 0), e = Math.max(Math.min(e, l), 0), n.style.left = e * -c + "px", 
                n.style.top = i * -d + "px";
            }
        };
    }, t.fn.zoom = function(i) {
        return this.each(function() {
            var n = t.extend({}, e, i || {}), o = n.target && t(n.target)[0] || this, s = this, r = t(s), a = document.createElement("img"), l = t(a), c = "mousemove.zoom", d = !1, u = !1;
            if (!n.url) {
                var h = s.querySelector("img");
                if (h && (n.url = h.getAttribute("data-src") || h.currentSrc || h.src), !n.url) return;
            }
            r.one("zoom.destroy", function(t, e) {
                r.off(".zoom"), o.style.position = t, o.style.overflow = e, a.onload = null, l.remove();
            }.bind(this, o.style.position, o.style.overflow)), a.onload = function() {
                function e(e) {
                    h.init(), h.move(e), l.stop().fadeTo(t.support.opacity ? n.duration : 0, 1, !!t.isFunction(n.onZoomIn) && n.onZoomIn.call(a));
                }
                function i() {
                    l.stop().fadeTo(n.duration, 0, !!t.isFunction(n.onZoomOut) && n.onZoomOut.call(a));
                }
                var h = t.zoom(o, s, a, n.magnify);
                "grab" === n.on ? r.on("mousedown.zoom", function(n) {
                    1 === n.which && (t(document).one("mouseup.zoom", function() {
                        i(), t(document).off(c, h.move);
                    }), e(n), t(document).on(c, h.move), n.preventDefault());
                }) : "click" === n.on ? r.on("click.zoom", function(n) {
                    return d ? void 0 : (d = !0, e(n), t(document).on(c, h.move), t(document).one("click.zoom", function() {
                        i(), d = !1, t(document).off(c, h.move);
                    }), !1);
                }) : "toggle" === n.on ? r.on("click.zoom", function(t) {
                    d ? i() : e(t), d = !d;
                }) : "mouseover" === n.on && (h.init(), r.on("mouseenter.zoom", e).on("mouseleave.zoom", i).on(c, h.move)), 
                n.touch && r.on("touchstart.zoom", function(t) {
                    t.preventDefault(), u ? (u = !1, i()) : (u = !0, e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]));
                }).on("touchmove.zoom", function(t) {
                    t.preventDefault(), h.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]);
                }).on("touchend.zoom", function(t) {
                    t.preventDefault(), u && (u = !1, i());
                }), t.isFunction(n.callback) && n.callback.call(a);
            }, a.setAttribute("role", "presentation"), a.alt = "", a.src = n.url;
        });
    }, t.fn.zoom.defaults = e;
}(window.jQuery), window.Modernizr = function(t, e, i) {
    function n(t) {
        d.cssText = t;
    }
    function o(t, e) {
        return typeof t === e;
    }
    var s, r, a = {}, l = e.documentElement, c = e.createElement("modernizr"), d = c.style, u = {}, h = [], p = h.slice, f = {}.hasOwnProperty;
    for (var g in r = o(f, "undefined") || o(f.call, "undefined") ? function(t, e) {
        return e in t && o(t.constructor.prototype[e], "undefined");
    } : function(t, e) {
        return f.call(t, e);
    }, Function.prototype.bind || (Function.prototype.bind = function(t) {
        var e = this;
        if ("function" != typeof e) throw new TypeError();
        var i = p.call(arguments, 1), n = function() {
            if (this instanceof n) {
                var o = function() {};
                o.prototype = e.prototype;
                var s = new o(), r = e.apply(s, i.concat(p.call(arguments)));
                return Object(r) === r ? r : s;
            }
            return e.apply(t, i.concat(p.call(arguments)));
        };
        return n;
    }), u) r(u, g) && (s = g.toLowerCase(), a[s] = u[g](), h.push((a[s] ? "" : "no-") + s));
    return a.addTest = function(t, e) {
        if ("object" == typeof t) for (var n in t) r(t, n) && a.addTest(n, t[n]); else {
            if (t = t.toLowerCase(), a[t] !== i) return a;
            e = "function" == typeof e ? e() : e, l.className += " " + (e ? "" : "no-") + t, 
            a[t] = e;
        }
        return a;
    }, n(""), c = null, function(t, e) {
        function i() {
            var t = f.elements;
            return "string" == typeof t ? t.split(" ") : t;
        }
        function n(t) {
            var e = p[t[u]];
            return e || (e = {}, h++, t[u] = h, p[h] = e), e;
        }
        function o(t, i, o) {
            return i || (i = e), a ? i.createElement(t) : (o || (o = n(i)), (s = o.cache[t] ? o.cache[t].cloneNode() : d.test(t) ? (o.cache[t] = o.createElem(t)).cloneNode() : o.createElem(t)).canHaveChildren && !c.test(t) ? o.frag.appendChild(s) : s);
            var s;
        }
        function s(t) {
            t || (t = e);
            var s = n(t);
            return f.shivCSS && !r && !s.hasCSS && (s.hasCSS = !!function(t, e) {
                var i = t.createElement("p"), n = t.getElementsByTagName("head")[0] || t.documentElement;
                return i.innerHTML = "x<style>" + e + "</style>", n.insertBefore(i.lastChild, n.firstChild);
            }(t, "article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")), 
            a || function(t, e) {
                e.cache || (e.cache = {}, e.createElem = t.createElement, e.createFrag = t.createDocumentFragment, 
                e.frag = e.createFrag()), t.createElement = function(i) {
                    return f.shivMethods ? o(i, t, e) : e.createElem(i);
                }, t.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + i().join().replace(/\w+/g, function(t) {
                    return e.createElem(t), e.frag.createElement(t), 'c("' + t + '")';
                }) + ");return n}")(f, e.frag);
            }(t, s), t;
        }
        var r, a, l = t.html5 || {}, c = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, d = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, u = "_html5shiv", h = 0, p = {};
        !function() {
            try {
                var t = e.createElement("a");
                t.innerHTML = "<xyz></xyz>", r = "hidden" in t, a = 1 == t.childNodes.length || function() {
                    e.createElement("a");
                    var t = e.createDocumentFragment();
                    return void 0 === t.cloneNode || void 0 === t.createDocumentFragment || void 0 === t.createElement;
                }();
            } catch (t) {
                r = !0, a = !0;
            }
        }();
        var f = {
            elements: l.elements || "abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",
            shivCSS: !1 !== l.shivCSS,
            supportsUnknownElements: a,
            shivMethods: !1 !== l.shivMethods,
            type: "default",
            shivDocument: s,
            createElement: o,
            createDocumentFragment: function(t, o) {
                if (t || (t = e), a) return t.createDocumentFragment();
                for (var s = (o = o || n(t)).frag.cloneNode(), r = 0, l = i(), c = l.length; r < c; r++) s.createElement(l[r]);
                return s;
            }
        };
        t.html5 = f, s(e);
    }(this, e), a._version = "2.6.2", l.className = l.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + " js " + h.join(" "), 
    a;
}(0, this.document), function(t, e, i) {
    function n(t) {
        return "[object Function]" == m.call(t);
    }
    function o(t) {
        return "string" == typeof t;
    }
    function s() {}
    function r(t) {
        return !t || "loaded" == t || "complete" == t || "uninitialized" == t;
    }
    function a() {
        var t = v.shift();
        y = 1, t ? t.t ? f(function() {
            ("c" == t.t ? h.injectCss : h.injectJs)(t.s, 0, t.a, t.x, t.e, 1);
        }, 0) : (t(), a()) : y = 0;
    }
    function l(t, i, n, o, s, l, c) {
        function d(e) {
            if (!p && r(u.readyState) && (b.r = p = 1, !y && a(), u.onload = u.onreadystatechange = null, 
            e)) for (var n in "img" != t && f(function() {
                w.removeChild(u);
            }, 50), E[i]) E[i].hasOwnProperty(n) && E[i][n].onload();
        }
        c = c || h.errorTimeout;
        var u = e.createElement(t), p = 0, m = 0, b = {
            t: n,
            s: i,
            e: s,
            a: l,
            x: c
        };
        1 === E[i] && (m = 1, E[i] = []), "object" == t ? u.data = i : (u.src = i, u.type = t), 
        u.width = u.height = "0", u.onerror = u.onload = u.onreadystatechange = function() {
            d.call(this, m);
        }, v.splice(o, 0, b), "img" != t && (m || 2 === E[i] ? (w.insertBefore(u, S ? null : g), 
        f(d, c)) : E[i].push(u));
    }
    function c(t, e, i, n, s) {
        return y = 0, e = e || "j", o(t) ? l("c" == e ? T : _, t, e, this.i++, i, n, s) : (v.splice(this.i++, 0, t), 
        1 == v.length && a()), this;
    }
    function d() {
        var t = h;
        return t.loader = {
            load: c,
            i: 0
        }, t;
    }
    var u, h, p = e.documentElement, f = t.setTimeout, g = e.getElementsByTagName("script")[0], m = {}.toString, v = [], y = 0, b = "MozAppearance" in p.style, S = b && !!e.createRange().compareNode, w = S ? p : g.parentNode, _ = (p = t.opera && "[object Opera]" == m.call(t.opera), 
    p = !!e.attachEvent && !p, b ? "object" : p ? "script" : "img"), T = p ? "script" : _, C = Array.isArray || function(t) {
        return "[object Array]" == m.call(t);
    }, x = [], E = {}, k = {
        timeout: function(t, e) {
            return e.length && (t.timeout = e[0]), t;
        }
    };
    (h = function(t) {
        function e(t, e, o, s, r) {
            var a = function(t) {
                t = t.split("!");
                var e, i, n, o = x.length, s = t.pop(), r = t.length;
                for (s = {
                    url: s,
                    origUrl: s,
                    prefixes: t
                }, i = 0; i < r; i++) n = t[i].split("="), (e = k[n.shift()]) && (s = e(s, n));
                for (i = 0; i < o; i++) s = x[i](s);
                return s;
            }(t), l = a.autoCallback;
            a.url.split(".").pop().split("?").shift(), a.bypass || (e && (e = n(e) ? e : e[t] || e[s] || e[t.split("/").pop().split("?")[0]]), 
            a.instead ? a.instead(t, e, o, s, r) : (E[a.url] ? a.noexec = !0 : E[a.url] = 1, 
            o.load(a.url, a.forceCSS || !a.forceJS && "css" == a.url.split(".").pop().split("?").shift() ? "c" : i, a.noexec, a.attrs, a.timeout), 
            (n(e) || n(l)) && o.load(function() {
                d(), e && e(a.origUrl, r, s), l && l(a.origUrl, r, s), E[a.url] = 2;
            })));
        }
        function r(t, i) {
            function r(t, s) {
                if (t) {
                    if (o(t)) s || (u = function() {
                        var t = [].slice.call(arguments);
                        h.apply(this, t), p();
                    }), e(t, u, i, 0, c); else if (Object(t) === t) for (l in a = function() {
                        var e, i = 0;
                        for (e in t) t.hasOwnProperty(e) && i++;
                        return i;
                    }(), t) t.hasOwnProperty(l) && (!s && !--a && (n(u) ? u = function() {
                        var t = [].slice.call(arguments);
                        h.apply(this, t), p();
                    } : u[l] = function(t) {
                        return function() {
                            var e = [].slice.call(arguments);
                            t && t.apply(this, e), p();
                        };
                    }(h[l])), e(t[l], u, i, l, c));
                } else !s && p();
            }
            var a, l, c = !!t.test, d = t.load || t.both, u = t.callback || s, h = u, p = t.complete || s;
            r(c ? t.yep : t.nope, !!d), d && r(d);
        }
        var a, l, c = this.yepnope.loader;
        if (o(t)) e(t, 0, c, 0); else if (C(t)) for (a = 0; a < t.length; a++) o(l = t[a]) ? e(l, 0, c, 0) : C(l) ? h(l) : Object(l) === l && r(l, c); else Object(t) === t && r(t, c);
    }).addPrefix = function(t, e) {
        k[t] = e;
    }, h.addFilter = function(t) {
        x.push(t);
    }, h.errorTimeout = 1e4, null == e.readyState && e.addEventListener && (e.readyState = "loading", 
    e.addEventListener("DOMContentLoaded", u = function() {
        e.removeEventListener("DOMContentLoaded", u, 0), e.readyState = "complete";
    }, 0)), t.yepnope = d(), t.yepnope.executeStack = a, t.yepnope.injectJs = function(t, i, n, o, l, c) {
        var d, u, p = e.createElement("script");
        o = o || h.errorTimeout;
        for (u in p.src = t, n) p.setAttribute(u, n[u]);
        i = c ? a : i || s, p.onreadystatechange = p.onload = function() {
            !d && r(p.readyState) && (d = 1, i(), p.onload = p.onreadystatechange = null);
        }, f(function() {
            d || (d = 1, i(1));
        }, o), l ? p.onload() : g.parentNode.insertBefore(p, g);
    }, t.yepnope.injectCss = function(t, i, n, o, r, l) {
        var c;
        o = e.createElement("link"), i = l ? a : i || s;
        for (c in o.href = t, o.rel = "stylesheet", o.type = "text/css", n) o.setAttribute(c, n[c]);
        r || (g.parentNode.insertBefore(o, g), f(i, 0));
    };
}(this, document), Modernizr.load = function() {
    yepnope.apply(window, [].slice.call(arguments, 0));
}, function() {
    var t, e;
    t = this.jQuery || window.jQuery, e = t(window), t.fn.stick_in_parent = function(i) {
        var n, o, s, r, a, l, c, d, u, h, p;
        for (null == i && (i = {}), p = i.sticky_class, a = i.inner_scrolling, h = i.recalc_every, 
        u = i.parent, d = i.offset_top, c = i.spacer, o = i.bottoming, null == d && (d = 0), 
        null == u && (u = void 0), null == a && (a = !0), null == p && (p = "is_stuck"), 
        n = t(document), null == o && (o = !0), s = function(i, s, r, l, f, g, m, v) {
            var y, b, S, w, _, T, C, x, E, k, I, A;
            if (!i.data("sticky_kit")) {
                if (i.data("sticky_kit", !0), _ = n.height(), C = i.parent(), null != u && (C = C.closest(u)), 
                !C.length) throw "failed to find stick parent";
                if (y = S = !1, (I = null != c ? c && i.closest(c) : t("<div />")) && I.css("position", i.css("position")), 
                (x = function() {
                    var t, e, o;
                    if (!v && (_ = n.height(), t = parseInt(C.css("border-top-width"), 10), e = parseInt(C.css("padding-top"), 10), 
                    s = parseInt(C.css("padding-bottom"), 10), r = C.offset().top + t + e, l = C.height(), 
                    S && (y = S = !1, null == c && (i.insertAfter(I), I.detach()), i.css({
                        position: "",
                        top: "",
                        width: "",
                        bottom: ""
                    }).removeClass(p), o = !0), f = i.offset().top - (parseInt(i.css("margin-top"), 10) || 0) - d, 
                    g = i.outerHeight(!0), m = i.css("float"), I && I.css({
                        width: i.outerWidth(!0),
                        height: g,
                        display: i.css("display"),
                        "vertical-align": i.css("vertical-align"),
                        float: m
                    }), o)) return A();
                })(), g !== l) return w = void 0, T = d, k = h, A = function() {
                    var t, u, b, E;
                    if (!v && (b = !1, null != k && (0 >= --k && (k = h, x(), b = !0)), b || n.height() === _ || x(), 
                    b = e.scrollTop(), null != w && (u = b - w), w = b, S ? (o && (E = b + g + T > l + r, 
                    y && !E && (y = !1, i.css({
                        position: "fixed",
                        bottom: "",
                        top: T
                    }).trigger("sticky_kit:unbottom"))), b < f && (S = !1, T = d, null == c && ("left" !== m && "right" !== m || i.insertAfter(I), 
                    I.detach()), t = {
                        position: "",
                        width: "",
                        top: ""
                    }, i.css(t).removeClass(p).trigger("sticky_kit:unstick")), a && (t = e.height(), 
                    g + d > t && !y && (T -= u, T = Math.max(t - g, T), T = Math.min(d, T), S && i.css({
                        top: T + "px"
                    })))) : b > f && (S = !0, (t = {
                        position: "fixed",
                        top: T
                    }).width = "border-box" === i.css("box-sizing") ? i.outerWidth() + "px" : i.width() + "px", 
                    i.css(t).addClass(p), null == c && (i.after(I), "left" !== m && "right" !== m || I.append(i)), 
                    i.trigger("sticky_kit:stick")), S && o && (null == E && (E = b + g + T > l + r), 
                    !y && E))) return y = !0, "static" === C.css("position") && C.css({
                        position: "relative"
                    }), i.css({
                        position: "absolute",
                        bottom: s,
                        top: "auto"
                    }).trigger("sticky_kit:bottom");
                }, E = function() {
                    return x(), A();
                }, b = function() {
                    if (v = !0, e.off("touchmove", A), e.off("scroll", A), e.off("resize", E), t(document.body).off("sticky_kit:recalc", E), 
                    i.off("sticky_kit:detach", b), i.removeData("sticky_kit"), i.css({
                        position: "",
                        bottom: "",
                        top: "",
                        width: ""
                    }), C.position("position", ""), S) return null == c && ("left" !== m && "right" !== m || i.insertAfter(I), 
                    I.remove()), i.removeClass(p);
                }, e.on("touchmove", A), e.on("scroll", A), e.on("resize", E), t(document.body).on("sticky_kit:recalc", E), 
                i.on("sticky_kit:detach", b), setTimeout(A, 0);
            }
        }, r = 0, l = this.length; r < l; r++) i = this[r], s(t(i));
        return this;
    };
}.call(this);